<template>
  <v-flex>

    <valoraciones-detalle-dialog
      v-if="modelReserva && modelReserva.id"
      v-model="dialogValoracionesReserva"
      tipo="reserva"
      :sujeto="modelReserva"
      @valoracion-cargada="_actualizarValoracionReserva"
    />

    <v-dialog v-model="dialogBusquedaClientes" width="500" persistent>
      <v-card class="mx-auto" outlined :color="'rgb(250,250,250)'" :style="'border: 1px solid grey;'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <h5 v-bind:style="{ color: 'white' }">
              RESULTADO DE BUSQUEDA DE CLIENTES
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogBusquedaClientes = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-0">
          <v-list color="transparent" nav dense>
            <v-list-item-group :color="colorBarraFormulario">
              <template v-for="client in clientes">
                <v-list-item :key="client.id" v-if="client" @click="_selecCliente(client)">
                  <v-list-item-avatar color="success">
                    <v-avatar size="40px">
                      <v-icon class="ml-0" size="38px">mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ client.nombre }} {{ client.apellidos }} </v-list-item-title>
                    <v-list-item-subtitle>{{ client.telefono }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ client.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showConfirmacionCancelaServicio" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Confirmación para eliminar servicio
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionCancelaServicio = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <p class="text-center" style="font-size: 1.2rem;" :dark="dark">
              ¿Está seguro que desea quitar el servicio {{ servicioSeleccionado != null ? servicioSeleccionado.titulo :
                '' }}?
            </p>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarServicio()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionCancelaServicio = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogEliminarTodasEtapas" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Confirmación para eliminar todas las etapas
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showDialogEliminarTodasEtapas = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <p class="text-center" style="font-size: 1.2rem;" :dark="dark">
              ¿Está seguro que desea eliminar todas las etapas?
            </p>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="eliminarTodasEtapas()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar Todas</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showDialogEliminarTodasEtapas = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogItinerarioAMedida" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Planificar Itinerario a Medida
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showDialogItinerarioAMedida = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <p class="text-center" style="font-size: 1.2rem;" :dark="dark">
              ¿Está seguro que desea planificar un itinerario a medida?<br>
              Esto le permitirá eliminar las etapas existentes y/o crear nuevas etapas.
            </p>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_updateItinerarioAMedida(1)">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Aceptar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showDialogItinerarioAMedida = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogCambiarEstado" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Cambiar Estado
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showDialogCambiarEstado = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <p class="text-center" style="font-size: 1.2rem;" :dark="dark">
              Seleccione el nuevo estado:
            </p>
          </v-row>

          <v-row class="mt-6 mb-4" justify="center">
            <v-col cols="12">
              <v-btn v-for="estado in estados" :key="estado.id" :color="estado.color" block large class="mb-3"
                @click="_cambiarEstado(estado.id)">
                <span v-bind:style="{ color: 'black' }">{{ estado.estado }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogCambiarTrabajador" width="600" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Cambiar Trabajador Asignado
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="_cerrarDialogCambiarTrabajador">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <v-col cols="12">
              <v-select class="mt-0" label="Seleccione el trabajador" dense :dark="dark" outlined
                v-model="trabajadorSeleccionado" :items="trabajadoresOrigenUno" item-text="nombre" item-value="id"
                :loading="loadingTrabajadores" return-object>
              </v-select>
            </v-col>
          </v-row>

          <v-row class="mt-2 mb-0 mx-4" justify="center">
            <v-col cols="12">
              <v-textarea class="mt-0" label="Mensaje (Opcional)" dense :dark="dark" outlined
                v-model="mensajeTrabajador" rows="4" placeholder="Escribe un mensaje opcional...">
              </v-textarea>
            </v-col>
          </v-row>

          <v-row class="mt-2 mb-4" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_cambiarTrabajadorAsignado()"
              :disabled="!trabajadorSeleccionado">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Aceptar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="_cerrarDialogCambiarTrabajador">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogEnviarDisponibilidadATodos" width="700" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Enviar Disponibilidad a Todos
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="_cerrarDialogEnviarDisponibilidadATodos">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <v-col cols="12">
              <p class="text-center mb-4" style="font-size: 1.1rem;" :dark="dark">
                Puedes añadir una nota opcional para los alojamientos antes de enviar la solicitud.
              </p>
              <v-textarea v-model="notaAlojamientosTemporal" label="Nota para alojamientos (opcional)" outlined dense
                :dark="dark" rows="5" auto-grow autocomplete="off"
                placeholder="Escribe aquí una nota adicional para incluir en el envío..."></v-textarea>
            </v-col>
          </v-row>

          <v-row class="mt-2 mb-4" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" :disabled="enviandoDisponibilidad"
              @click="_confirmarEnviarDisponibilidadATodos()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">
                  {{ enviandoDisponibilidad ? 'Enviando...' : 'Enviar' }}
                </span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" :disabled="enviandoDisponibilidad"
              @click="_cerrarDialogEnviarDisponibilidadATodos">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="modelProveedor" v-model="dialogFormularioProveedor" width="1600px" persistent>
      <proveedor-formulario :modelProveedor="modelProveedor" :accion="'editar'"
        @cerrarFormularioProveedor="cerrarDialogProveedorItinerario" />
    </v-dialog>

    <v-dialog v-model="showDialogTarifasAlojamientoItinerario" max-width="900px" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense flat color="blue-grey darken-3" dark>
          <v-toolbar-title>
            <span>Tarifas del Proveedor</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" color="white" @click="cerrarDialogTarifasAlojamientoItinerario">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-6 mx-4">
            <v-col cols="12" md="6">
              <v-text-field :value="tarifasAlojamientoProveedorItinerario" label="Proveedor" outlined dense
                readonly></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu v-model="menuFechaTarifasAlojamientoItinerario" :close-on-content-click="false"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :value="tarifasAlojamientoFechaMostradaItinerario" label="Fecha" outlined dense readonly
                    prepend-inner-icon="mdi-calendar" v-on="on"></v-text-field>
                </template>
                <v-date-picker :value="tarifasAlojamientoFechaItinerario" color="success" locale="es"
                  first-day-of-week="1" @input="onCambiarFechaTarifasAlojamientoItinerario"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row v-if="loadingTarifasAlojamientoItinerario" class="mx-4 my-8" justify="center">
            <v-progress-linear color="blue-grey darken-3" indeterminate rounded height="6"></v-progress-linear>
          </v-row>

          <v-row v-else-if="!tarifasAlojamientoItinerario.length" class="mx-4 my-8">
            <v-col cols="12" class="text-center">
              No existen tarifas para este proveedor y esta fecha
            </v-col>
          </v-row>

          <v-row v-else class="mx-4 mb-6">
            <v-col cols="12">
              <v-data-table dense hide-default-footer :headers="headersTarifasDialogoItinerario"
                :items="tarifasAlojamientoItinerario" :items-per-page="tarifasAlojamientoItinerario.length"
                class="elevation-1 alternating-rows bordered-table">
                <template v-slot:[`item.precio`]="{ item }">
                  {{ formatearImporte(item.precio) }}
                </template>

                <template v-slot:no-data>
                  No existen tarifas para este proveedor y esta fecha
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogEnviarCorreoEtapa" max-width="800px" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense flat color="blue-grey darken-3" dark>
          <v-toolbar-title>
            <span>Enviar Correo al Proveedor</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" color="white" @click="cerrarDialogEnviarCorreoEtapa">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-6 mx-4">
            <v-select v-model="enviarCorreoEtapaDe" :items="enviarCorreoEtapaListaCorreos" label="De" outlined
              dense></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-select v-model="enviarCorreoEtapaPara" :items="enviarCorreoEtapaParaOptions" label="Para" outlined dense
              clearable no-data-text="No hay correos disponibles para este proveedor"></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field v-model="enviarCorreoEtapaCC" label="CC" outlined dense autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field v-model="enviarCorreoEtapaAsunto" label="Asunto" outlined dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-textarea v-model="enviarCorreoEtapaTexto" label="Texto del Correo" outlined dense rows="10"
              autocomplete="off"></v-textarea>
          </v-row>

          <v-row class="mx-4 mb-2 mt-8">
            <v-spacer></v-spacer>
            <v-chip class="mr-1 px-10" label color="blue-grey darken-3" text-color="white" link
              :disabled="!puedeEnviarCorreoEtapa() || loadingEnviandoCorreoEtapa" @click="enviarCorreoProveedorEtapa">
              <span v-if="loadingEnviandoCorreoEtapa" style="color: white;">Enviando...</span>
              <span v-else style="color: white;">Enviar Correo</span>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogConfirmarCambioProveedorEtapa" width="600" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title>
            <span style="color: white;">
              Confirmar cambio de alojamiento
            </span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="mt-4 mb-4">
            <v-icon color="warning darken-2" size="56">mdi-alert-outline</v-icon>
          </v-row>
          <v-row justify="center">
            <p class="text-center mb-4" style="font-size: 1.1rem;">
              Esta etapa ya está confirmada con el alojamiento
              <strong>{{ proveedorAnteriorCambioEtapa }}</strong>.
              Al cambiarlo se enviará un correo de cancelación al alojamiento.
            </p>
          </v-row>
          <v-row class="mt-4 mb-0" justify="center">
            <v-chip class="mr-4 mb-0" label color="blue-grey darken-3" :disabled="procesandoCambioProveedorEtapa"
              @click="cancelarCambioProveedorEtapa">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Volver atrás</span>
              </v-container>
            </v-chip>
            <v-chip class="mb-0" label color="blue-grey darken-3" :disabled="procesandoCambioProveedorEtapa"
              @click="confirmarCambioProveedorEtapa">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">
                  {{ procesandoCambioProveedorEtapa ? 'Continuando...' : 'Continuar' }}
                </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogItinerarioOriginal" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Cargar Itinerario Original
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showDialogItinerarioOriginal = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <p class="text-center" style="font-size: 1.2rem;" :dark="dark">
              ¿Está seguro que desea cargar el itinerario original del camino?<br>
              Esto eliminará el itinerario que haya creado y recargará las etapas originales del camino.
            </p>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_updateItinerarioAMedida(0)">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Aceptar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showDialogItinerarioOriginal = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showModalAgregarServicio" max-width="800px" persistent>
      <v-card v-if="modelReserva" :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Agregar Servicio</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="_cerrarModalAgregarServicio()">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row
            v-if="modelReserva && modelReserva.camino && modelReserva.camino.servicios && modelReserva.camino.servicios.length > 0"
            class="mt-6" dense>
            <v-col class="ml-0">
              <v-row dense class="mx-4">
                <v-select outlined dense :dark="dark" autocomplete="off" label="Seleccionar servicio"
                  v-model="servicioNuevoSeleccionado" return-object @change="_changeServicioNuevoSeleccionado"
                  :item-text="getTituloServicio" item-value="id"
                  :items="this.modelReserva.camino.servicios.filter(servicio => !servicio.esta_incluido && servicio.esta_activo)">
                </v-select>
              </v-row>

              <div v-if="servicioNuevoSeleccionado && !servicioEsNocheExtra(servicioNuevoSeleccionado)">
                <v-row v-if="esServicioDescuento(servicioNuevoSeleccionado)" dense class="mx-4">
                  <v-select v-model="servicioNuevoTipoDescuento" :items="tiposDescuento" label="Aplicar descuento a"
                    outlined dense :dark="dark"></v-select>
                </v-row>

                <v-row dense class="mx-4">
                  <v-col cols="8">
                    <v-text-field label="Descripcion" outlined dense :dark="dark" autocomplete="off"
                      v-model="servicioNuevoDescripcion"
                      @input="servicioNuevoDescripcion = $event.toUpperCase()"></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field label="Importe" outlined dense :dark="dark" autocomplete="off"
                      v-model="servicioNuevoImporte"></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense class="mx-4" justify="end">
                  <span v-bind:style="{ fontSize: '1.2rem' }">{{ servicioNuevoTituloImporteParaGuardar }}</span>
                </v-row>

                <v-row dense class="mx-4" justify="end">
                  <span>{{ servicioNuevoDescripcionParaGuardar }}</span>
                </v-row>


              </div>

              <div v-if="servicioNuevoSeleccionado && servicioEsNocheExtra(servicioNuevoSeleccionado)">
                <v-row dense class="mx-4 mb-2">
                  <v-combobox v-model="servicioNuevoLocalidad" :items="listadoPuntosFinales" label="Localidad" outlined
                    dense hide-details @input="verificarLocalidadPersonalizada"
                    hint="Seleccione o escriba una localidad" persistent-hint>
                  </v-combobox>
                </v-row>

                <v-row v-if="mostrarReferenciaLocalidad" dense class="mx-4 mb-6 mt-2">
                  <v-select v-model="servicioNuevoLocalidadReferencia" :items="listadoPuntosFinales"
                    label="Referencia. Noche extra después de:" outlined dense hide-details
                    hint="Seleccione la localidad más cercana como referencia">
                  </v-select>
                </v-row>

                <v-row v-else dense class="mx-4 mb-4"></v-row>

                <v-row dense class="mx-4">
                  <v-col cols="12" class="py-0">
                    <v-row dense>
                      <v-col cols="4">
                        <v-text-field label="Habitaciones" :value="servicioNuevoCantidadInd" type="number" min="0"
                          step="1" :max="modelReserva.cant_habitaciones_individuales || 0" outlined dense :dark="dark"
                          autocomplete="off" @input="_limitarCantidadNocheExtra('servicioNuevoCantidadInd', $event, modelReserva.cant_habitaciones_individuales)"></v-text-field>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field label="Tarifa Ind." v-model="servicioNuevoTarifaInd" inputmode="decimal"
                          outlined dense :dark="dark" autocomplete="off" @input="_normalizarTarifaNocheExtra('servicioNuevoTarifaInd', $event)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-row dense>
                      <v-col cols="4">
                        <v-text-field label="Habitaciones" :value="servicioNuevoCantidadDoble" type="number" min="0"
                          step="1" :max="_getMaximoHabitacionesDobles()" outlined dense :dark="dark" autocomplete="off"
                          @input="_limitarCantidadNocheExtra('servicioNuevoCantidadDoble', $event, _getMaximoHabitacionesDobles())"></v-text-field>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field label="Tarifa Doble" v-model="servicioNuevoTarifaDoble" inputmode="decimal"
                          outlined dense :dark="dark" autocomplete="off" @input="_normalizarTarifaNocheExtra('servicioNuevoTarifaDoble', $event)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-row dense>
                      <v-col cols="4">
                        <v-text-field label="Habitaciones" :value="servicioNuevoCantidadTriple" type="number" min="0"
                          step="1" :max="modelReserva.cant_habitaciones_triples || 0" outlined dense :dark="dark"
                          autocomplete="off" @input="_limitarCantidadNocheExtra('servicioNuevoCantidadTriple', $event, modelReserva.cant_habitaciones_triples)"></v-text-field>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field label="Tarifa Triple" v-model="servicioNuevoTarifaTriple" inputmode="decimal"
                          outlined dense :dark="dark" autocomplete="off" @input="_normalizarTarifaNocheExtra('servicioNuevoTarifaTriple', $event)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row dense class="mx-4" justify="end">
                  <span v-bind:style="{ fontSize: '1.2rem' }">{{ servicioNuevoTituloImporteParaGuardar }}</span>
                </v-row>

                <v-row dense class="mx-4" justify="end">
                  <span>{{ servicioNuevoDescripcionParaGuardar }}</span>
                </v-row>
              </div>


            </v-col>
          </v-row>
          <v-row class="mx-4 mb-2 mt-8">
            <v-spacer></v-spacer>

            <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link @click="_agregarServicio">
              <span v-bind:style="{ color: 'white' }">Agregar</span>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogEditarNocheExtra" max-width="800px" persistent>
      <v-card v-if="modelReserva" :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Editar Noche Extra</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="_cerrarDialogEditarNocheExtra()">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-6 mx-4">
            <v-col cols="12">
              <v-text-field :value="servicioNocheExtraEditando ? servicioNocheExtraEditando.titulo : ''" label="Servicio"
                outlined dense readonly hide-details></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mx-4 mt-4">
            <v-col cols="12" class="py-0">
              <v-row dense>
                <v-col cols="4">
                  <v-text-field label="Habitaciones" :value="servicioEditarNocheExtraCantidadInd" type="number"
                    min="0" step="1" :max="modelReserva.cant_habitaciones_individuales || 0" outlined dense :dark="dark"
                    autocomplete="off" @input="_limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadInd', $event, modelReserva.cant_habitaciones_individuales)"></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field label="Tarifa Ind." v-model="servicioEditarNocheExtraTarifaInd" inputmode="decimal"
                    outlined dense :dark="dark" autocomplete="off" @input="_normalizarTarifaNocheExtra('servicioEditarNocheExtraTarifaInd', $event)"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row dense>
                <v-col cols="4">
                  <v-text-field label="Habitaciones" :value="servicioEditarNocheExtraCantidadDoble" type="number"
                    min="0" step="1" :max="_getMaximoHabitacionesDobles()" outlined dense :dark="dark" autocomplete="off"
                    @input="_limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadDoble', $event, _getMaximoHabitacionesDobles())"></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field label="Tarifa Doble" v-model="servicioEditarNocheExtraTarifaDoble" inputmode="decimal"
                    outlined dense :dark="dark" autocomplete="off" @input="_normalizarTarifaNocheExtra('servicioEditarNocheExtraTarifaDoble', $event)"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row dense>
                <v-col cols="4">
                  <v-text-field label="Habitaciones" :value="servicioEditarNocheExtraCantidadTriple" type="number"
                    min="0" step="1" :max="modelReserva.cant_habitaciones_triples || 0" outlined dense :dark="dark"
                    autocomplete="off" @input="_limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadTriple', $event, modelReserva.cant_habitaciones_triples)"></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field label="Tarifa Triple" v-model="servicioEditarNocheExtraTarifaTriple" inputmode="decimal"
                    outlined dense :dark="dark" autocomplete="off" @input="_normalizarTarifaNocheExtra('servicioEditarNocheExtraTarifaTriple', $event)"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense class="mx-4 mt-4" justify="end">
            <span v-bind:style="{ fontSize: '1.2rem' }">
              • {{ servicioNocheExtraEditando ? servicioNocheExtraEditando.titulo : '' }} ..... {{ Number(_getImporteEdicionNocheExtra()).toFixed(2) }} €
            </span>
          </v-row>

          <v-row dense class="mx-4" justify="end">
            <span>{{ _getDescripcionEdicionNocheExtra() }}</span>
          </v-row>

          <v-row class="mx-4 mb-2 mt-8">
            <v-spacer></v-spacer>
            <v-chip class="mr-2 px-10" label color="blue-grey darken-3" text-color="white" link
              @click="_cerrarDialogEditarNocheExtra()">
              <span v-bind:style="{ color: 'white' }">Cancelar</span>
            </v-chip>
            <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link
              @click="_guardarEdicionNocheExtra()">
              <span v-if="loadingGuardandoEdicionNocheExtra" v-bind:style="{ color: 'white' }">Guardando...</span>
              <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogGuardarItinerarioAMedida" max-width="800px" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Guardar Itinerario a Medida</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'"
            @click="showDialogGuardarItinerarioAMedida = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-6 mx-4">
            <v-text-field label="Nombre" outlined dense :dark="dark" autocomplete="off"
              v-model="itinerarioAMedidaNombre" @input="itinerarioAMedidaNombre = $event.toUpperCase()"></v-text-field>
          </v-row>

          <v-row dense class="mt -6 mx-4">
            <v-textarea label="Descripción" outlined dense :dark="dark" autocomplete="off" rows="4"
              v-model="itinerarioAMedidaDescripcion"></v-textarea>
          </v-row>

          <v-row class="mx-4 mb-2 mt-8">
            <v-spacer></v-spacer>

            <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link
              @click="showDialogGuardarItinerarioAMedida = false">
              <span v-bind:style="{ color: 'white' }">Guardar</span>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogEnviarCorreo" max-width="800px" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Enviar Correo</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="showDialogEnviarCorreo = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-6 mx-4">
            <v-select v-model="enviarCorreoDe" :items="enviarListaCorreos" label="De" outlined dense></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field label="Para" outlined dense :dark="dark" autocomplete="off"
              v-model="enviarCorreoPara"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-select v-model="enviarCorreoCC" :items="enviarListaCorreos" label="CC" outlined dense clearable></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field label="Asunto:" outlined dense :dark="dark" autocomplete="off"
              v-model="enviarCorreoAsunto"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-textarea label="Texto del Correo" outlined dense :dark="dark" autocomplete="off" rows="10"
              v-model="enviarTextoMensaje" persistent-hint
              hint="En el texto pueden aparecer etiquetas html de formato."></v-textarea>
          </v-row>

          <v-row v-if="allowSendCuestionario" dense class="mx-4">
            <v-switch v-model="enviarCuestionario" label="Enviar Cuestionario" :color="colorAccent1" dense
              hide-details @change="_actualizarContenidoCorreoResena()">
            </v-switch>
          </v-row>

          <v-row v-if="existPresupuesto && allowSendUltimoPresupuesto" dense class="mx-4">
            <v-switch v-model="enviarUltimoPresupuesto" label="Enviar último Presupuesto generado" :color="colorAccent1"
              dense hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="existConfirmacion && allowSendUltimoConfirmacion" dense class="mx-4">
            <v-switch v-model="enviarUltimoConfirmacion" label="Enviar última Confirmación generada"
              :color="colorAccent1" dense hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="existDossier && allowSendDossier" dense class="mx-4">
            <v-switch v-model="enviarDossier" label="Enviar Dossier" :color="colorAccent1" dense hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="existUltimoBonoAlojamientos && allowSendUltimoBonoAlojamientos" dense class="mx-4">
            <v-switch v-model="enviarUltimoBonoAlojamientos" label="Enviar último Bono de Alojamientos generado"
              :color="colorAccent1" dense hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="existUltimoBonoServicios && allowSendUltimoBonoServicios" dense class="mx-4">
            <v-switch v-model="enviarUltimoBonoServicios" label="Enviar último Bono de Servicios generado"
              :color="colorAccent1" dense hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="existUltimoProforma && allowSendUltimoProforma" dense class="mx-4">
            <v-switch v-model="enviarUltimoProforma" label="Enviar última Proforma generada" :color="colorAccent1" dense
              hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="existUltimoSeguro && allowSendUltimoSeguro" dense class="mx-4">
            <v-switch v-model="enviarUltimoSeguro" label="Enviar último Seguro generado" :color="colorAccent1" dense
              hide-details></v-switch>
          </v-row>

          <v-row v-if="existTips && allowSendTips" dense class="mx-4">
            <v-switch v-model="enviarTips" label="Enviar Tips del Camino" :color="colorAccent1" dense hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="allowSendRegistroViajeros" dense class="mx-4">
            <v-switch v-model="enviarRegistroViajeros" label="Enviar Registro de Viajeros" :color="colorAccent1" dense
              hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="allowSendAutorizacionTarjeta" dense class="mx-4">
            <v-switch v-model="enviarAutorizacionTarjeta" label="Enviar Autorización cargo tarjeta de crédito"
              :color="colorAccent1" dense hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="allowSendDatosBanco" dense class="mx-4">
            <v-switch v-model="enviarDatosBanco" label="Enviar Datos Bancarios" :color="colorAccent1" dense
              hide-details>
            </v-switch>
          </v-row>

          <v-row v-if="existSeguroAnulacion && allowSendSeguroAnulacion" dense class="mx-4">
            <v-switch v-model="enviarSeguroAnulacion" label="Enviar Seguro de Anulación" :color="colorAccent1" dense
              hide-details>
            </v-switch>
          </v-row>

          <v-row class="mx-4 mb-2 mt-8">
            <v-spacer></v-spacer>
            <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link @click="_enviarCorreo()">
              <span v-if="loadingEnviandoCorreo" v-bind:style="{ color: 'white' }">Enviando...</span>
              <span v-else v-bind:style="{ color: 'white' }">Enviar Correo</span>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogEnviarDocumentoCliente" max-width="800px" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Enviar Documento al Cliente</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="_cerrarDialogEnviarDocumentoCliente">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-6 mx-4">
            <v-text-field
              :value="documentoClienteSeleccionado ? getNombreArchivo(documentoClienteSeleccionado.url_pdf) : ''"
              label="Documento" outlined dense readonly></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-select v-model="enviarDocumentoClienteDe" :items="enviarListaCorreos" label="De" outlined
              dense></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field label="Para" outlined dense :dark="dark" autocomplete="off"
              v-model="enviarDocumentoClientePara"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-select v-model="enviarDocumentoClienteCC" :items="enviarListaCorreos" label="CC" outlined
              dense></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field label="Asunto:" outlined dense :dark="dark" autocomplete="off"
              v-model="enviarDocumentoClienteAsunto"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-textarea label="Texto del Correo" outlined dense :dark="dark" autocomplete="off" rows="10"
              v-model="enviarDocumentoClienteTexto"></v-textarea>
          </v-row>

          <v-row class="mx-4 mb-2 mt-8">
            <v-spacer></v-spacer>

            <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link
              :disabled="loadingEnviandoDocumentoCliente" @click="_enviarDocumentoACliente">
              <span v-if="loadingEnviandoDocumentoCliente" v-bind:style="{ color: 'white' }">Enviando...</span>
              <span v-else v-bind:style="{ color: 'white' }">Enviar</span>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogHistorialCorreo" max-width="900">
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title>
            <span v-bind:style="{ color: 'white' }">Contenido del Correo</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="showDialogHistorialCorreo = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mx-4 mt-4 mb-2">
            <div class="historial-correo-texto" v-html="historialCorreoTexto"></div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogHistorialAdjuntos" max-width="700px">
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title>
            <span v-bind:style="{ color: 'white' }">Documentos Adjuntos</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="showDialogHistorialAdjuntos = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-list color="transparent" dense>
            <v-list-item v-for="(adjunto, index) in historialAdjuntos" :key="`${adjunto.url_documento}-${index}`"
              @click="abrirHistorialAdjuntoDocumento(adjunto)">
              <v-list-item-icon>
                <v-icon color="primary">mdi-file-pdf</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ adjunto.nombre_documento || `Documento ${index + 1}` }}</v-list-item-title>
                <v-list-item-subtitle>{{ adjunto.url_documento }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showModalAgregarPasajero" max-width="800px" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Agregar Pasajero</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
            @click="_guardarPasajero(false)">
            <span v-if="loadingGuardandoPasajero" v-bind:style="{ color: 'white' }">Guardando...</span>
            <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
          </v-chip>
          <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
            @click="_guardarPasajero(true)">
            <span v-if="loadingGuardandoPasajero" v-bind:style="{ color: 'white' }">Guardando...</span>
            <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
          </v-chip>
          <v-icon size="30" :color="'white'" @click="showModalAgregarPasajero = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>

          <v-row dense class="mt-12 mx-2 mb-4">
            <v-text-field v-model="pasajeroNuevo.nombre" class="mx-4 mb-2" label="Nombre" type="text" outlined dense
              autocomplete="off" hide-details @input="pasajeroNuevo.nombre = $event.toUpperCase()">
            </v-text-field>
          </v-row>

          <v-row dense class="mx-2 mb-4">
            <v-text-field v-model="pasajeroNuevo.primer_apellido" class="mx-4 mb-2" label="Primer Apellido" type="text"
              outlined dense autocomplete="off" hide-details
              @input="pasajeroNuevo.primer_apellido = $event.toUpperCase()">
            </v-text-field>
            <v-text-field v-model="pasajeroNuevo.segundo_apellido" class="mx-4 mb-2" label="Segundo Apellido"
              type="text" outlined dense autocomplete="off" hide-details
              @input="pasajeroNuevo.segundo_apellido = $event.toUpperCase()">
            </v-text-field>
          </v-row>

          <v-row dense class="mx-2 mb-4">
            <template v-if="_mostrarCamposCompletosPasajero()">
              <v-select v-model="pasajeroNuevo.sexo" :items="sexos" item-text="name" item-value="value" outlined dense
                hide-details class="mx-4">
              </v-select>
              <v-menu ref="menuFechaNacimiento" v-model="menuFechaNacimiento" :close-on-content-click="false"
                :return-value.sync="pasajeroNuevo.fecha_nacimiento" transition="scale-transition" offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="pasajeroNuevo.fecha_nacimiento" class="mx-4 mb-2" label="Fecha de Nacimiento"
                    prepend-icon="mdi-calendar" outlined dense hide-details placeholder="YYYY-MM-DD"
                    :rules="[validarFecha]" v-bind="attrs" v-on="on" @blur="validarYFormatearFecha">
                  </v-text-field>
                </template>
                <v-date-picker v-model="pasajeroNuevo.fecha_nacimiento" :max="new Date().toISOString().substr(0, 10)"
                  min="1900-01-01" locale="es"
                  @input="$refs.menuFechaNacimiento.save(pasajeroNuevo.fecha_nacimiento)"></v-date-picker>
              </v-menu>
            </template>
          </v-row>

          <v-row dense class="mx-2 mb-4">
            <template v-if="_mostrarCamposCompletosPasajero()">
              <v-col cols="3" class="pr-0">
                <v-select v-model="pasajeroNuevo.tipo_documento" :items="tipoDeDocumentos" item-text="name"
                  item-value="value" outlined dense hide-details class="mx-4">
                </v-select>
              </v-col>
              <v-col cols="5" class="pl-0">
                <v-text-field v-model="pasajeroNuevo.numero_documento" class="mx-4 mb-2" label="Número de Documento"
                  :error="!isValidDocument(pasajeroNuevo.tipo_documento, pasajeroNuevo.numero_documento)" type="text"
                  outlined dense autocomplete="off" hide-details
                  @input="pasajeroNuevo.numero_documento = $event.toUpperCase()">
                </v-text-field>
              </v-col>
              <v-col cols="4" class="pl-0">
                <v-text-field v-model="pasajeroNuevo.soporte_documento" class="mx-4 mb-2" label="Soporte de Documento"
                  type="text" outlined dense autocomplete="off" hide-details
                  @input="pasajeroNuevo.soporte_documento = $event.toUpperCase()">
                </v-text-field>
              </v-col>
            </template>
            <v-col v-else cols="12">
              <v-text-field v-model="pasajeroNuevo.numero_documento" class="mx-4 mb-2" label="Número de Documento"
                type="text" outlined dense autocomplete="off" hide-details
                @input="pasajeroNuevo.numero_documento = $event.toUpperCase()">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mx-2 mb-4">
            <template v-if="_mostrarCamposCompletosPasajero()">
              <v-text-field v-model="pasajeroNuevo.telefono_fijo" class="mx-4 mb-2" label="Teléfono Fijo" type="text"
                outlined dense autocomplete="off" hide-details>
              </v-text-field>
              <v-text-field v-model="pasajeroNuevo.telefono_movil" class="mx-4 mb-2" label="Teléfono Móvil" type="text"
                outlined dense autocomplete="off" hide-details>
              </v-text-field>
            </template>
            <v-text-field v-else v-model="pasajeroNuevo.telefono_movil" class="mx-4 mb-2" label="Teléfono Móvil"
              type="text" outlined dense autocomplete="off" hide-details>
            </v-text-field>
          </v-row>

          <template v-if="_mostrarCamposCompletosPasajero()">
            <v-row dense class="mx-2 mb-4">
              <v-text-field v-model="pasajeroNuevo.email" class="mx-4 mb-2" label="Email" type="text" outlined dense
                autocomplete="off" hide-details>
              </v-text-field>
            </v-row>

            <v-row dense class="mx-2 mb-4">
              <v-text-field v-model="pasajeroNuevo.direccion" class="mx-4 mb-2" label="Dirección" type="text" outlined
                dense autocomplete="off" hide-details @input="pasajeroNuevo.direccion = $event.toUpperCase()">
              </v-text-field>
            </v-row>

            <v-row dense class="mx-2 mb-4">
              <v-text-field v-model="pasajeroNuevo.poblacion" class="mx-4 mb-2" label="Población" type="text" outlined
                dense autocomplete="off" hide-details @input="pasajeroNuevo.poblacion = $event.toUpperCase()">
              </v-text-field>
              <v-select v-if="_esNacionalidadEspana(pasajeroNuevo.nacionalidad)" v-model="pasajeroNuevo.provincia"
                :items="provincias" class="mx-4 mb-2" label="Provincia" outlined dense autocomplete="off" hide-details>
              </v-select>
              <v-text-field v-else v-model="pasajeroNuevo.provincia" class="mx-4 mb-2" label="Provincia" type="text"
                outlined dense autocomplete="off" hide-details @input="pasajeroNuevo.provincia = $event.toUpperCase()">
              </v-text-field>
              <v-text-field v-model="pasajeroNuevo.codigo_postal" class="mx-4 mb-2" label="Código Postal" type="text"
                outlined dense autocomplete="off" hide-details>
              </v-text-field>
            </v-row>

            <v-row dense class="mx-2 mb-4">
              <v-select v-model="pasajeroNuevo.nacionalidad" :items="nacionalidades" class="mx-4 mb-2"
                label="Nacionalidad" outlined dense autocomplete="off" hide-details
                @change="_onNacionalidadPasajeroChange">
              </v-select>
            </v-row>

            <v-row dense class="mx-2 mb-4">
              <v-text-field v-model="pasajeroNuevo.parentesco" class="mx-4 mb-2" label="Parentesco" type="text" outlined
                dense autocomplete="off" hide-details @input="pasajeroNuevo.parentesco = $event.toUpperCase()">
              </v-text-field>
            </v-row>
          </template>


        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Formulario para crear o editar una etapa -->
    <v-dialog v-if="this.modelEtapaExtra" v-model="dialogFormularioEtapaExtra" :max-width="800" persistent>
      <etapa-extra-formulario @actualizarEtapaExtra="_actualizarEtapaExtra" :modelEtapa="this.modelEtapaExtra"
        :reserva_id="this.modelReserva.id" :fecha="this.fechaEtapaExtra" />
    </v-dialog>

    <v-dialog v-model="showModalNuevaNotaInterna" max-width="800px" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Agregar Nueva Nota Interna</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="_cerrarModalNuevaNotaInterna">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>

          <v-row dense class="mx-4 mt-12 mb-0">
            <v-textarea :rows="8" outlined v-model="nuevaNotaInterna" :dark="dark"
              label="Nueva Nota Interna"></v-textarea>
          </v-row>

          <v-row class="mx-4 mb-2">
            <v-spacer></v-spacer>

            <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link @click="_agregarNotaInterna">
              <span v-bind:style="{ color: 'white' }">Agregar</span>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card min-height="800" :color="'rgb(250, 250, 250)'" class="elevation-0 mx-4 mt-4">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-chip v-if="modelReserva && modelReserva.id != null" class="mr-4 px-2" label :color="'grey lighten-2'"
          text-color="white" link @click="modelReserva.codigo_reserva ? _irAReserva() : _irAPresupuesto()">
          <span v-bind:style="{ color: 'black' }"><b>
              << </b></span>
        </v-chip>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <h5 v-if="this.accion == 'editar'" v-bind:style="{ color: 'white' }">{{ modelReserva && modelReserva.estado ?
            (modelReserva.estado.id < 3 ? _getTipoCabecera() + ' ' + modelReserva.codigo : _getTipoCabecera() + ' ' + (modelReserva.codigo_reserva ? modelReserva.codigo_reserva : '') + ' - ' + modelReserva.codigo) : '' }}</h5>
              <h5 v-else v-bind:style="{ color: 'white' }">{{ _getTipoCabecera() }}</h5>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-chip v-if="this.accion == 'editar' && modelReserva" class="mr-4 px-10" label :color="'blue lighten-2'"
          text-color="white" link @click="_refrescarReserva()">
          <span v-bind:style="{ color: 'white' }">Refrescar</span>
        </v-chip>

        <v-chip
          v-if="this.accion == 'editar' && modelReserva && modelReserva.id"
          label
          link
          class="mr-4 px-4 font-weight-bold"
          color="amber darken-2"
          text-color="blue-grey darken-4"
          @click="dialogValoracionesReserva = true"
        >
          <v-icon left color="blue-grey darken-4">mdi-star</v-icon>
          {{ valoracionReservaTexto }}
        </v-chip>

        <v-spacer></v-spacer>

        <v-chip class="mr-2 px-10" label :color="modelReserva.estado.color" text-color="white" link
          v-if="this.modelReserva && this.modelReserva.estado" @click="_mostrarDialogCambiarEstado('RESERVA')">
          <span v-bind:style="{ color: 'black' }">{{ modelReserva.estado.estado }}</span>
        </v-chip>

        <v-chip v-if="modelReserva && modelReserva.id != null" class="mr-6 px-6" label
          v-bind:style="{ border: '2px solid ' + colorAccent1 }" text-color="black  " link
          @click="_abrirDialogCambiarTrabajador">
          <v-icon class="mr-2" size="20" :color="colorAccent1">mdi-account</v-icon>
          <span v-if="modelReserva && modelReserva.asignada_a" v-bind:style="{ color: colorAccent1 }">{{
            modelReserva.asignada_a.nombre }}</span>
          <span v-else v-bind:style="{ color: colorAccent1 }">Sin asignar</span>
        </v-chip>



        <v-chip class="mr-4 px-10" label :color="'green lighten-2'" text-color="white" link
          v-if="_activoBotonDeCrearGuardar()" @click="_guardarReserva()">

          <span v-if="loadingGuardando" v-bind:style="{ color: 'white' }"> {{ this.accion == "crear" ? "Creando" :
            "Guardando" }}...</span>
          <span v-else v-bind:style="{ color: 'white' }"> {{ this.accion == "crear" ? "Crear" : "Guardar" }}</span>
        </v-chip>


      </v-toolbar>

      <v-row v-if="loading">
        <v-spacer />
        <v-row class="mt-12">
          <v-col>
            <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
              height="6"></v-progress-linear>
          </v-col>
        </v-row>
        <v-spacer />
      </v-row>



      <v-row v-if="modelReserva && !loading" class="mx-4">
        <v-col cols="9">

          <v-container class="px-4 pt-4 pb-4">
            <v-row>
              <v-col>
                <v-tabs background-color="transparent" grow v-model="tab" :slider-size="0" :slider-color="colorAccent1"
                  @change="onTabChange">
                  <v-tab v-for="(header, index) in tabHeaders" :key="index" class="custom-tab"
                    :class="{ 'active-tab': tab === index }" v-if="!isTabDisabled(index)">
                    {{ header }}
                  </v-tab>
                  <v-tab v-if="mostrarTabApiCorreos" class="custom-tab"
                    :class="{ 'active-tab': tab === apiCorreosTabIndex }">
                    API-Correos
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <!-- Datos de la Reserva -->
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mt-4 mx-4">
                          <v-select class="mt-0 mr-0" label="Seleccione el origen" dense :dark="dark" outlined
                            v-model="modelReserva.origen" :items="origenes" item-text="nombre" item-value="id"
                            return-object @change="_changeOrigen">
                          </v-select>
                        </v-row>

                        <v-row v-if="mostrarCampoCodigoAgencia()" dense class="mx-4">
                          <v-text-field class="mt-0 mr-0 mb-10" v-model="modelReserva.codigo_agencia"
                            label="Código de la Reserva en la Agencia" dense :dark="dark" outlined autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4 mt-4">
                          <v-select class="mt-0 mr-0" :items="caminos_permitidos" label="Seleccione el camino" dense
                            :dark="dark" outlined v-model="modelReserva.camino" item-text="titulo" return-object
                            @change="_changeCamino()">
                            <template v-slot:item="{ item, on, attrs }">
                              <v-list-item v-on="on" v-bind="attrs">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <div class="d-flex align-center">
                                      <v-chip v-if="item.categoria_id > 10" small label color="blue lighten-2"
                                        text-color="white" class="mr-2 px-2">
                                        <b>M</b>
                                      </v-chip>
                                      <span :style="{ fontWeight: item.categoria_id > 10 ? 'bold' : 'normal' }">
                                        {{ item.titulo }}
                                      </span>

                                    </div>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                            <template v-slot:selection="{ item }">
                              <div class="d-flex align-center">
                                <v-chip v-if="item.categoria_id > 10" small label color="blue lighten-2"
                                  text-color="white" class="mr-2 px-2">
                                  <b>M</b>
                                </v-chip>
                                <span :style="{ fontWeight: item.categoria_id > 10 ? 'bold' : 'normal' }">
                                  {{ item.titulo }}
                                </span>
                              </div>
                            </template>
                          </v-select>
                        </v-row>

                        <v-row dense class="mt-2 mx-4">
                          <v-select class="mt-0 mr-0" label="Seleccione el idioma" dense :dark="dark" outlined
                            v-model="modelReserva.language" :items="languages" item-text="idioma" item-value="cod"
                            @change="_changeLanguage()">
                          </v-select>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col>
                            <v-menu :dark="dark" v-model="showFechaInicio" :close-on-content-click="false"
                              :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field :dark="dark" class="mr-2" clearable dense outlined
                                  :value="fechaInicioFormateada" label="Fecha de inicio"
                                  prepend-inner-icon="mdi-calendar" readonly v-on="on" hide-details
                                  :disabled="modelReserva.camino == null"
                                  @click:clear="modelReserva.fecha_inicio = null"></v-text-field>
                              </template>
                              <v-date-picker :dark="dark" color="success" locale="es"
                                v-model="modelReserva.fecha_inicio" @input="showFechaInicio = false"
                                @change="_changeFechaInicio()" first-day-of-week="1"></v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col>
                            <v-menu :dark="dark" v-model="showFechaLlegada" :close-on-content-click="false"
                              :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field class="ml-2" :dark="dark" clearable dense outlined
                                  :value="fechaLlegadaFormateada" label="Fecha de llegada"
                                  prepend-inner-icon="mdi-calendar" readonly v-on="on" hide-details
                                  :disabled="modelReserva.camino == null"
                                  @click:clear="modelReserva.fecha_llegada = null"></v-text-field>
                              </template>
                              <v-date-picker :dark="dark" color="success" locale="es"
                                v-model="modelReserva.fecha_llegada" @input="showFechaLlegada = false"
                                first-day-of-week="1" @change="_changeFechaLlegada()"></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4 mt-6">
                          <v-textarea :rows="8" outlined v-model="modelReserva.comentarios" :dark="dark"
                            label="Comentarios" @input="modelReserva.comentarios = $event.toUpperCase()"></v-textarea>
                        </v-row>



                        <v-row dense class="mx-4">
                          <v-col align="end" cols="5">
                            <span>Individuales: </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_individuales > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadHabitacionesIndividuales('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_habitaciones_individuales }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3"
                              @click="_setCantidadHabitacionesIndividuales('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col align="end" cols="5">
                            <span>Dobles (2 Ind): </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_dobles > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadHabitacionesDobles('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_habitaciones_dobles }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3" @click="_setCantidadHabitacionesDobles('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col align="end" cols="5">
                            <span>Dobles (1 Mat): </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_dobles_matrimoniales > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadHabitacionesDoblesMatrimonio('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_habitaciones_dobles_matrimoniales }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3"
                              @click="_setCantidadHabitacionesDoblesMatrimonio('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col align="end" cols="5">
                            <span> Triples: </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_triples > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadHabitacionesTriples('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_habitaciones_triples }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3"
                              @click="_setCantidadHabitacionesTriples('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4 mt-4 mb-4">
                          <v-col align="end" cols="5">
                            <span>Cantidad de Peregrinos: </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_peregrinos > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadPeregrinos('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_peregrinos }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3" @click="_setCantidadPeregrinos('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Cliente -->
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mx-2 mt-12">
                          <v-text-field v-model="modelReserva.cliente.nombre" class="mx-4 mb-2" label="Nombre"
                            type="text" outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorNombre(modelReserva.cliente.nombre)
                              " hide-details @input="modelReserva.cliente.nombre = $event.toUpperCase()">
                          </v-text-field>
                        </v-row>

                        <v-row dense class="mx-2 mt-4">
                          <v-text-field v-model="modelReserva.cliente.apellidos" class="mx-4 mb-2" label="Apellidos"
                            type="text" outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorNombre(modelReserva.cliente.apellidos)
                              " hide-details @input="modelReserva.cliente.apellidos = $event.toUpperCase()">
                          </v-text-field>
                        </v-row>

                        <v-row dense class="mx-2 mt-4">
                          <v-text-field v-model="modelReserva.cliente.telefono" class="mx-4 mb-2" label="Teléfono"
                            type="text" outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorTelefono(modelReserva.cliente.telefono)
                              " hide-details>
                          </v-text-field>
                        </v-row>

                        <v-row dense class="mx-2 mt-4">
                          <v-text-field v-model="modelReserva.cliente.email" class="mx-4 mb-2" label="Email" type="text"
                            outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorEmail(modelReserva.cliente.email)
                              " hide-details>
                          </v-text-field>
                        </v-row>

                        <!--   <v-row dense class="mx-2">
                          <v-text-field v-model="modelReserva.cliente.documento" class="mx-4 mb-2" label="Documento"
                            type="text" outlined dense :dark="dark" autocomplete="off" hide-details>
                          </v-text-field>
                        </v-row>
                        <v-row dense class="mx-2">
                          <v-textarea v-model="modelReserva.cliente.direccion" class="mx-4 mb-2"
                            label="Dirección del cliente" type="text" outlined dense :dark="dark" autocomplete="off"
                            rows="2" hide-details>
                          </v-textarea>
                        </v-row>
                        <v-row dense class="mx-2">
                          <v-textarea v-model="modelReserva.cliente.comentarios" class="mx-4 mb-2"
                            label="Observaciones del cliente" type="text" outlined dense :dark="dark"
                            autocomplete="false" rows="8" hide-details>
                          </v-textarea>
                        </v-row>
                      -->
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Servicios -->
                  <v-tab-item>
                    <v-card>
                      <v-card-text>

                        <v-row class="mt-8 mb-4 mx-4">
                          <v-spacer></v-spacer>
                          <v-chip class="mr-0 px-10" label :color="'green lighten-2'" text-color="white" link
                            @click="_showDialogAgregarServicio">
                            <span v-bind:style="{ color: 'white' }">Agregar Servicio Extra</span>
                          </v-chip>
                        </v-row>

                        <v-card v-if="modelReserva && modelReserva.servicios && modelReserva.servicios.length > 0"
                          class="mb-2 pa-0"
                          v-for="(servicio, i) in modelReserva.servicios.filter(servicio => servicio.esta_incluido == 0)"
                          :key="servicio.id" :style="'border: 2px solid black'">
                          <v-card-text>
                            <v-row class="mb-2" :dark="!dark" dense :color="'white'" flat>
                              <h3>{{ servicio.titulo }}</h3>
                              <v-divider class="mx-4" inset vertical></v-divider>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row class="mb-2" :dark="!dark" dense :color="'white'" flat>
                              <v-col cols="8">
                                <v-text-field v-model="servicio.descripcion" class="mx-4 mb-2" label="Descripción"
                                  type="text" outlined dense :dark="dark" autocomplete="off" hide-details
                                  @input="servicio.descripcion = $event.toUpperCase()">
                                </v-text-field>

                              </v-col>
                              <v-col>
                                <v-text-field v-model="servicio.importe" class="mx-4 mb-2" label="Importe" type="text"
                                  outlined dense :dark="dark" autocomplete="off" hide-details>
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row v-if="esServicioDescuento(servicio)" class="mb-2" :dark="!dark" dense
                              :color="'white'" flat>
                              <v-col cols="8">
                                <v-select :value="getTipoDescuentoServicioParaGuardar(servicio)" :items="tiposDescuento"
                                  class="mx-4 mb-2" label="Aplicar descuento a" outlined dense :dark="dark"
                                  hide-details @change="$set(servicio, 'tipo_descuento', $event)"></v-select>
                              </v-col>
                            </v-row>

                            <v-row v-if="debeMostrarFechaServicio(servicio)" class="mb-2" :dark="!dark" dense
                              :color="'white'" flat>
                              <v-col cols="6">
                                <v-menu :dark="dark" :close-on-content-click="false" transition="scale-transition"
                                  offset-y min-width="290px" :value="Boolean(servicio._showFechaServicio)"
                                  @input="value => $set(servicio, '_showFechaServicio', value)">
                                  <template v-slot:activator="{ on }">
                                    <v-text-field class="mx-4 mb-2" label="Fecha" dense outlined :dark="dark"
                                      :value="getFechaServicioMostrada(servicio)" prepend-inner-icon="mdi-calendar"
                                      readonly clearable v-on="on" hide-details
                                      @click:clear="_limpiarFechaServicio(servicio)"></v-text-field>
                                  </template>
                                  <v-date-picker :dark="dark" color="success" locale="es"
                                    :value="getFechaServicioParaPicker(servicio)"
                                    @input="valor => _onInputFechaServicio(servicio, valor)"
                                    first-day-of-week="1"></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>

                            <v-row class="mt-2 mb-0 mx-0" dense>
                              <v-spacer></v-spacer>
                              <v-chip v-if="servicioEsNocheExtra(servicio)" class="mr-2 px-2" label small
                                :color="colorAccent3" text-color="white" link
                                @click="_showDialogEditarNocheExtra(servicio)">
                                <v-icon small>mdi-pencil</v-icon>
                              </v-chip>
                              <v-chip class="mr-0 px-10" label :color="'red lighten-2'" text-color="white" link
                                @click="_showConfirmacionCancelaServicio(servicio)">
                                <span v-bind:style="{ color: 'white' }">Eliminar servicio</span>
                              </v-chip>
                            </v-row>
                          </v-card-text>
                        </v-card>



                        <v-row class="mt-8 mb-4 mx-4">
                          <v-spacer></v-spacer>
                          <v-chip
                            v-if="modelReserva && modelReserva.servicios && modelReserva.servicios.length > 0 && modelReserva.servicios.filter(servicio => servicio.esta_incluido == 0).length > 0"
                            class="mr-0 px-10" label :color="colorAccent1" text-color="white" link
                            @click="_guardarServicios">
                            <span v-if="loadingGuardandoServicios" v-bind:style="{ color: 'white' }">Guardando
                              Servicios...</span>
                            <span v-else v-bind:style="{ color: 'white' }">Guardar Servicios</span>
                          </v-chip>
                        </v-row>

                        <v-card v-if="modelReserva && modelReserva.camino" class="mt-12 mb-2 pa-0"
                          :style="'border: 1px solid grey'">
                          <v-card-text>
                            <v-row justify="center" class="mt-2">
                              <h1> Servicios Incluidos </h1>
                            </v-row>
                            <v-row class="mt-6 mb-6 mx-6">
                              <span style="text-align: start;">Si quieres cancelar alguno de los servicios incluidos,
                                puedes
                                eliminarlo.</span>
                            </v-row>

                            <v-list dense>
                              <v-list-item class="mb-1" v-for="servicio in serviciosIncluidos" :key="servicio.id">
                                <v-list-item-icon v-if="servicio.seleccionado">
                                  <v-icon color="green" style="font-size: 2rem;"
                                    @click="onCancelarServicioInc(servicio, true)">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-icon v-else>
                                  <v-icon color="red" style="font-size: 2rem;"
                                    @click="onCancelarServicioInc(servicio, false)">mdi-close-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content align="start">
                                  <v-list-item-title>
                                    <span
                                      style="font-size: 1rem; white-space: normal; word-break: break-word;  line-height: 1.4; overflow: visible;">{{
                                        getTituloServicio(servicio) }}</span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>



                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Itinerario -->
                  <v-tab-item>
                    <v-card>
                      <v-card-text>

                        <v-row justify="end" class="mt-2 mb-2 mr-0">
                          <v-chip class="px-10 mr-4" label :color="'blue lighten-2'" text-color="white" link
                            @click="_enviarDisponibilidadATodos()">
                            <span v-bind:style="{ color: 'white' }"> {{ enviandoDisponibilidad ? 'Enviando...' : 'Enviar Disponibilidad a Todos' }} </span>
                          </v-chip>
                          <v-chip v-if="modelReserva.itinerario_a_medida" class="px-10 mr-4" label
                            :color="'red lighten-2'" text-color="white" link
                            @click="showDialogEliminarTodasEtapas = true">
                            <span v-if="loadingEliminandoTodasEtapas" v-bind:style="{ color: 'white' }">Eliminando
                              Etapas...</span>
                            <span v-else v-bind:style="{ color: 'white' }">Eliminar Todas las Etapas</span>
                          </v-chip>
                          <v-chip v-if="modelReserva.itinerario_a_medida" class="px-10" label :color="'green lighten-2'"
                            text-color="white" link @click="showDialogItinerarioOriginal = true">
                            <span v-bind:style="{ color: 'white' }">Cargar Itinerario Original</span>
                          </v-chip>
                          <v-chip v-if="!modelReserva.itinerario_a_medida" class="px-10" label
                            :color="'green lighten-2'" text-color="white" link
                            @click="showDialogItinerarioAMedida = true">
                            <span v-bind:style="{ color: 'white' }">Planificar Itinerario a Medida</span>
                          </v-chip>
                        </v-row>

                        <v-row justify="end" class="mt-2 mb-2 mr-0">
                          <v-chip
                            v-if="modelReserva.itinerario_a_medida && modelReserva.etapas && modelReserva.etapas.length == 0"
                            class="px-10" label :color="'green lighten-2'" text-color="white" link
                            @click="_agregarEtapa(modelReserva.fecha_inicio)">
                            <span v-bind:style="{ color: 'white' }">Agregar Etapa</span>
                            <v-icon color="white" size="small" class="ml-2">mdi-arrow-down</v-icon>
                          </v-chip>
                        </v-row>

                        <v-card v-if="modelReserva && modelReserva.etapas && modelReserva.etapas.length > 0"
                          class="mb-1" v-for="(etapa, i) in modelReserva.etapas" :key="etapa.fecha"
                          :style="'border: 2px solid black'">
                          <v-card-text>
                            <v-row justify="end" class="mb-2 mr-0">
                              <v-menu v-if="mostrarAccionesMenuEtapa(etapa)" bottom left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small outlined v-bind="attrs" v-on="on"
                                    style="min-width: 34px; width: 34px; height: 34px; padding: 0; border-radius: 8px; border-color: white;">
                                    <v-icon small>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>
                                <v-list dense>
                                  <v-list-item v-for="accion in getAccionesMenuEtapa(etapa)" :key="accion.key"
                                    @click="onAccionMenuEtapa(etapa, accion.key)">
                                    <v-list-item-title>{{ accion.label }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-row>
                            <v-row class="mb-2" :dark="!dark" dense :color="'white'" flat>
                              <v-chip class="mr-1 py-3" label small :color="_getColorEstadoEtapa(etapa)" link
                                @click="_mostrarDialogCambiarEstado('ETAPA', etapa.pivot.id)"
                                :style="'border: 3px solid grey'">
                                <h3 :style="{ color: 'black' }"> {{ formatearFechaSinHora(etapa.pivot.fecha) }}
                                </h3>
                              </v-chip>
                              <v-divider class="mx-2" inset vertical></v-divider>
                              <h3>{{ 'Día ' + (i + 1) }}</h3>
                              <v-divider class="mx-2" inset vertical></v-divider>
                              <v-tooltip v-if="etapa.pivot.comentario" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-chip class="py-3" label small :color="'blue lighten-2'"
                                    :style="'border: 3px solid grey'" v-bind="attrs" v-on="on">
                                    <span :style="{ color: 'black' }"> Comentario</span>
                                  </v-chip>
                                </template>
                                <div class="tooltip-content">
                                  {{ etapa.pivot.comentario }}
                                </div>
                              </v-tooltip>
                              <v-spacer></v-spacer>
                              <span class="mr-2" v-if="etapa.pivot.modificacion">{{ etapa.pivot.modificacion }}</span>
                              <v-chip v-if="etapa.pivot.proveedor_id" class="px-3 mr-2" label
                                :color="etapaEnviadaOConfirmada(etapa) ? '#555555' : 'blue lighten-2'"
                                text-color="white" :link="!etapaEnviadaOConfirmada(etapa)"
                                :disabled="etapaEnviadaOConfirmada(etapa)"
                                @click="!etapaEnviadaOConfirmada(etapa) && _solicitarDisponibilidad(etapa)">
                                <span v-bind:style="{ color: 'white' }">
                                  {{ etapaEnviadaOConfirmada(etapa) ? 'Enviada' : enviandoDisponibilidad ? 'Enviando...'
                                    :
                                    'Solicitar' }}
                                </span>
                              </v-chip>
                            </v-row>

                            <v-row dense>
                              <v-col>
                                <h3>{{ etapa.pivot.descripcion }}</h3>
                                <v-text-field class="mr-10 mt-2" v-model="etapa.pivot.nota_extra" outlined dense
                                  :dark="dark" autocomplete="off" label="Nota" hide-details
                                  @blur="actualizarNotaEtapa(etapa)"
                                  @keyup.enter="actualizarNotaEtapa(etapa)"></v-text-field>

                                <v-row v-if="etapa.pivot.proveedor_id" dense class="mr-10 mt-4">
                                  <v-col cols="12" md="6" class="pl-0 pr-md-2">
                                    <v-combobox outlined dense :dark="dark" autocomplete="off"
                                      v-model="etapa.pivot.modalidad_pago" label="Modalidad de Pago"
                                      :items="modalidadesPagoItems" hide-details @blur="actualizarNotaEtapa(etapa)"
                                      @change="actualizarNotaEtapa(etapa)"></v-combobox>
                                  </v-col>

                                  <v-col cols="12" md="6" class="pr-0 pl-md-2">
                                    <v-text-field v-if="etapa.pivot.modalidad_pago === 'Prepago'" outlined dense
                                      :dark="dark" autocomplete="off" v-model.number="etapa.pivot.prepago_dias"
                                      label="Prepago Días" type="number" min="0" hide-details
                                      @blur="actualizarNotaEtapa(etapa)"
                                      @keyup.enter="actualizarNotaEtapa(etapa)"></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row v-if="etapa.pivot.proveedor_id" dense class="mr-10 mt-1">
                                  <v-col cols="12" md="6" class="pl-0 pr-md-2">
                                    <v-select v-if="etapa.pivot.modalidad_pago === 'Prepago'" outlined dense
                                      :dark="dark" autocomplete="off" v-model="etapa.pivot.prepago_tipo_dias"
                                      label="Tipo de Días" :items="prepagoTipoDiasItems" hide-details
                                      @change="actualizarNotaEtapa(etapa)">
                                    </v-select>
                                  </v-col>

                                  <v-col cols="12" md="6" class="pr-0 pl-md-2">
                                    <v-text-field v-if="etapa.pivot.modalidad_pago === 'Prepago'" outlined dense
                                      :dark="dark" autocomplete="off" v-model="etapa.pivot.prepago_fecha_aviso"
                                      label="Fecha Aviso Prepago" type="date" hide-details
                                      @blur="actualizarNotaEtapa(etapa)"
                                      @change="actualizarNotaEtapa(etapa)"></v-text-field>
                                  </v-col>
                                </v-row>

                              </v-col>

                              <v-divider class="mx-4" inset vertical></v-divider>

                              <v-col>
                                <v-row>
                                  <v-spacer></v-spacer>

                                </v-row>
                                <v-switch
                                  v-if="modelReserva.etapas && modelReserva.etapas.length > 1 && i !== modelReserva.etapas.length - 1"
                                  class="mt-2 mb-1 pt-0" :input-value="getMostrarTodosLosProveedoresEtapa(etapa)"
                                  :color="colorAccent1" dense hide-details inset label="Mostrar todos los alojamientos"
                                  @change="onCambiarMostrarTodosLosProveedoresEtapa(etapa, $event)"></v-switch>
                                <v-combobox v-if="modelReserva.etapas && i !== modelReserva.etapas.length - 1" outlined
                                  class="mt-4" dense :dark="dark" autocomplete="off" label="Alojamiento"
                                  v-model="modelReserva.etapas[i].proveedor"
                                  @change="_changeProveedorEtapaSeleccionado(etapa)"
                                  :error-messages="getAvisoEstadoEtapa(etapa)" :items="getProveedoresPorEtapa(etapa)"
                                  item-text="nombre_alias" item-value="id" return-object allow-input clearable
                                  :filter="customFilter"></v-combobox>

                                <v-row v-if="modelReserva.etapas && i !== modelReserva.etapas.length - 1">
                                  <v-col v-if="modelReserva.cant_habitaciones_individuales > 0" cols="3">
                                    <v-text-field style="width: 100%;" v-model="etapa.pivot.tarifa_ind" outlined dense
                                      :dark="dark" autocomplete="off" label="Ind" hide-details
                                      @blur="actualizarTarifasEtapa(etapa)"
                                      @keyup.enter="actualizarTarifasEtapa(etapa)">
                                    </v-text-field>
                                  </v-col>
                                  <v-col
                                    v-if="modelReserva.cant_habitaciones_dobles + modelReserva.cant_habitaciones_dobles_matrimoniales > 0"
                                    cols="3">
                                    <v-text-field style="width: 100%;" v-model="etapa.pivot.tarifa_doble" outlined dense
                                      :dark="dark" autocomplete="off" label="Doble" hide-details
                                      @blur="actualizarTarifasEtapa(etapa)"
                                      @keyup.enter="actualizarTarifasEtapa(etapa)"></v-text-field>
                                  </v-col>

                                  <v-col v-if="modelReserva.cant_habitaciones_triples > 0" cols="3">
                                    <v-text-field style="width: 100%;" v-model="etapa.pivot.tarifa_triple" outlined
                                      dense :dark="dark" autocomplete="off" label="Triple" hide-details
                                      @blur="actualizarTarifasEtapa(etapa)"
                                      @keyup.enter="actualizarTarifasEtapa(etapa)"></v-text-field>
                                  </v-col>



                                </v-row>
                                <v-row class="ml-2">
                                  <span>{{ descripcionCosteEtapa(etapa) }}</span>

                                </v-row>


                              </v-col>
                            </v-row>

                            <v-row justify="end" class="mt-2 mb-0 mr-0">
                              <v-chip v-if="modelReserva.itinerario_a_medida" class="px-10 mr-2" label
                                :color="'green lighten-2'" text-color="white" link
                                @click="_agregarEtapa(etapa.pivot.fecha)">
                                <span v-bind:style="{ color: 'white' }">Agregar Etapa</span>
                                <v-icon color="white" size="small" class="ml-2">mdi-arrow-down</v-icon>
                              </v-chip>
                              <v-chip v-if="modelReserva.itinerario_a_medida" class="px-10" label
                                :color="'red lighten-2'" text-color="white" link
                                @click="_eliminarEtapa(etapa.pivot.id)">
                                <span v-if="loadingEliminandoEtapa" v-bind:style="{ color: 'white' }">Eliminando
                                  Etapa...</span>
                                <span v-else v-bind:style="{ color: 'white' }">Eliminar Etapa</span>
                              </v-chip>
                            </v-row>




                            <!--   <v-row class="mb-2" v-for="(proveedor, i) in etapa.proveedores" :key="proveedor.id"
                              :dark="!dark" dense :color="'white'" flat>
                              <v-col cols="auto">
                                <v-icon :color="_colorEstadoAlojamiento(proveedor)">mdi-home</v-icon>
                              </v-col>
                              <v-col>
                                {{ proveedor.nombre }}
                              </v-col>

                            </v-row>-->

                          </v-card-text>
                        </v-card>
                        <!-- <v-row justify="end" class="mt-4 mb-4 mr-0">
                          <v-chip v-if="modelReserva.itinerario_a_medida" class="px-10 mx-4" label
                            :color="'green lighten-2'" text-color="white" link>
                            <span v-bind:style="{ color: 'white' }">Importar Itinerario a Medida</span>
                          </v-chip>

                          <v-chip v-if="modelReserva.itinerario_a_medida" class="px-10" label :color="'green lighten-2'"
                            text-color="white" link @click="showDialogGuardarItinerarioAMedida = true">
                            <span v-bind:style="{ color: 'white' }">Guardar Itinerario a Medida</span>
                          </v-chip>
                        </v-row> -->
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Historial -->
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row v-if="loadingCargandoHistorial">
                          <v-spacer />
                          <v-row class="mt-12">
                            <v-col>
                              <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px"
                                rounded height="6"></v-progress-linear>
                            </v-col>
                          </v-row>
                          <v-spacer />
                        </v-row>

                        <v-data-table
                          v-if="modelReserva && modelReserva.historials && modelReserva.historials.filter(item => item.tipo === null).length > 0"
                          hide-default-footer locale="es" dense :headers="headersHistorials"
                          :items="modelReserva.historials.filter(item => item.tipo === null)"
                          :server-items-length="modelReserva.historials.length"
                          class="elevation-1 alternating-rows bordered-table">

                          <template v-slot:[`item.fecha`]="{ item }">
                            {{ formatearFechaConHora(item.fecha) }}
                          </template>

                          <template v-slot:[`item.user`]="{ item }">
                            {{ getNombreUsuario(item.user) }}
                          </template>

                          <template v-slot:[`item.descripcion`]="{ item }">
                            <span class="historial-descripcion"
                              v-html="formatHistorialDescripcion(item.descripcion)"></span>
                          </template>

                          <template v-slot:[`item.mensaje`]="{ item }">
                            <v-icon v-if="getHistorialMensaje(item)" @click="mostrarDialogHistorialCorreo(item)"
                              style="cursor: pointer;" color="primary">
                              mdi-email
                            </v-icon>
                          </template>

                          <template v-slot:[`item.adjunto`]="{ item }">
                            <v-tooltip v-if="item.adjunto" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-if="item.adjunto != null" v-bind="attrs" @click="verHistorialAdjunto(item)"
                                  v-on="on" style="cursor: pointer;" color="primary">
                                  mdi-file-pdf
                                </v-icon>
                              </template>
                              <div class="tooltip-content">
                                Ver Documento
                              </div>
                            </v-tooltip>
                          </template>



                          <template v-slot:no-data>
                            No hay acciones registradas en el historial
                          </template>


                        </v-data-table>

                        <v-data-table v-if="historialsDisponibilidadOrdenados.length > 0" hide-default-footer
                          locale="es" dense :headers="headersHistorialsDisponibilidad"
                          :items="historialsDisponibilidadOrdenados"
                          :server-items-length="historialsDisponibilidadOrdenados.length"
                          class="mt-6 elevation-1 alternating-rows bordered-table">

                          <template v-slot:top>
                            <v-toolbar dense :color="colorBarraFormulario" dark flat>
                              <v-toolbar-title>Historial Disponibilidad</v-toolbar-title>
                            </v-toolbar>
                          </template>

                          <template v-slot:[`item.created_at`]="{ item }">
                            {{ formatearFechaConHora(item.created_at) }}
                          </template>

                          <template v-slot:[`item.user`]="{ item }">
                            {{ getNombreUsuario(item.user) }}
                          </template>

                          <template v-slot:[`item.descripcion`]="{ item }">
                            <span class="historial-descripcion"
                              v-html="formatHistorialDescripcion(item.descripcion)"></span>
                          </template>

                          <template v-slot:[`item.mensaje`]="{ item }">
                            <v-icon v-if="getHistorialMensaje(item)" @click="mostrarDialogHistorialCorreo(item)"
                              style="cursor: pointer;" color="primary">
                              mdi-email
                            </v-icon>
                          </template>

                          <template v-slot:[`item.adjunto`]="{ item }">
                            <v-tooltip v-if="item.adjunto" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-if="item.adjunto != null" v-bind="attrs" @click="verHistorialAdjunto(item)"
                                  v-on="on" style="cursor: pointer;" color="primary">
                                  mdi-file-pdf
                                </v-icon>
                              </template>
                              <div class="tooltip-content">
                                Ver Documento
                              </div>
                            </v-tooltip>
                          </template>



                          <template v-slot:no-data>
                            No hay acciones registradas en el historial
                          </template>


                        </v-data-table>

                        <v-data-table v-if="historialsAgenciaRutasMeigasOrdenados.length > 0" hide-default-footer
                          locale="es" dense :headers="headersHistorials"
                          :items="historialsAgenciaRutasMeigasOrdenados"
                          :server-items-length="historialsAgenciaRutasMeigasOrdenados.length"
                          class="mt-6 elevation-1 alternating-rows bordered-table">

                          <template v-slot:top>
                            <v-toolbar dense :color="colorBarraFormulario" dark flat>
                              <v-toolbar-title>Historial {{ modelReserva && modelReserva.origen ? modelReserva.origen.nombre : 'Agencia' }} <=> Rutas Meigas</v-toolbar-title>
                            </v-toolbar>
                          </template>

                          <template v-slot:[`item.created_at`]="{ item }">
                            {{ formatearFechaConHora(item.created_at) }}
                          </template>

                          <template v-slot:[`item.user`]="{ item }">
                            {{ getNombreUsuario(item.user) }}
                          </template>

                          <template v-slot:[`item.descripcion`]="{ item }">
                            <span class="historial-descripcion"
                              v-html="formatHistorialDescripcion(item.descripcion)"></span>
                          </template>

                          <template v-slot:[`item.mensaje`]="{ item }">
                            <v-icon v-if="getHistorialMensaje(item)" @click="mostrarDialogHistorialCorreo(item)"
                              style="cursor: pointer;" color="primary">
                              mdi-email
                            </v-icon>
                          </template>

                          <template v-slot:[`item.adjunto`]="{ item }">
                            <v-tooltip v-if="item.adjunto" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-if="item.adjunto != null" v-bind="attrs" @click="verHistorialAdjunto(item)"
                                  v-on="on" style="cursor: pointer;" color="primary">
                                  mdi-file-pdf
                                </v-icon>
                              </template>
                              <div class="tooltip-content">
                                Ver Documento
                              </div>
                            </v-tooltip>
                          </template>

                          <template v-slot:no-data>
                            No hay acciones registradas en el historial
                          </template>
                        </v-data-table>

                        <v-row justify="end" class="mt-12 mb-2 mx-4">
                          <v-chip class="px-2" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '0px' }"
                            text-color="white" link @click="_showModalAgregarNotaInterna()">
                            <span v-bind:style="{ color: 'white' }">Nueva Nota Interna</span>
                          </v-chip>
                          <v-chip class="ml-2 px-2" label :color="colorAccent1" v-bind:style="{ 'min-width': '0px' }"
                            text-color="white" link @click="_guardarNotasInternasEditadas">
                            <span v-if="loadingGuardandoNotasInternas"
                              v-bind:style="{ color: 'white' }">Guardando...</span>
                            <span v-else v-bind:style="{ color: 'white' }">Guardar Cambios</span>
                          </v-chip>
                        </v-row>

                        <v-row dense class="mx-4 mt-2">
                          <v-card outlined style="width: 100%; max-height: 500px; overflow-y: auto;" class="pa-3">
                            <v-row v-if="notasInternasEditables.length === 0" dense>
                              <v-col>
                                <span>No hay notas internas</span>
                              </v-col>
                            </v-row>
                            <v-card v-for="(nota, index) in notasInternasEditables" :key="nota.id" outlined
                              class="pa-3 mb-2">
                              <v-row dense>
                                <v-col cols="10">
                                  <div v-html="nota.headerHtml" style="font-weight: bold; margin-bottom: 6px;"></div>
                                  <v-textarea v-model="nota.bodyText" outlined dense :dark="dark" hide-details rows="3"
                                    label="Nota interna"></v-textarea>
                                </v-col>
                                <v-col cols="2" class="d-flex align-start justify-end">
                                  <v-chip class="px-0" label small :color="'red lighten-2'" text-color="white" link
                                    @click="_eliminarNotaInterna(index)">
                                    <v-icon>mdi-delete</v-icon>
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-card>
                        </v-row>


                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Pasajeros -->
                  <v-tab-item>
                    <v-card>
                      <v-card-text>

                        <v-row class="mt-8 mb-8 mx-4">
                          <v-switch :input-value="clienteEsViajero" label="El cliente es parte de los pasajeros"
                            :color="colorAccent1" :loading="loadingClienteEsViajero"
                            :disabled="!modelReserva || !modelReserva.id || loadingClienteEsViajero" dense hide-details
                            @change="_actualizarClienteEsViajero">
                          </v-switch>
                          <v-spacer></v-spacer>
                          <v-chip class="mr-0 px-10" label :color="'green lighten-2'" text-color="white" link
                            @click="_showModalAgregarPasajero()">
                            <span v-bind:style="{ color: 'white' }">Agregar Pasajero</span>
                          </v-chip>
                        </v-row>

                        <v-data-table hide-default-footer locale="es" v-if="modelReserva && modelReserva.pasajeros"
                          dense :headers="headersPasajeros" :items="pasajerosMostrados"
                          :server-items-length="pasajerosMostrados.length"
                          class="elevation-1 alternating-rows bordered-table">

                          <template v-slot:[`item.roaming`]="{ item }">
                            <v-combobox v-if="tieneRoaming" class="ma-0 pa-0" dense outlined hide-details
                              :items="getHabitacionesDisponiblesParaPasajero(item)" :value="getHabitacionAsignada(item)"
                              item-text="label" return-object
                              @change="seleccion => onAsignarHabitacion(item, seleccion)"></v-combobox>
                            <span v-else>-</span>
                          </template>

                          <template v-slot:[`item.action`]="{ item }">
                            <v-chip class="mr-2 px-0" label small :color="'blue lighten-2'" text-color="white" link
                              @click="_editarPasajero(item)">
                              <v-icon>mdi-pencil</v-icon>
                            </v-chip>
                            <v-chip class="mr-1 px-0" label small
                              :color="_esPrimerPasajero(item) ? 'grey lighten-2' : 'red lighten-2'" text-color="white"
                              :link="!_esPrimerPasajero(item)" :disabled="_esPrimerPasajero(item)"
                              @click="!_esPrimerPasajero(item) ? _deletePasajero(item) : null">
                              <v-icon>mdi-delete</v-icon>
                            </v-chip>
                          </template>

                          <template v-slot:no-data>
                            No hay pasajeros registrados
                          </template>
                        </v-data-table>

                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Archivos -->
                  <v-tab-item>
                    <!-- Dossier y Tips del Camino -->
                    <v-card v-if="this.accion == 'editar'" :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-12">
                      <v-toolbar dense :color="colorBarraFormulario" dark flat>
                        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                          <h5 v-bind:style="{ color: 'white' }">DOSSIER, TIPS DEL CAMINO {{ modelReserva.language ==
                            'ES' ?
                            'Y SEGURO DE ANULACIÓN' : '' }}</h5>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>

                      </v-toolbar>
                      <v-card-text>
                        <v-data-table hide-default-footer locale="es"
                          v-if="archivosDossierYTips && archivosDossierYTips.length > 0" dense
                          :headers="headersDossierYTips" :items="archivosDossierYTips"
                          :server-items-length="archivosDossierYTips.length"
                          class="elevation-1 alternating-rows bordered-table">

                          <template v-slot:[`item.action`]="{ item }">
                            <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link
                              :href="item.url_pdf" target="_blank">
                              Ver
                            </v-chip>
                          </template>

                          <template v-slot:[`item.url_pdf`]="{ item }">
                            {{ getNombreArchivo(item.url_pdf) }}
                          </template>

                          <template v-slot:no-data>
                            No hay documentos registrados para este camino
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                    <v-row v-if="this.accion == 'editar' && !allEtapasConfirmadas" class="mt-6 mb-12" justify="center">
                      <span style="color: red;">Si no están asignados los alojamientos en cada etapa, no se pueden
                        generar
                        los documentos de la reserva.</span>
                    </v-row>

                    <!-- Bonos de Alojamientos -->
                    <v-card v-if="this.accion == 'editar' && allEtapasConfirmadas" :color="'rgb(255, 255, 255)'"
                      class="elevation-0 mx-0 mt-6">
                      <v-toolbar dense :color="colorBarraFormulario" dark flat>
                        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                          <h5 v-bind:style="{ color: 'white' }">BONOS DE ALOJAMIENTOS</h5>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-chip class="mr-0 px-10" label :color="'green lighten-2'" text-color="white" link
                          @click="_generarBonosAlojamientos">
                          <span v-if="loadingGenerandoBonosAlojamientos" v-bind:style="{ color: 'white' }">
                            Generando...</span>
                          <span v-else v-bind:style="{ color: 'white' }"> Generar Bonos Alojamientos</span>
                        </v-chip>
                      </v-toolbar>
                      <v-card-text>
                        <v-data-table hide-default-footer locale="es"
                          v-if="modelReserva && modelReserva.bonos_alojamientos" dense :headers="headersPresupuestos"
                          :items="modelReserva.bonos_alojamientos"
                          :server-items-length="modelReserva.bonos_alojamientos.length"
                          class="elevation-1 alternating-rows bordered-table">

                          <template v-slot:[`item.action`]="{ item }">
                            <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link
                              :href="item.url_pdf" target="_blank">
                              Ver
                            </v-chip>
                          </template>

                          <template v-slot:[`item.fecha`]="{ item }">
                            {{ formatearFechaConHora(item.fecha) }}
                          </template>

                          <template v-slot:[`item.url_pdf`]="{ item }">
                            {{ getNombreArchivo(item.url_pdf) }}
                          </template>

                          <template v-slot:[`item.action2`]="{ item }">
                            <v-menu bottom left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="_mostrarDialogEnviarDocumentoCliente(item)">
                                  <v-list-item-title>Enviar al Cliente</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="_eliminarPresupuesto(item)">
                                  <v-list-item-title>Eliminar</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </template>

                          <template v-slot:no-data>
                            No hay bonos de alojamientos registrados
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>

                    <!-- Bonos de Servicios -->
                    <v-card v-if="this.accion == 'editar' && allEtapasConfirmadas" :color="'rgb(255, 255, 255)'"
                      class="elevation-0 mx-0 mt-6">
                      <v-toolbar dense :color="colorBarraFormulario" dark flat>
                        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                          <h5 v-bind:style="{ color: 'white' }">BONOS DE SERVICIOS</h5>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-chip class="mr-0 px-10" label :color="'green lighten-2'" text-color="white" link
                          @click="_generarBonosServicios">
                          <span v-if="loadingGenerandoBonosServicios" v-bind:style="{ color: 'white' }">
                            Generando...</span>
                          <span v-else v-bind:style="{ color: 'white' }"> Generar Bonos Servicios</span>
                        </v-chip>

                      </v-toolbar>
                      <v-card-text>
                        <v-data-table hide-default-footer locale="es"
                          v-if="modelReserva && modelReserva.bonos_servicios" dense :headers="headersPresupuestos"
                          :items="modelReserva.bonos_servicios"
                          :server-items-length="modelReserva.bonos_servicios.length"
                          class="elevation-1 alternating-rows bordered-table">

                          <template v-slot:[`item.action`]="{ item }">
                            <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link
                              :href="item.url_pdf" target="_blank">
                              Ver
                            </v-chip>
                          </template>

                          <template v-slot:[`item.fecha`]="{ item }">
                            {{ formatearFechaConHora(item.fecha) }}
                          </template>

                          <template v-slot:[`item.url_pdf`]="{ item }">
                            {{ getNombreArchivo(item.url_pdf) }}
                          </template>

                          <template v-slot:[`item.action2`]="{ item }">
                            <v-menu bottom left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="_mostrarDialogEnviarDocumentoCliente(item)">
                                  <v-list-item-title>Enviar al Cliente</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="_eliminarPresupuesto(item)">
                                  <v-list-item-title>Eliminar</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </template>

                          <template v-slot:no-data>
                            No hay bonos de servicios registrados
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>

                    <!-- Proforma -->
                    <v-card v-if="this.accion == 'editar' && allEtapasConfirmadas" :color="'rgb(255, 255, 255)'"
                      class="elevation-0 mx-0 mt-6">
                      <v-toolbar dense :color="colorBarraFormulario" dark flat>
                        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                          <h5 v-bind:style="{ color: 'white' }">PROFORMAS</h5>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-chip class="mr-0 px-10" label :color="'green lighten-2'" text-color="white" link
                          @click="_generarProforma">
                          <span v-if="loadingGenerandoProforma" v-bind:style="{ color: 'white' }"> Generando...</span>
                          <span v-else v-bind:style="{ color: 'white' }"> Generar Proforma</span>
                        </v-chip>

                      </v-toolbar>
                      <v-card-text>
                        <v-data-table hide-default-footer locale="es" v-if="modelReserva && modelReserva.proformas"
                          dense :headers="headersPresupuestos" :items="modelReserva.proformas"
                          :server-items-length="modelReserva.proformas.length"
                          class="elevation-1 alternating-rows bordered-table">

                          <template v-slot:[`item.action`]="{ item }">
                            <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link
                              :href="item.url_pdf" target="_blank">
                              Ver
                            </v-chip>
                          </template>

                          <template v-slot:[`item.fecha`]="{ item }">
                            {{ formatearFechaConHora(item.fecha) }}
                          </template>

                          <template v-slot:[`item.url_pdf`]="{ item }">
                            {{ getNombreArchivo(item.url_pdf) }}
                          </template>

                          <template v-slot:[`item.action2`]="{ item }">
                            <v-menu bottom left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="_mostrarDialogEnviarDocumentoCliente(item)">
                                  <v-list-item-title>Enviar al Cliente</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="_eliminarPresupuesto(item)">
                                  <v-list-item-title>Eliminar</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </template>

                          <template v-slot:no-data>
                            No hay proformas registradas
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>

                    <!-- Seguro de Viaje -->
                    <v-card v-if="this.accion == 'editar' && allEtapasConfirmadas" :color="'rgb(255, 255, 255)'"
                      class="elevation-0 mx-0 mt-6">
                      <v-toolbar dense :color="colorBarraFormulario" dark flat>
                        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                          <h5 v-bind:style="{ color: 'white' }">SEGURO DE VIAJE</h5>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-chip class="mr-0 px-10" label :color="'green lighten-2'" text-color="white" link
                          @click="abrirSelectorSeguro">
                          <span v-bind:style="{ color: 'white' }"> Subir Seguro</span>
                        </v-chip>

                        <!-- Input file oculto -->
                        <input ref="fileInput" type="file" accept=".pdf" style="display: none"
                          @change="manejarSeleccionSeguro" />

                      </v-toolbar>
                      <v-card-text>
                        <v-data-table hide-default-footer locale="es" v-if="modelReserva && modelReserva.seguros" dense
                          :headers="headersPresupuestos" :items="modelReserva.seguros"
                          :server-items-length="modelReserva.seguros.length"
                          class="elevation-1 alternating-rows bordered-table">

                          <template v-slot:[`item.action`]="{ item }">
                            <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link
                              :href="item.url_pdf" target="_blank">
                              Ver
                            </v-chip>
                          </template>

                          <template v-slot:[`item.fecha`]="{ item }">
                            {{ formatearFechaConHora(item.fecha) }}
                          </template>

                          <template v-slot:[`item.url_pdf`]="{ item }">
                            {{ getNombreArchivo(item.url_pdf) }}
                          </template>

                          <template v-slot:[`item.action2`]="{ item }">
                            <v-menu bottom left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="_mostrarDialogEnviarDocumentoCliente(item)">
                                  <v-list-item-title>Enviar al Cliente</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="_eliminarPresupuesto(item)">
                                  <v-list-item-title>Eliminar</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </template>

                          <template v-slot:no-data>
                            No hay Seguros de Viaje subidos
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>


                  </v-tab-item>

                  <!-- Resumen -->
                  <v-tab-item>
                    <vista-resumen v-if="modelReserva" :reserva="modelReserva" @guardar-servicios="_guardarServicios" />
                  </v-tab-item>

                  <!-- API-Correos -->
                  <v-tab-item v-if="mostrarTabApiCorreos">
                    <api-correos-tab :model-reserva="modelReserva" />
                  </v-tab-item>

                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <!-- TICKET PARA CLIENTES FINALES -->
        <v-col v-if="!isReservaDeAgencia" cols="3">
          <v-row class="mt-6">
            <v-col cols="6" align="end">
              <h3> Importe reserva: </h3>

            </v-col>
            <v-col align="end">
              <h2>{{ formatearImporte(this.getImporteReservaParaMostrar) }}</h2>
            </v-col>
          </v-row>
          <v-row dense class="mt-2">
            <v-col align="end">
              <p style="white-space: pre-wrap">{{ formatearImporteEnTexto(this.getDescripcionImporteReservaParaMostrar)
                }}
              </p>
            </v-col>
          </v-row>

          <v-row v-if="this.accion == 'editar' && tieneServiciosParaMostrar">
            <v-col cols="6" align="end">
              <h3> Importe servicios: </h3>
            </v-col>
            <v-col align="end">
              <h2>{{ formatearImporte(this.getImporteServicios) }}</h2>
            </v-col>
          </v-row>

          <v-row v-if="this.accion == 'editar' && tieneServiciosParaMostrar" align="center" dense>
            <v-col align="end">
              <p v-html="formatearImporteEnTexto(this.getDescripcionImporteServicios)" />
            </v-col>
          </v-row>

          <v-row v-if="tieneServiciosExtras">
            <v-col cols="6" align="end">
              <h3> Importe total: </h3>
            </v-col>
            <v-col align="end">
              <h2>{{ formatearImporte(this.getImporteTotal) }}</h2>
            </v-col>
          </v-row>
          <template v-if="modelReserva">
            <v-row dense>
              <v-col cols="6" align="end">
                <span> Coste total: </span>
              </v-col>
              <v-col align="end">
                <span>{{ formatearImporte(totalCosteResumen) }}</span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" align="end">
                <span> Margen: </span>
              </v-col>
              <v-col align="end">
                <span>{{ formatearImporte(gananciaResumen) }}</span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" align="end">
                <span> Margen (%): </span>
              </v-col>
              <v-col align="end">
                <span>{{ porcientoVentaCosteResumen.toFixed(2) }} %</span>
              </v-col>
            </v-row>
          </template>



          <v-card v-if="this.accion == 'editar'" :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-12">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                <h5 v-bind:style="{ color: 'white' }">PRESUPUESTOS</h5>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip class="px-2" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '0px' }"
                text-color="white" link @click="_generarNuevoPresupuesto">
                <span v-if="loadingGenerandoPresupuesto" v-bind:style="{ color: 'white' }">Generando...</span>
                <span v-else v-bind:style="{ color: 'white' }">Generar</span>
              </v-chip>

            </v-toolbar>
            <v-card-text>
              <v-data-table hide-default-footer locale="es"
                v-if="modelReserva && modelReserva.presupuestos && modelReserva.presupuestos.length > 0" dense
                :headers="headersPresupuestos" :items="modelReserva.presupuestos"
                :server-items-length="modelReserva.presupuestos.length"
                class="elevation-1 alternating-rows bordered-table">

                <template v-slot:[`item.action`]="{ item }">
                  <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link :href="item.url_pdf"
                    target="_blank">
                    Ver
                  </v-chip>
                </template>



                <template v-slot:[`item.fecha`]="{ item }">
                  {{ formatearFechaConHora(item.fecha) }}
                </template>

                <template v-slot:[`item.url_pdf`]="{ item }">
                  {{ getNombreArchivo(item.url_pdf) }}
                </template>

                <template v-slot:[`item.action2`]="{ item }">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="_eliminarPresupuesto(item)">
                        <v-list-item-title>Eliminar</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>

                <template v-slot:no-data>
                  No hay presupuestos registrados
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card v-if="this.accion == 'editar'" :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-12">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                <h5 v-bind:style="{ color: 'white' }">CONFIRMACIONES</h5>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip v-if="this.accion == 'editar' && allEtapasConfirmadas" class="px-2" label
                :color="'green lighten-2'" v-bind:style="{ 'min-width': '0px' }" text-color="white" link
                @click="_generarNuevaConfirmacion">
                <span v-if="loadingGenerandoConfirmacion" v-bind:style="{ color: 'white' }">Generando...</span>
                <span v-else v-bind:style="{ color: 'white' }">Generar</span>
              </v-chip>

            </v-toolbar>
            <v-card-text>
              <v-data-table hide-default-footer locale="es"
                v-if="modelReserva && modelReserva.confirmaciones && modelReserva.confirmaciones.length > 0" dense
                :headers="headersPresupuestos" :items="modelReserva.confirmaciones"
                :server-items-length="modelReserva.confirmaciones.length"
                class="elevation-1 alternating-rows bordered-table">

                <template v-slot:[`item.action`]="{ item }">
                  <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link :href="item.url_pdf"
                    target="_blank">
                    Ver
                  </v-chip>
                </template>

                <template v-slot:[`item.fecha`]="{ item }">
                  {{ formatearFechaConHora(item.fecha) }}
                </template>

                <template v-slot:[`item.url_pdf`]="{ item }">
                  {{ getNombreArchivo(item.url_pdf) }}
                </template>

                <template v-slot:[`item.action2`]="{ item }">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="_eliminarPresupuesto(item)">
                        <v-list-item-title>Eliminar</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>


                <template v-slot:no-data>
                  No hay confirmaciones registradas
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card v-if="this.accion == 'editar'" :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-12">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                <h5 v-bind:style="{ color: 'white' }">ACCIONES</h5>
              </v-toolbar-title>
              <v-spacer></v-spacer>

            </v-toolbar>
            <v-card-text>
              <v-row justify="center" class="mt-2 mb-2">

              </v-row>

              <v-row v-if="mostrarBotonEnviarPresupuesto" justify="center" class="mt-2 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarPresupuesto()">
                  <span v-bind:style="{ color: 'white' }">Enviar Presupuesto</span>
                </v-chip>
              </v-row>


              <v-row v-if="existConfirmacion && allEtapasConfirmadas" justify="center" class="mt-2 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarConfirmacion()">
                  <span v-bind:style="{ color: 'white' }">Enviar Confirmación</span>
                </v-chip>
              </v-row>

              <v-row v-if="allEtapasConfirmadas" justify="center" class="mt-2 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarDocumentacionFinal()">
                  <span v-bind:style="{ color: 'white' }">Enviar Documentación</span>
                </v-chip>
              </v-row>

              <v-row justify="center" class="mt-10 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarCorreo()">
                  <span v-bind:style="{ color: 'white' }">Enviar Correo con Extras</span>
                </v-chip>
              </v-row>

              <v-row v-if="fechaLlegadaYaPasada" justify="center" class="mt-2 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarResena()">
                  <span v-bind:style="{ color: 'white' }">Enviar Reseña - Cuestionario</span>
                </v-chip>
              </v-row>

            </v-card-text>
          </v-card>
        </v-col>

        <!-- TICKET PARA AGENCIAS -->
        <v-col v-if="isReservaDeAgencia" cols="3">
          <v-row dense class="mt-6">
            <v-col cols="7" align="end">
              <h3> Importe reserva: (PVP) </h3>

            </v-col>
            <v-col align="end">
              <h2>{{ formatearImporte(this.getImporteReservaParaMostrar) }}</h2>
            </v-col>
          </v-row>


          <v-row dense class="mt-0">
            <v-col cols="7" align="end">
              <h4> {{ comisionAgenciaPorcentaje }}% Comisión: </h4>

            </v-col>
            <v-col align="end">
              <h4>{{ formatearImporte(importeComisionAgencia) }}</h4>
            </v-col>
          </v-row>

          <v-row dense class="mt-0">
            <v-col cols="7" align="end">
              <h4> Importe Neto Agencia: </h4>

            </v-col>
            <v-col align="end">
              <h4>{{ formatearImporte(importeNetoAgencia) }}</h4>
            </v-col>
          </v-row>

          <v-row dense class="mt-4">
            <v-col align="end">
              <p style="white-space: pre-wrap">{{ formatearImporteEnTexto(this.getDescripcionImporteReservaParaMostrar)
                }}
              </p>
            </v-col>
          </v-row>

          <v-row v-if="this.accion == 'editar' && tieneServiciosParaMostrar">
            <v-col cols="7" align="end">
              <h3> Importe servicios: (Neto) </h3>
            </v-col>
            <v-col align="end">
              <h2>{{ formatearImporte(this.getImporteServicios) }}</h2>
            </v-col>
          </v-row>

          <v-row v-if="this.accion == 'editar' && tieneServiciosParaMostrar" align="center" dense>
            <v-col align="end">
              <p v-html="formatearImporteEnTexto(this.getDescripcionImporteServicios)" />
            </v-col>
          </v-row>

          <v-row v-if="tieneServiciosExtras" dense>
            <v-col cols="7" align="end">
              <h3> Importe total: (PVP) </h3>
            </v-col>
            <v-col align="end">
              <h2>{{ formatearImporte(this.getImporteTotal) }}</h2>
            </v-col>
          </v-row>

          <v-row v-if="tieneServiciosExtras" dense>
            <v-col cols="7" align="end">
              <h3> Importe total: (Neto) </h3>
            </v-col>
            <v-col align="end">
              <h2>{{ formatearImporte(Number(this.importeNetoAgencia) + Number(this.getImporteServicios)) }}</h2>
            </v-col>
          </v-row>

          <template v-if="modelReserva">
            <v-row dense>
              <v-col cols="6" align="end">
                <span> Coste total: </span>
              </v-col>
              <v-col align="end">
                <span>{{ formatearImporte(totalCosteResumen) }}</span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" align="end">
                <span> Margen: </span>
              </v-col>
              <v-col align="end">
                <span>{{ formatearImporte(gananciaResumen) }}</span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" align="end">
                <span> Margen (%): </span>
              </v-col>
              <v-col align="end">
                <span>{{ porcientoVentaCosteResumen.toFixed(2) }} %</span>
              </v-col>
            </v-row>
          </template>



          <v-card v-if="this.accion == 'editar'" :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-12">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                <h5 v-bind:style="{ color: 'white' }">PRESUPUESTOS</h5>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip class="px-2" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '0px' }"
                text-color="white" link @click="_generarNuevoPresupuesto">
                <span v-if="loadingGenerandoPresupuesto" v-bind:style="{ color: 'white' }">Generando...</span>
                <span v-else v-bind:style="{ color: 'white' }">Generar</span>
              </v-chip>

            </v-toolbar>
            <v-card-text>
              <v-data-table hide-default-footer locale="es"
                v-if="modelReserva && modelReserva.presupuestos && modelReserva.presupuestos.length > 0" dense
                :headers="headersPresupuestos" :items="modelReserva.presupuestos"
                :server-items-length="modelReserva.presupuestos.length"
                class="elevation-1 alternating-rows bordered-table">

                <template v-slot:[`item.action`]="{ item }">
                  <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link :href="item.url_pdf"
                    target="_blank">
                    Ver
                  </v-chip>
                </template>



                <template v-slot:[`item.fecha`]="{ item }">
                  {{ formatearFechaConHora(item.fecha) }}
                </template>

                <template v-slot:[`item.url_pdf`]="{ item }">
                  {{ getNombreArchivo(item.url_pdf) }}
                </template>

                <template v-slot:[`item.action2`]="{ item }">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="_eliminarPresupuesto(item)">
                        <v-list-item-title>Eliminar</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>

                <template v-slot:no-data>
                  No hay presupuestos registrados
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card v-if="this.accion == 'editar'" :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-12">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                <h5 v-bind:style="{ color: 'white' }">CONFIRMACIONES</h5>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip v-if="this.accion == 'editar' && allEtapasConfirmadas" class="px-2" label
                :color="'green lighten-2'" v-bind:style="{ 'min-width': '0px' }" text-color="white" link
                @click="_generarNuevaConfirmacion">
                <span v-if="loadingGenerandoConfirmacion" v-bind:style="{ color: 'white' }">Generando...</span>
                <span v-else v-bind:style="{ color: 'white' }">Generar</span>
              </v-chip>

            </v-toolbar>
            <v-card-text>
              <v-data-table hide-default-footer locale="es"
                v-if="modelReserva && modelReserva.confirmaciones && modelReserva.confirmaciones.length > 0" dense
                :headers="headersPresupuestos" :items="modelReserva.confirmaciones"
                :server-items-length="modelReserva.confirmaciones.length"
                class="elevation-1 alternating-rows bordered-table">

                <template v-slot:[`item.action`]="{ item }">
                  <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link :href="item.url_pdf"
                    target="_blank">
                    Ver
                  </v-chip>
                </template>

                <template v-slot:[`item.fecha`]="{ item }">
                  {{ formatearFechaConHora(item.fecha) }}
                </template>

                <template v-slot:[`item.url_pdf`]="{ item }">
                  {{ getNombreArchivo(item.url_pdf) }}
                </template>

                <template v-slot:[`item.action2`]="{ item }">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="_eliminarPresupuesto(item)">
                        <v-list-item-title>Eliminar</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>


                <template v-slot:no-data>
                  No hay confirmaciones registradas
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card v-if="this.accion == 'editar'" :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-12">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
                <h5 v-bind:style="{ color: 'white' }">ACCIONES</h5>
              </v-toolbar-title>
              <v-spacer></v-spacer>

            </v-toolbar>
            <v-card-text>
              <v-row justify="center" class="mt-2 mb-2">

              </v-row>

              <v-row v-if="mostrarBotonEnviarPresupuesto" justify="center" class="mt-2 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarPresupuesto()">
                  <span v-bind:style="{ color: 'white' }">Enviar Presupuesto</span>
                </v-chip>
              </v-row>


              <v-row v-if="existConfirmacion && allEtapasConfirmadas" justify="center" class="mt-2 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarConfirmacion()">
                  <span v-bind:style="{ color: 'white' }">Enviar Confirmación</span>
                </v-chip>
              </v-row>

              <v-row v-if="allEtapasConfirmadas" justify="center" class="mt-2 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarDocumentacionFinal()">
                  <span v-bind:style="{ color: 'white' }">Enviar Documentación</span>
                </v-chip>
              </v-row>

              <v-row justify="center" class="mt-10 mb-2">
                <v-chip class="px-10" label :color="'green lighten-2'" v-bind:style="{ 'min-width': '250px' }"
                  text-color="white" link @click="_mostrarDialogEnviarCorreo()">
                  <span v-bind:style="{ color: 'white' }">Enviar Correo con Extras</span>
                </v-chip>
              </v-row>



            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>


  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import EtapaExtraFormulario from "@/components/formularios/EtapaExtraFormulario.vue";
import ProveedorFormulario from "@/components/formularios/ProveedorFormulario.vue";
import ValoracionesDetalleDialog from "@/components/valoraciones/ProveedorValoracionesDialog.vue";
import ApiCorreosTab from "@/components/presupuesto/ApiCorreosTab.vue";
import VistaResumen from "@/components/presupuesto/VistaResumen.vue";
import {
  descripcionCosteEtapa as descripcionCosteEtapaHelper,
  formatearImporte,
  formatearImporteEnTexto,
  getCosteEtapa as getCosteEtapaHelper,
  getGananciaResumen as getGananciaResumenHelper,
  getPorcentajeVentaCoste as getPorcentajeVentaCosteHelper,
  getTotalCosteResumen as getTotalCosteResumenHelper,
  getTotalVentaResumen as getTotalVentaResumenHelper,
} from "@/helpers/reservaHelpers";
import { generarEmailContenidoPresupuesto, generarEmailContenidoConfirmacion, generarEmailContenidoDocumentacion, generarEmailContenidoResena } from "@/helpers/emailsHelpers";


export default {
  components: {
    EtapaExtraFormulario,
    ProveedorFormulario,
    ValoracionesDetalleDialog,
    ApiCorreosTab,
    VistaResumen,
  },


  data: () => ({
    inputId: null,
    loading: false,
    loadingGuardando: false,
    loadingGuardandoServicios: false,
    loadingGuardandoEdicionNocheExtra: false,
    loadingGenerandoPresupuesto: false,

    loadingCargandoHistorial: false,
    loadingGuardandoPasajero: false,
    loadingClienteEsViajero: false,
    loadingGuardandoNotasInternas: false,
    loadingGenerandoBonosAlojamientos: false,
    loadingGenerandoBonosServicios: false,
    loadingGenerandoProforma: false,
    loadingGenerandoConfirmacion: false,

    dialogValoracionesReserva: false,

    modelReserva: null,
    serviciosNoIncluidos: [],
    serviciosIncluidos: [],

    nochesextras: [],
    trasladosExtras: [],
    serviciosExtras: [],

    showModalAgregarServicio: false,
    showDialogEditarNocheExtra: false,
    showModalNuevaNotaInterna: false,
    showConfirmacionCancelaServicio: false,
    servicioSeleccionado: null,
    servicioNocheExtraEditando: null,

    showModalAgregarPasajero: false,
    menuFechaNacimiento: false,

    servicioNuevoSeleccionado: null,
    servicioNuevoTipoDescuento: 'Servicios',
    tiposDescuento: ['Servicios', 'Reserva'],

    showDialogItinerarioAMedida: false,
    showDialogItinerarioOriginal: false,

    showDialogCambiarEstado: false,
    showDialogCambiarTrabajador: false,
    showDialogConfirmarCambioProveedorEtapa: false,
    dialogFormularioProveedor: false,
    modelProveedor: null,
    showDialogTarifasAlojamientoItinerario: false,
    loadingTarifasAlojamientoItinerario: false,
    tarifasAlojamientoItinerario: [],
    tarifasAlojamientoProveedorIdItinerario: null,
    tarifasAlojamientoProveedorItinerario: "",
    tarifasAlojamientoFechaItinerario: "",
    menuFechaTarifasAlojamientoItinerario: false,
    headersTarifasAlojamientoItinerario: [
      { text: "Régimen", value: "regimen" },
      { text: "Habitación - Característica", value: "habitacion_caracteristica" },
      { text: "Precio", value: "precio", align: "right" },
    ],
    headersTarifasGenericasItinerario: [
      { text: "Descripción", value: "descripcion" },
      { text: "Unidad", value: "unidad" },
      { text: "Precio", value: "precio", align: "right" },
    ],
    showDialogEnviarCorreoEtapa: false,
    loadingEnviandoCorreoEtapa: false,
    etapaCorreoSeleccionada: null,
    proveedorCorreoEtapaSeleccionado: null,
    enviarCorreoEtapaListaCorreos: [],
    enviarCorreoEtapaDe: "",
    enviarCorreoEtapaParaOptions: [],
    enviarCorreoEtapaPara: "",
    enviarCorreoEtapaCC: "",
    enviarCorreoEtapaAsunto: "",
    enviarCorreoEtapaTexto: "",
    procesandoCambioProveedorEtapa: false,
    cambioProveedorEtapaPendiente: null,

    trabajadores: [],
    trabajadorSeleccionado: null,
    mensajeTrabajador: '',
    loadingTrabajadores: false,

    showDialogEliminarTodasEtapas: false,
    loadingEliminandoEtapa: false,
    loadingEliminandoTodasEtapas: false,

    dialogFormularioEtapaExtra: false,

    modelEtapaExtra: null,
    fechaEtapaExtra: null,

    notasInternasEditables: [],

    showDialogGuardarItinerarioAMedida: false,
    itinerarioAMedidaNombre: '',
    itinerarioAMedidaDescripcion: '',

    showDialogEnviarCorreo: false,
    showDialogEnviarDocumentoCliente: false,
    showDialogHistorialCorreo: false,
    showDialogHistorialAdjuntos: false,
    documentoClienteSeleccionado: null,
    historialCorreoTexto: '',
    historialAdjuntos: [],
    loadingEnviandoDocumentoCliente: false,

    enviarCorreoDe: '',
    enviarCorreoPara: '',
    enviarCorreoCC: '',
    enviarCorreoAsunto: '',
    enviarTextoMensaje: '',

    enviarDocumentoClienteDe: '',
    enviarDocumentoClientePara: '',
    enviarDocumentoClienteCC: '',
    enviarDocumentoClienteAsunto: '',
    enviarDocumentoClienteTexto: '',

    allowSendUltimoPresupuesto: false,
    allowSendUltimoConfirmacion: false,
    allowSendUltimoBonoAlojamientos: false,
    allowSendUltimoBonoServicios: false,
    allowSendUltimoProforma: false,
    allowSendUltimoSeguro: false,
    allowSendDossier: false,
    allowSendTips: false,
    allowSendSeguroAnulacion: false,
    allowSendAutorizacionTarjeta: false,
    allowSendRegistroViajeros: false,
    allowSendDatosBanco: false,
    allowSendCuestionario: false,

    enviarUltimoPresupuesto: false,
    enviarUltimoConfirmacion: false,
    enviarUltimoBonoAlojamientos: false,
    enviarUltimoBonoServicios: false,
    enviarUltimoProforma: false,
    enviarUltimoSeguro: false,
    enviarDossier: false,
    enviarTips: false,
    enviarSeguroAnulacion: false,
    enviarAutorizacionTarjeta: false,
    enviarRegistroViajeros: false,
    enviarDatosBanco: false,
    enviarCuestionario: false,

    enviarAdjuntoUltimoPresupuesto: '',
    enviarAdjuntoUltimoConfirmacion: '',
    enviarAdjuntoDossier: '',
    enviarAdjuntoTips: '',
    enviarAdjuntoSeguroAnulacion: '',
    enviarAdjuntoUltimoBonoAlojamientos: '',
    enviarAdjuntoUltimoBonoServicios: '',
    enviarAdjuntoUltimoProforma: '',
    enviarAdjuntoUltimoSeguro: '',
    enviarAdjuntoAutorizacionTarjeta: '',
    enviarAdjuntoRegistroViajeros: '',
    loadingEnviandoCorreo: false,

    enviarListaCorreos: [],
    estadoAccionDeCorreo: null, // 2: Presupuesto, 5: Confirmacion, 6: Documentacion


    servicioNuevoImporte: 0,
    servicioNuevoDescripcion: '',
    servicioNuevoLocalidad: '',
    servicioNuevoLocalidadReferencia: '',
    mostrarReferenciaLocalidad: false,
    servicioNuevoTarifaInd: 0,
    servicioNuevoTarifaDoble: 0,
    servicioNuevoTarifaTriple: 0,
    servicioNuevoCantidadInd: 0,
    servicioNuevoCantidadDoble: 0,
    servicioNuevoCantidadTriple: 0,
    servicioEditarNocheExtraTarifaInd: 0,
    servicioEditarNocheExtraTarifaDoble: 0,
    servicioEditarNocheExtraTarifaTriple: 0,
    servicioEditarNocheExtraCantidadInd: 0,
    servicioEditarNocheExtraCantidadDoble: 0,
    servicioEditarNocheExtraCantidadTriple: 0,

    modelEtapa: null,
    accionEtapa: "",
    dialogFormularioEtapa: false,
    showConfirmacionEliminacionEtapa: false,

    showFechaInicio: false,
    showFechaLlegada: false,
    dialogBusquedaClientes: false,

    infoEtapas: [],
    nuevaNotaInterna: '',

    enviandoDisponibilidad: false,
    showDialogEnviarDisponibilidadATodos: false,
    notaAlojamientosTemporal: '',

    entidadACambiarEstado: null,
    etapaACambiarEstadoId: null,
    avisosEstadoEtapa: {},
    mostrarTodosLosProveedoresPorEtapa: {},

    tab: null, // Para controlar el tab activo
    tabHeaders: ['Datos de Reserva', 'Cliente', 'Servicios', 'Itinerario', 'Historial', 'Pasajeros', 'Archivos', 'Resumen'], // Nombres de los tabs

    modalidadesPagoItems: [
      "Crédito",
      "Crédito 30 días f/fra.",
      "Crédito máximo día 5 mes siguiente f/fra.",
      "Crédito, grupos 25% 45 días antes, 75% 30 días antes (excepto \"OPERATIVA TODAS AGENCIAS\" 30 días antes 100%)",
      "Pago inmediato",
      "Prepago",
    ],
    prepagoTipoDiasItems: ["Naturales", "Laborables"],

    languages: [
      { cod: 'ES', idioma: 'Español' },
      { cod: 'EN', idioma: 'Inglés' },
      { cod: 'DE', idioma: 'Alemán' },
    ],

    headersPresupuestos: [
      { text: "", width: "1%", value: "action2", sortable: false, align: "center", class: "col-compact", cellClass: "col-compact" },
      { text: "", width: "1%", value: "action", sortable: false, align: "center", class: "col-compact", cellClass: "col-compact" },
      { text: "FECHA", align: "left", sortable: false, value: "fecha", width: "1%" },
      { text: "PDF", align: "left", sortable: false, value: "url_pdf" },

    ],
    headersDossierYTips: [
      { text: "", width: "10px", value: "action", sortable: false, align: "center" },
      { text: "DOCUMENTO", align: "left", sortable: false, value: "documento", width: "180px" },
      { text: "IDIOMA", align: "left", sortable: false, value: "idioma", width: "45px" },
      { text: "PDF", align: "left", sortable: false, value: "url_pdf" },
    ],
    headersHistorials: [
      { text: "FECHA", align: "left", sortable: false, value: "fecha", width: "180px" },
      { text: "ACCION", align: "left", sortable: false, value: "accion" },
      { text: "DESCRIPCION", align: "left", sortable: false, value: "descripcion" },
      { text: "TRAB", width: "20px", align: "left", sortable: false, value: "user" },
      { text: "", width: "0px", value: "mensaje", sortable: false, align: "center" },
      { text: "", width: "0px", value: "adjunto", sortable: false, align: "center" },
    ],
    headersHistorialsDisponibilidad: [
      { text: "FECHA", align: "left", sortable: false, value: "created_at", width: "180px" },
      { text: "ACCION", align: "left", sortable: false, value: "accion" },
      { text: "LOCALIDAD", align: "left", sortable: false, value: "etapa_localidad" },
      { text: "DESCRIPCION", align: "left", sortable: false, value: "descripcion" },
      { text: "TRAB", width: "20px", align: "left", sortable: false, value: "user" },
      { text: "", width: "0px", value: "mensaje", sortable: false, align: "center" },
      { text: "", width: "0px", value: "adjunto", sortable: false, align: "center" },
    ],
    headersPasajeros: [
      { text: "NOMBRE", align: "left", sortable: false, value: "nombre" },
      { text: "PRIMER APELLIDO", align: "left", sortable: false, value: "primer_apellido" },
      { text: "SEGUNDO APELLIDO", align: "left", sortable: false, value: "segundo_apellido" },
      { text: "TELEFONO", align: "left", sortable: false, value: "telefono_movil" },
      { text: "ROAMING", align: "left", sortable: false, value: "roaming", width: "200px" },
      { text: "", width: "100px", value: "action", sortable: false, align: "center" },
    ],

    pasajeroNuevo: {
      id: null,
      nombre: '',
      primer_apellido: '',
      segundo_apellido: '',
      tipo_documento: 'DNI',
      numero_documento: '',
      soporte_documento: '',
      parentesco: '',
      poblacion: '',
      provincia: '',
      direccion: '',
      codigo_postal: '',
      email: '',
      fecha_nacimiento: '',

      nacionalidad: '',

      telefono_fijo: '',
      telefono_movil: '',
      sexo: '',
      reserva_id: 0,
      sexo: '',
      telefono_fijo: '',
      telefono_movil: '',
    },
    tipoDeDocumentos: [
      { name: 'DNI', value: 'DNI' },
      { name: 'NIE', value: 'NIE' },
      { name: 'PASAPORTE', value: 'PASAPORTE' },
    ],
    sexos: [
      { name: 'Hombre', value: 'H' },
      { name: 'Mujer', value: 'M' },
    ],

    accion: "editar",

    precio_ind: 0,
    precio_doble: 0,
    precio_triple: 0
  }),

  created() {
    if (!this.isLogged || !this.access_token) {
      this.$router.push("/Login");
      return;
    }

    if (this.estados && this.estados.length == 0) {
      this._getInitialData();
    }
  },



  mounted() {
    this.inputId = this.$route.params.id;
    if (this.inputId > 0) {
      this.accion = "editar";
      this._getReserva();
      this._getProveedoresDeServicios();
    } else {
      this.accion = "crear";
      this._inicializarModelReserva();
      this._aplicarContextoCreacionDesdeRuta();
      this._getCaminos();
      this._getOrigenes();
    }

  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "dificultades",
      "tiposCliente",
      "nacionalidades",
      "provincias",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
      "masterProveedores",
      "isLogged",
    ]),
    ...mapState("reservas", [
      "reservaSelec",
    ]),
    ...mapState("caminos", ["caminos", "caminoSelec"]),
    ...mapState("clientes", ["clientes", "clienteSelec"]),
    ...mapState("origenes", ["origenes", "origenSelec"]),
    ...mapState("estados", ["estados"]),
    ...mapState("proveedores", ["proveedoresServiciosPaqueterias", "proveedoresServiciosGuias", "proveedoresServiciosBodegas", "proveedoresServiciosSeguros", "proveedoresServiciosTransfers"]),

    ...mapGetters("estados", ["getEstadoIdEnProceso", "getEstadoIdConfirmada", "getEstadoIdConfirmacionFinal"]),

    mostrarTabApiCorreos() {
      return Number(this.modelReserva?.estado?.id) >= 5;
    },

    clienteEsViajero() {
      const valor = this.modelReserva?.cliente_es_viajero;
      return valor === true || valor === 1 || valor === "1" || valor === "true";
    },

    valoracionReservaTexto() {
      if (!this.modelReserva || this.modelReserva.valoracion === null || this.modelReserva.valoracion === undefined) {
        return "Sin valorar";
      }

      return `${Number(this.modelReserva.valoracion).toFixed(1).replace(".", ",")} / 10`;
    },

    pasajerosMostrados() {
      const pasajeros = this.modelReserva?.pasajeros || [];
      const clienteEsPasajero = this.modelReserva?.cliente_es_pasajero;
      const valor = clienteEsPasajero === undefined
        ? this.modelReserva?.cliente_es_viajero
        : clienteEsPasajero;
      const clienteNoViaja = valor === false || valor === 0 || valor === "0" || valor === "false";

      return clienteNoViaja ? pasajeros.slice(1) : pasajeros;
    },

    isReservaDeAgencia() {
      return this.modelReserva?.origen?.id !== 1;
    },

    trabajadoresOrigenUno() {
      return this.trabajadores.filter((trabajador) => {
        const origenId = Number(trabajador?.origen?.id ?? trabajador?.origen_id ?? 0);
        return origenId === 1;
      });
    },

    apiCorreosTabIndex() {
      return this.tabHeaders.length;
    },

    // Formatea la fecha de inicio para mostrar en formato dd/mm/yyyy
    fechaInicioFormateada() {
      if (!this.modelReserva.fecha_inicio) return '';
      const [year, month, day] = this.modelReserva.fecha_inicio.split('-');
      return `${day}/${month}/${year}`;
    },

    // Formatea la fecha de llegada para mostrar en formato dd/mm/yyyy
    fechaLlegadaFormateada() {
      if (!this.modelReserva.fecha_llegada) return '';
      const [year, month, day] = this.modelReserva.fecha_llegada.split('-');
      return `${day}/${month}/${year}`;
    },

    fechaLlegadaYaPasada() {
      
      const fechaLlegada = String(this.modelReserva?.fecha_llegada || '');
      const [year, month, day] = fechaLlegada.split('-').map(Number);

      if (!year || !month || !day) return false;

      const llegada = new Date(year, month - 1, day);
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      return llegada < hoy;
    },

    historialsDisponibilidadOrdenados() {
      return this._getHistorialsPorTipoOrdenados('DISPONIBILIDAD');
    },

    historialsAgenciaRutasMeigasOrdenados() {
      return this._getHistorialsPorTipoOrdenados('AGENCIA_RUTASMEIGAS');
    },

    tarifasAlojamientoFechaMostradaItinerario() {
      return this.formatearFechaSinHora(this.tarifasAlojamientoFechaItinerario);
    },

    headersTarifasDialogoItinerario() {
      if (this.tarifasAlojamientoItinerario.some((tarifa) => tarifa?.descripcion != null || tarifa?.unidad != null)) {
        return this.headersTarifasGenericasItinerario;
      }
      if (
        this.tarifasAlojamientoItinerario.some(
          (tarifa) => tarifa?.regimen != null || tarifa?.habitacion_caracteristica != null || tarifa?.precio != null
        )
      ) {
        return this.headersTarifasAlojamientoItinerario;
      }
      return this.headersTarifasAlojamientoItinerario;
    },

    caminos_permitidos() {
      const ordenarCaminos = (items) => {
        return [...items].sort((a, b) => {
          const categoriaA = a?.categoria_id;
          const categoriaB = b?.categoria_id;

          if (categoriaA !== categoriaB) {
            const categoriaANum = Number(categoriaA);
            const categoriaBNum = Number(categoriaB);
            const categoriasSonNumericas = !Number.isNaN(categoriaANum) && !Number.isNaN(categoriaBNum);

            if (categoriasSonNumericas) {
              return categoriaANum - categoriaBNum;
            }

            return String(categoriaA ?? "").localeCompare(String(categoriaB ?? ""), "es", { numeric: true, sensitivity: "base" });
          }

          const subcategoriaA = a?.subcategoria_id;
          const subcategoriaB = b?.subcategoria_id;
          const subcategoriaANull = subcategoriaA === null || subcategoriaA === undefined;
          const subcategoriaBNull = subcategoriaB === null || subcategoriaB === undefined;

          if (subcategoriaANull && !subcategoriaBNull) return 1;
          if (!subcategoriaANull && subcategoriaBNull) return -1;
          if (subcategoriaANull && subcategoriaBNull) return 0;

          const subcategoriaANum = Number(subcategoriaA);
          const subcategoriaBNum = Number(subcategoriaB);
          const subcategoriasSonNumericas = !Number.isNaN(subcategoriaANum) && !Number.isNaN(subcategoriaBNum);

          if (subcategoriasSonNumericas) {
            return subcategoriaANum - subcategoriaBNum;
          }

          return String(subcategoriaA).localeCompare(String(subcategoriaB), "es", { numeric: true, sensitivity: "base" });
        });
      };

      if (this.modelReserva && this.modelReserva.origen && this.modelReserva.origen.caminos_permitidos) {
        try {
          const caminosPermitidos = JSON.parse(this.modelReserva.origen.caminos_permitidos);
          const caminosIds = caminosPermitidos.caminos_id || [];
          const caminosFiltrados = this.caminos.filter(camino => caminosIds.includes(camino.id));
          return ordenarCaminos(caminosFiltrados);
        } catch (error) {
          console.warn('error:', error);
        }
      }

      return ordenarCaminos(this.caminos);
    },

    estadoSeleccionado: {
      get() {
        return this.modelReserva?.estado?.id || null;
      },
      set(estadoId) {
        if (estadoId && this.estados) {
          const estadoEncontrado = this.estados.find(estado => estado.id === estadoId);
          if (estadoEncontrado) {
            this.modelReserva.estado = estadoEncontrado;
          }
        }
      }
    },

    archivosDossierYTips() {
      let res = [];
      if (this.modelReserva && this.modelReserva.camino) {

        const traducciones = {
          'ES': {
            url_pdf: this.modelReserva.camino.link_pdf, url_tips: this.modelReserva.camino.link_tips_camino
          },
          'EN': {
            url_pdf: this.modelReserva.camino.link_pdf_EN, url_tips: this.modelReserva.camino.link_tips_camino_EN
          },
          'DE': {
            url_pdf: this.modelReserva.camino.link_pdf_DE, url_tips: this.modelReserva.camino.link_tips_camino_DE
          },
        }

        if (this.modelReserva.camino.link_pdf) {
          res.push({
            documento: 'DOSSIER',
            idioma: this.modelReserva.language,
            url_pdf: traducciones[this.modelReserva.language].url_pdf
          });
        }

        if (this.modelReserva.camino.link_tips_camino) {
          res.push({
            documento: 'TIPS DEL CAMINO',
            idioma: this.modelReserva.language,
            url_pdf: traducciones[this.modelReserva.language].url_tips
          });
        }

        if (this.modelReserva.link_seguro_anulacion) {
          res.push({
            documento: 'SEGURO DE ANULACIÓN',
            idioma: this.modelReserva.language,
            url_pdf: this.modelReserva.link_seguro_anulacion
          });
        }

        if (this.modelReserva.link_cargo_tarjeta) {
          res.push({
            documento: 'AUTORIZACIÓN CARGO TARJETA',
            idioma: this.modelReserva.language,
            url_pdf: this.modelReserva.link_cargo_tarjeta
          });
        }



        return res;
      }
    },

    getImporteServicios() {
      var importe = 0;
      if (this.modelReserva && this.modelReserva.servicios) {
        for (let servicio of this.modelReserva.servicios) {
          if (this.esDescuentoReserva(servicio)) {
            continue;
          }
          importe += Number(servicio.importe);
        }
      }
      return parseFloat(importe).toFixed(2);
    },

    serviciosDescuentoReserva() {
      if (!Array.isArray(this.modelReserva?.servicios)) {
        return [];
      }
      return this.modelReserva.servicios.filter(
        (servicio) => servicio.esta_incluido == 0 && this.esDescuentoReserva(servicio)
      );
    },

    getImporteDescuentosReserva() {
      return this.serviciosDescuentoReserva.reduce(
        (importe, servicio) => importe + Number(servicio.importe || 0),
        0
      );
    },

    getImporteReservaParaMostrar() {
      return Number(this.modelReserva?.importe_reserva || 0) + this.getImporteDescuentosReserva;
    },

    getDescripcionImporteReservaParaMostrar() {
      const descripcionReserva = this.modelReserva?.descripcion_importe_reserva || '';
      const descuentos = this.serviciosDescuentoReserva
        .map((servicio) => [
          `• ${servicio.titulo} ..... ${Number(servicio.importe || 0).toFixed(2)} €`,
          servicio.descripcion || '',
        ].filter(Boolean).join('\n'))
        .join('\n');

      return [descripcionReserva, descuentos].filter(Boolean).join('\n');
    },

    tieneServiciosExtras() {
      return Array.isArray(this.modelReserva?.servicios) &&
        this.modelReserva.servicios.some(servicio => servicio.esta_incluido == 0);
    },

    tieneServiciosParaMostrar() {
      return Array.isArray(this.modelReserva?.servicios) &&
        this.modelReserva.servicios.some(
          (servicio) => servicio.esta_incluido == 0 && !this.esDescuentoReserva(servicio)
        );
    },

    listadoPuntosFinales() {
      const res = [];
      if (this.modelReserva && this.modelReserva.camino) {
        for (let etapa of this.modelReserva.camino.etapas) {
          res.push(etapa.final_punto.nombre);
        }
      }
      return res;
    },



    servicioNuevoTituloParaGuardar() {
      /* if (this.servicioNuevoSeleccionado &&
         (this.servicioNuevoSeleccionado.titulo.includes('Traslados extra') ||
           this.servicioNuevoSeleccionado.titulo.includes('Servicios extra'))) {
         return (this.modelReserva.language == 'EN' ? this.servicioNuevoSeleccionado.titulo_EN : (this.modelReserva.language == 'DE' ? this.servicioNuevoSeleccionado.titulo_DE : this.servicioNuevoSeleccionado.titulo))
           + ': ' + this.servicioNuevoDescripcion;
       }*/

      if (this.servicioNuevoSeleccionado &&
        !this.servicioEsNocheExtra(this.servicioNuevoSeleccionado)) {
        return (this.modelReserva.language == 'EN' ? this.servicioNuevoSeleccionado.titulo_EN : (this.modelReserva.language == 'DE' ? this.servicioNuevoSeleccionado.titulo_DE : this.servicioNuevoSeleccionado.titulo));
      }

      if (this.servicioNuevoSeleccionado &&
        this.servicioEsNocheExtra(this.servicioNuevoSeleccionado)) {

        return (this.modelReserva.language == 'EN' ? this.servicioNuevoSeleccionado.titulo_EN + ' in ' : (this.modelReserva.language == 'DE' ? this.servicioNuevoSeleccionado.titulo_DE + ' in ' : this.servicioNuevoSeleccionado.titulo + ' en '))
          + this.servicioNuevoLocalidad;
      }

      return '';
    },

    servicioNuevoTituloImporteParaGuardar() {
      if (this.servicioNuevoSeleccionado &&
        (this.servicioNuevoSeleccionado.titulo.includes('Traslados extra') ||
          this.servicioNuevoSeleccionado.titulo.includes('Servicios extra'))) {
        return '• ' +
          (this.modelReserva.language == 'EN' ? this.servicioNuevoSeleccionado.titulo_EN : (this.modelReserva.language == 'DE' ? this.servicioNuevoSeleccionado.titulo_DE : this.servicioNuevoSeleccionado.titulo))
          + ': ' + this.servicioNuevoDescripcion
          + ' ..... ' + Number(this.servicioNuevoImporte).toFixed(2) + ' €';
      }

      if (this.servicioNuevoSeleccionado &&
        !this.servicioEsNocheExtra(this.servicioNuevoSeleccionado)) {
        return '• ' +
          (this.modelReserva.language == 'EN' ? this.servicioNuevoSeleccionado.titulo_EN : (this.modelReserva.language == 'DE' ? this.servicioNuevoSeleccionado.titulo_DE : this.servicioNuevoSeleccionado.titulo))
          + ' ..... ' + Number(this.servicioNuevoImporte).toFixed(2) + ' €';
      }

      if (this.servicioNuevoSeleccionado &&
        this.servicioEsNocheExtra(this.servicioNuevoSeleccionado)) {
        const importeEstaNocheExtra = this._getImporteNocheExtraConTarifas(
          this.servicioNuevoTarifaInd,
          this.servicioNuevoTarifaDoble,
          this.servicioNuevoTarifaTriple,
          this.servicioNuevoCantidadInd,
          this.servicioNuevoCantidadDoble,
          this.servicioNuevoCantidadTriple
        );

        this.servicioNuevoImporte = importeEstaNocheExtra;

        return '• ' +
          (this.modelReserva.language == 'EN' ? this.servicioNuevoSeleccionado.titulo_EN + ' in ' : (this.modelReserva.language == 'DE' ? this.servicioNuevoSeleccionado.titulo_DE + ' in ' : this.servicioNuevoSeleccionado.titulo + ' en '))
          + this.servicioNuevoLocalidad
          + ' ..... ' + Number(importeEstaNocheExtra).toFixed(2) + ' €';
      }

      return '';
    },

    servicioNuevoDescripcionParaGuardar() {
      if (this.servicioNuevoSeleccionado &&
        (this.servicioNuevoSeleccionado.titulo.includes('Traslado privado a') ||
          this.servicioNuevoSeleccionado.titulo.includes('Traslado privado de'))) {
        return '(' + this.servicioNuevoDescripcion + ')';
      }

      /*if (this.servicioNuevoSeleccionado &&
        (this.servicioNuevoSeleccionado.titulo.includes('Traslados extra') ||
          this.servicioNuevoSeleccionado.titulo.includes('Servicios extra'))) {
        return '';
      }*/

      if (this.servicioNuevoSeleccionado &&
        this.servicioEsNocheExtra(this.servicioNuevoSeleccionado)) {
        return this._getDescripcionNocheExtraConTarifas(
          this.servicioNuevoTarifaInd,
          this.servicioNuevoTarifaDoble,
          this.servicioNuevoTarifaTriple,
          this.servicioNuevoCantidadInd,
          this.servicioNuevoCantidadDoble,
          this.servicioNuevoCantidadTriple
        );
      }

      return this.servicioNuevoDescripcion;
    },

    getImporteTotal() {
      return parseFloat(Number(this.getImporteReservaParaMostrar) + Number(this.getImporteServicios)).toFixed(2);
    },

    comisionAgenciaPorcentaje() {
      return Number(this.modelReserva?.origen?.comision || 0);
    },

    importeComisionAgencia() {
      return this.getImporteReservaParaMostrar * this.comisionAgenciaPorcentaje / 100;
    },

    importeNetoAgencia() {
      return this.getImporteReservaParaMostrar - this.importeComisionAgencia;
    },

    totalVentaResumen() {
      return getTotalVentaResumenHelper(this.modelReserva);
    },

    totalCosteResumen() {
      return getTotalCosteResumenHelper(this.modelReserva);
    },

    gananciaResumen() {
      return getGananciaResumenHelper(this.modelReserva);
    },

    porcientoVentaCosteResumen() {
      return getPorcentajeVentaCosteHelper(this.modelReserva);
    },

    getDescripcionImporteServicios() {
      var descripcion = '';

      for (let servicio of this.modelReserva.servicios.filter(servicio =>
        servicio.esta_incluido == 0 && !this.esDescuentoReserva(servicio)
      )) {
        const titulo = this.getTituloServicioNormalizado(servicio);
        const esTrasladoExtra = [
          'traslados extra',
          'extra transfers',
          'zusätzliche transfers',
        ].some((tituloTraslado) => titulo.startsWith(tituloTraslado));

        if (esTrasladoExtra || this.esServicioServiciosExtra(servicio)) {
          descripcion += '• ' + servicio.titulo + ': ' + servicio.descripcion + ' ..... ' + Number(servicio.importe).toFixed(2) + ' €<br>';
        } else {

          /*  if (servicio.titulo == 'Servicios extra') {
              descripcion += servicio.descripcion + '<br>';
            } else*/

          /* if (this.servicioEsNocheExtra(servicio)) {
             descripcion += servicio.descripcion + '<br>';
           } else {*/
          descripcion += '• ' + servicio.titulo + ' ..... ' + Number(servicio.importe).toFixed(2) + ' €<br>';
          descripcion += servicio.descripcion + '<br>';
        }



      }
      descripcion += '<br>';


      return descripcion;
    },

    traducciones() {
      return {
        'ES': {
          pendiente: 'Pendiente de tarifa',
          personas: 'personas',
          // otras traducciones...
        },
        'EN': {
          pendiente: 'Pending',
          personas: 'pilgrims',
          // otras traducciones...
        },
        'DE': {
          pendiente: 'Ausstehend',
          personas: 'Pilger/innen',
          // otras traducciones...
        }
      };
    },

    textoPendiente() {
      const language = this.modelReserva?.language || 'ES';
      return this.traducciones[language]?.pendiente || this.traducciones['ES'].pendiente;
    },

    textoPersonas() {
      const language = this.modelReserva?.language || 'ES';
      return this.traducciones[language]?.personas || this.traducciones['ES'].personas;
    },

    existPresupuesto() {
      return this.modelReserva && this.modelReserva.presupuestos && this.modelReserva.presupuestos.length > 0;
    },

    mostrarBotonEnviarPresupuesto() {
      const estadoReserva = this.modelReserva?.estado?.estado;
      return estadoReserva === 'SOLICITADA' || estadoReserva === 'PRESUPUESTADA';
    },

    tieneRoaming() {
      return Boolean(this.modelReserva && this.modelReserva.roaming);
    },

    existConfirmacion() {
      return this.modelReserva && this.modelReserva.confirmaciones && this.modelReserva.confirmaciones.length > 0;
    },

    existTips() {
      return this.archivosDossierYTips && this.archivosDossierYTips.some(item => item.documento == 'TIPS DEL CAMINO');
    },

    existSeguroAnulacion() {
      return this.archivosDossierYTips && this.archivosDossierYTips.some(item => item.documento == 'SEGURO DE ANULACIÓN');
    },

    existDossier() {
      return this.archivosDossierYTips && this.archivosDossierYTips.some(item => item.documento == 'DOSSIER');
    },

    existUltimoBonoAlojamientos() {
      return this.modelReserva && this.modelReserva.bonos_alojamientos && this.modelReserva.bonos_alojamientos.length > 0;
    },

    existUltimoBonoServicios() {
      return this.modelReserva && this.modelReserva.bonos_servicios && this.modelReserva.bonos_servicios.length > 0;
    },

    existUltimoProforma() {
      return this.modelReserva && this.modelReserva.proformas && this.modelReserva.proformas.length > 0;
    },

    existUltimoSeguro() {
      return this.modelReserva && this.modelReserva.seguros && this.modelReserva.seguros.length > 0;
    },

    allEtapasConfirmadas() {
      let res = true;
      for (let etapa of this.modelReserva.etapas) {
        if (this.modelReserva.camino.con_etapa_final == 1 && etapa.inicio_punto_id != etapa.final_punto_id && etapa.pivot.proveedor_id == null) {
          return false;
        }
      }
      return res;
    },

    /* estadoReservaDocumentacionFinal() {
       return this.allEtapasConfirmadas &&
         this.modelReserva?.confirmaciones && this.modelReserva.confirmaciones.length > 0; //&& this.fechaInicioEnProximos10Dias;
     },*/

    fechaInicioEnProximos10Dias() {
      if (!this.modelReserva?.fecha_inicio) return false;

      const fechaInicio = new Date(this.modelReserva.fecha_inicio);
      const hoy = new Date();
      const en10Dias = new Date();
      en10Dias.setDate(hoy.getDate() + 10);

      return fechaInicio >= hoy && fechaInicio <= en10Dias;
    },

    proveedorAnteriorCambioEtapa() {
      return this.cambioProveedorEtapaPendiente?.proveedorAnteriorNombre || 'actual';
    }



  },

  watch: {
    modelReserva: {
      handler(newVal) {
        if (newVal && !Object.prototype.hasOwnProperty.call(newVal, "codigo_agencia")) {
          this.$set(newVal, "codigo_agencia", null);
        }
      },
      immediate: true,
    },
    "modelReserva.notas_internas": {
      handler(newVal) {
        this.sincronizarNotasInternasEditables(newVal);
      },
      immediate: true,
    },
    mostrarTabApiCorreos(newVal) {
      if (!newVal && this.tab === this.apiCorreosTabIndex) {
        this.tab = 0;
      }
    },
    enviarTips(newVal) {
      if (this.estadoAccionDeCorreo == 5) {
        const textos = {
          ES: '- <b>Tips para el Camino</b>',
          EN: '- <b>Tips for the Camino</b>',
          DE: '- <b>Tipps für den Jakobsweg</b>'
        };
        const patrones = {
          ES: /Además, os adjunto lo siguiente:/i,
          EN: /Additionally, I am attaching the following:/i,
          DE: /Zusätzlich füge ich Folgendes bei:/i
        };

        const language = this.modelReserva?.language || 'ES';
        const texto = textos[language];
        const patron = patrones[language];

        if (newVal) {
          const existeAlgunTexto = Object.values(textos).some(t => this.enviarTextoMensaje.includes(t));

          if (!existeAlgunTexto) {
            if (patron.test(this.enviarTextoMensaje)) {
              this.enviarTextoMensaje = this.enviarTextoMensaje.replace(
                patron,
                (match) => `${match}\n ${texto}`
              );
            } else {
              this.enviarTextoMensaje += `\n${texto}`;
            }
          }
        } else {
          Object.values(textos).forEach(t => {
            const regex = new RegExp(`\\n?\\s*${t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g');
            this.enviarTextoMensaje = this.enviarTextoMensaje.replace(regex, '');
          });
        }
      }
    },

    enviarDatosBanco(newVal) {
      if (this.estadoAccionDeCorreo != 5) return;

      const textos = {
        ES: 'TITULAR DE LA CUENTA: RUTAS MEIGAS SL\nENTIDAD BANCARIA: Banco Sabadell\nIBAN: ES38 0081 0499 6400 0188 1494\nBIC: BSABESBB\n',
        EN: 'ACCOUNT HOLDER: RUTAS MEIGAS SL\nBANK: Banco Sabadell\nIBAN: ES38 0081 0499 6400 0188 1494\nBIC: BSABESBB\n',
        DE: 'KONTOINHABER: RUTAS MEIGAS SL\nBANK: Banco Sabadell\nIBAN: ES38 0081 0499 6400 0188 1494\nBIC: BSABESBB\n'
      };
      const textosLegacy = [
        'Banco Sabadell\nIBAN: ES38 0081 0499 6400 0188 1494',
        'Bank Sabadell\nIBAN: ES38 0081 0499 6400 0188 1494'
      ];
      const patrones = {
        ES: /El resto del pago lo tenéis que hacer 10 días antes de comenzar el camino\./i,
        EN: /The remaining payment must be made 10 days before starting the Camino\./i,
        DE: /Die Restzahlung muss 10 Tage vor Beginn des Jakobswegs erfolgen\./i
      };

      const language = this.modelReserva?.language || 'ES';
      const texto = textos[language] || textos.ES;
      const patron = patrones[language] || patrones.ES;

      const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const buildBlockRegex = (bloque) => {
        const pattern = bloque
          .split('\n')
          .map(line => `\\s*${escapeRegExp(line)}\\s*`)
          .join('\\n');
        return new RegExp(`\\n{0,2}${pattern}\\n{0,2}`, 'gi');
      };

      const limpiarBloquesBancarios = () => {
        const bloques = [...new Set([...Object.values(textos), ...textosLegacy])];
        bloques.forEach((bloque) => {
          this.enviarTextoMensaje = this.enviarTextoMensaje.replace(buildBlockRegex(bloque), '\n');
        });
        this.enviarTextoMensaje = this.enviarTextoMensaje.replace(/\n{3,}/g, '\n\n');
      };

      if (newVal) {
        limpiarBloquesBancarios();
        if (patron.test(this.enviarTextoMensaje)) {
          this.enviarTextoMensaje = this.enviarTextoMensaje.replace(
            patron,
            (match) => `${match}\n\n${texto}`
          );
        } else {
          this.enviarTextoMensaje = `${this.enviarTextoMensaje}\n\n${texto}`;
        }
        this.enviarTextoMensaje = this.enviarTextoMensaje.replace(/\n{3,}/g, '\n\n');
      } else {
        limpiarBloquesBancarios();
      }
    },

    enviarRegistroViajeros(newVal) {
      if (this.estadoAccionDeCorreo != 5 && this.estadoAccionDeCorreo != 6) return;

      const textos = {
        ES: '- <b>Registro de viajeros</b>',
        EN: '- <b>Traveler Registration Form</b>',
        DE: '- <b>Reiseanmeldeformular</b>'
      };

      const patrones = {
        ES: /Además, os adjunto lo siguiente:/i,
        EN: /Additionally, I am attaching the following:/i,
        DE: /Zusätzlich füge ich Folgendes bei:/i
      };

      const language = this.modelReserva?.language || 'ES';
      const texto = textos[language];
      const patron = patrones[language];

      if (newVal) {
        const existeAlgunTexto = Object.values(textos).some(t => this.enviarTextoMensaje.includes(t));

        if (!existeAlgunTexto) {
          if (patron.test(this.enviarTextoMensaje)) {
            this.enviarTextoMensaje = this.enviarTextoMensaje.replace(
              patron,
              (match) => `${match}\n ${texto}`
            );
          } else {
            this.enviarTextoMensaje += `\n${texto}`;
          }
        }
      } else {
        Object.values(textos).forEach(t => {
          const regex = new RegExp(`\\n?\\s*${t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g');
          this.enviarTextoMensaje = this.enviarTextoMensaje.replace(regex, '');
        });
      }
    },

    enviarAutorizacionTarjeta(newVal) {
      if (this.estadoAccionDeCorreo != 5 && this.estadoAccionDeCorreo != 6) return;

      const textos = {
        ES: '- <b>Autorización cargo tarjeta de crédito (VISA O MASTER CARD)</b>',
        EN: '- <b>Credit Card Charge Authorization (VISA OR MASTER CARD)</b>',
        DE: '- <b>Kreditkartenabbuchungsermächtigung (VISA ODER MASTER CARD)</b>'
      };

      const patrones = {
        ES: /Además, os adjunto lo siguiente:/i,
        EN: /Additionally, I am attaching the following:/i,
        DE: /Zusätzlich füge ich Folgendes bei:/i
      };

      const language = this.modelReserva?.language || 'ES';
      const texto = textos[language];
      const patron = patrones[language];

      if (newVal) {
        const existeAlgunTexto = Object.values(textos).some(t => this.enviarTextoMensaje.includes(t));

        if (!existeAlgunTexto) {
          if (patron.test(this.enviarTextoMensaje)) {
            this.enviarTextoMensaje = this.enviarTextoMensaje.replace(
              patron,
              (match) => `${match}\n ${texto}`
            );
          } else {
            this.enviarTextoMensaje += `\n${texto}`;
          }
        }
      } else {
        Object.values(textos).forEach(t => {
          const regex = new RegExp(`\\n?\\s*${t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g');
          this.enviarTextoMensaje = this.enviarTextoMensaje.replace(regex, '');
        });
      }
    }


  },
  methods: {
    ...mapActions("reservas", ["getReservas", "crearReserva", "updateReserva", "getReserva", "guardarServiciosReserva",
      "eliminarServicioReserva", "agregarServicioReserva", "generarNuevoPresupuesto", "updateServiciosIncCancelados",
      "updateProveedorEtapa", "getHistorialByReserva", "updateItinerarioAMedida", "eliminarEtapas", "enviarCorreo", "enviarCorreoProveedor",
      "actualizarEtapasPorCambiodeCamino", "crearPasajeros", "eliminarPasajero", "updatePasajero", "generarNuevaConfirmacion",
      "generarBonosAlojamientos", "generarBonosServicios", "generarProforma", "subirSeguro", "updateNotaExtraEtapa", "updateTarifasEtapa",
      "agregarNotaInterna", "updateEstadoReserva", "updateEstadoEtapa", "getTrabajadores", "cambiarTrabajadorAsignado", "solicitarDisponibilidad",
      "enviarDocumentoACliente",
      "enviarDisponibilidadATodos", "eliminarPresupuesto", "updateReservaServicioFecha", "asignarPasajeroHabitacion",
      "updateClienteEsViajero"]),
    ...mapMutations("reservas", ["setReservaSelec"]),
    ...mapActions("caminos", ["getCaminos"]),
    ...mapActions("clientes", ["getClientes"]),
    ...mapActions("origenes", ["getOrigenes"]),
    ...mapMutations("caminos", ["setCaminoSelec"]),
    ...mapMutations("auth", ["addMasterProveedor"]),
    ...mapActions("auth", ["getInitialData"]),
    ...mapActions("proveedores", ["getProveedoresDeServicios", "getProveedor", "getTarifasProveedorPorFecha", "getMaestrasProveedores"]),
    formatearImporte,
    formatearImporteEnTexto,

    _actualizarValoracionReserva(valoracion) {
      if (this.modelReserva) {
        this.$set(this.modelReserva, "valoracion", valoracion);
      }
    },

    _getHistorialsPorTipoOrdenados(tipo) {
      if (!this.modelReserva?.historials) return [];
      const res = this.modelReserva.historials
        .filter(item => item.tipo === tipo)
        .slice()
        .sort((a, b) => {
          const etapaOrdenA = Number(a?.etapa_orden);
          const etapaOrdenB = Number(b?.etapa_orden);
          const ordenA = Number.isNaN(etapaOrdenA) ? Number.POSITIVE_INFINITY : etapaOrdenA;
          const ordenB = Number.isNaN(etapaOrdenB) ? Number.POSITIVE_INFINITY : etapaOrdenB;

          if (ordenA !== ordenB) {
            return ordenA - ordenB;
          }

          const createdAtA = a?.created_at || '';
          const createdAtB = b?.created_at || '';
          return createdAtA.localeCompare(createdAtB);
        });
      return res;
    },

    mostrarAccionesMenuEtapa(etapa) {
      return this.getAccionesMenuEtapa(etapa).length > 0;
    },

    getAccionesMenuEtapa(etapa) {
      if (!this.etapaTieneProveedorMenu(etapa)) {
        return [];
      }

      const acciones = [
        { key: "enviar_correo_etapa", label: "Enviar Correo" },
      ];

      if (this.getProveedorMenuEtapa(etapa)?.id) {
        acciones.push({ key: "ver_tarifas_alojamiento", label: "Ver Tarifas" });
        acciones.push({ key: "ver_ficha_alojamiento", label: "Ver Ficha del alojamiento" });
      }

      return acciones;
    },

    onAccionMenuEtapa(etapa, accion) {
      if (accion === "enviar_correo_etapa") {
        this.abrirDialogEnviarCorreoEtapa(etapa);
        return;
      }
      if (accion === "ver_tarifas_alojamiento") {
        this.onVerTarifasAlojamientoEtapa(etapa);
        return;
      }
      if (accion === "ver_ficha_alojamiento") {
        this.onVerFichaAlojamientoEtapa(etapa);
      }
    },

    etapaTieneProveedorMenu(etapa) {
      const proveedor = this.getProveedorMenuEtapa(etapa);
      return Boolean(
        proveedor?.id ||
        String(proveedor?.nombre_alias || proveedor?.nombre || "").trim() ||
        String(proveedor?.email_reservas || proveedor?.email || "").trim()
      );
    },

    getProveedorMenuEtapa(etapa) {
      const proveedorActual = this.getProveedorActualEtapa(etapa);
      const emailEtapa = etapa?.pivot?.proveedor_email || "";
      const proveedorId = etapa?.pivot?.proveedor_id || proveedorActual?.id || null;
      const proveedorMaestro = proveedorId
        ? this.masterProveedores.find((item) => item.id == proveedorId)
        : null;

      if (proveedorMaestro) {
        return {
          ...proveedorMaestro,
          email_reservas: proveedorMaestro.email_reservas || emailEtapa,
          email: proveedorMaestro.email || emailEtapa,
        };
      }

      if (proveedorActual && typeof proveedorActual === "object") {
        return {
          ...proveedorActual,
          email_reservas: proveedorActual.email_reservas || emailEtapa,
          email: proveedorActual.email || emailEtapa,
        };
      }

      const nombre = typeof proveedorActual === "string"
        ? proveedorActual
        : (etapa?.pivot?.proveedor_nombre || "");

      if (!nombre && !emailEtapa && !etapa?.pivot?.proveedor_id) {
        return null;
      }

      return {
        id: etapa?.pivot?.proveedor_id || null,
        nombre_alias: nombre,
        nombre,
        email_reservas: emailEtapa,
        email: emailEtapa,
      };
    },

    getNombreProveedorMenuEtapa(etapa, proveedor = null) {
      const proveedorEtapa = proveedor || this.getProveedorMenuEtapa(etapa);
      return (
        proveedorEtapa?.nombre_alias ||
        proveedorEtapa?.nombre ||
        etapa?.pivot?.proveedor_nombre ||
        ""
      );
    },

    getEmailsProveedorMenuEtapa(etapa, proveedor = null) {
      const proveedorEtapa = proveedor || this.getProveedorMenuEtapa(etapa);
      const correos = [];

      if (proveedorEtapa?.email_reservas) {
        correos.push(...String(proveedorEtapa.email_reservas).split(/[;,]/));
      }
      if (proveedorEtapa?.email) {
        correos.push(...String(proveedorEtapa.email).split(/[;,]/));
      }
      if (etapa?.pivot?.proveedor_email) {
        correos.push(...String(etapa.pivot.proveedor_email).split(/[;,]/));
      }

      return [...new Set(correos.map((email) => String(email || "").trim()).filter(Boolean))];
    },

    getListaCorreosUsuario() {
      const correos = [];
      if (this.user?.email) {
        correos.push(this.user.email);
      }
      if (this.user?.lista_emails) {
        correos.push(...String(this.user.lista_emails).split(";"));
      }
      return [...new Set(correos.map((email) => String(email || "").trim()).filter(Boolean))];
    },

    getAsuntoCorreoEtapa(etapa, proveedor = null) {
      const proveedorNombre = this.getNombreProveedorMenuEtapa(etapa, proveedor);
      return [this.modelReserva?.codigo || "", `Alojamiento - ${proveedorNombre || ""}`.trim()]
        .filter(Boolean)
        .join(" - ");
    },

    getTextoCorreoEtapa(etapa, proveedor = null) {
      const proveedorNombre = this.getNombreProveedorMenuEtapa(etapa, proveedor);
      const cliente = [this.modelReserva?.cliente?.nombre, this.modelReserva?.cliente?.apellidos]
        .filter(Boolean)
        .join(" ");

      return [
        proveedorNombre ? `Hola ${proveedorNombre},` : "Hola,",
        "",
        `Te contactamos por la reserva ${this.modelReserva?.codigo || ""}${cliente ? ` de ${cliente}` : ""}.`,
        etapa?.pivot?.fecha ? `Fecha: ${this.formatearFechaSinHora(etapa.pivot.fecha)}.` : "",
      ]
        .filter(Boolean)
        .join("\n");
    },

    puedeEnviarCorreoEtapa() {
      return Boolean(
        this.enviarCorreoEtapaDe &&
        this.enviarCorreoEtapaPara &&
        this.enviarCorreoEtapaAsunto
      );
    },

    cerrarDialogEnviarCorreoEtapa() {
      this.showDialogEnviarCorreoEtapa = false;
      this.loadingEnviandoCorreoEtapa = false;
      this.etapaCorreoSeleccionada = null;
      this.proveedorCorreoEtapaSeleccionado = null;
      this.enviarCorreoEtapaListaCorreos = [];
      this.enviarCorreoEtapaDe = "";
      this.enviarCorreoEtapaParaOptions = [];
      this.enviarCorreoEtapaPara = "";
      this.enviarCorreoEtapaCC = "";
      this.enviarCorreoEtapaAsunto = "";
      this.enviarCorreoEtapaTexto = "";
    },

    abrirDialogEnviarCorreoEtapa(etapa) {
      const proveedor = this.getProveedorMenuEtapa(etapa);
      const correosUsuario = this.getListaCorreosUsuario();
      const correosProveedor = this.getEmailsProveedorMenuEtapa(etapa, proveedor);
      const correoReservas = String(proveedor?.email_reservas || "")
        .split(/[;,]/)
        .map((email) => String(email || "").trim())
        .filter(Boolean)[0] || "";

      this.etapaCorreoSeleccionada = etapa;
      this.proveedorCorreoEtapaSeleccionado = proveedor;
      this.enviarCorreoEtapaListaCorreos = correosUsuario;
      this.enviarCorreoEtapaDe = correosUsuario[0] || this.user?.email || "";
      this.enviarCorreoEtapaCC = this.user?.email || this.enviarCorreoEtapaDe || "";
      this.enviarCorreoEtapaParaOptions = correosProveedor;
      this.enviarCorreoEtapaPara = correoReservas || correosProveedor[0] || "";
      this.enviarCorreoEtapaAsunto = this.getAsuntoCorreoEtapa(etapa, proveedor);
      this.enviarCorreoEtapaTexto = this.getTextoCorreoEtapa(etapa, proveedor);
      this.showDialogEnviarCorreoEtapa = true;
    },

    async enviarCorreoProveedorEtapa() {
      if (!this.puedeEnviarCorreoEtapa() || this.loadingEnviandoCorreoEtapa || !this.etapaCorreoSeleccionada) {
        return;
      }

      const proveedorSeleccionado = this.proveedorCorreoEtapaSeleccionado || {};
      const proveedorId = proveedorSeleccionado?.id || this.etapaCorreoSeleccionada?.pivot?.proveedor_id || null;
      const proveedorNombre = this.getNombreProveedorMenuEtapa(this.etapaCorreoSeleccionada, proveedorSeleccionado) || null;

      this.loadingEnviandoCorreoEtapa = true;
      try {
        const res = await this.enviarCorreoProveedor([
          this.access_token,
          this.modelReserva.id,
          this.enviarCorreoEtapaDe,
          this.enviarCorreoEtapaPara,
          this.enviarCorreoEtapaCC,
          this.enviarCorreoEtapaAsunto,
          this.enviarCorreoEtapaTexto,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          null,
          proveedorId,
          proveedorNombre,
        ]);

        if (res && res.id == this.modelReserva.id) {
          this.modelReserva = res;
          this.sincronizarProveedoresEtapa();
        }

        this.cerrarDialogEnviarCorreoEtapa();
      } finally {
        this.loadingEnviandoCorreoEtapa = false;
      }
    },

    async onVerFichaAlojamientoEtapa(etapa) {
      const proveedor = this.getProveedorMenuEtapa(etapa);
      if (!proveedor?.id) {
        return;
      }

      const proveedorCompleto = await this.getProveedor([this.access_token, proveedor.id, false]);
      this.modelProveedor = JSON.parse(JSON.stringify(proveedorCompleto || proveedor));
      this.dialogFormularioProveedor = true;
    },

    cerrarDialogProveedorItinerario() {
      this.dialogFormularioProveedor = false;
      this.modelProveedor = null;
    },

    getFechaEtapaIsoItinerario(etapa) {
      const fecha = etapa?.pivot?.fecha || etapa?.fecha || "";
      if (/^\d{4}-\d{2}-\d{2}/.test(fecha)) {
        return fecha.slice(0, 10);
      }

      const date = new Date(fecha);
      if (Number.isNaN(date.getTime())) {
        return "";
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    async onVerTarifasAlojamientoEtapa(etapa) {
      const proveedor = this.getProveedorMenuEtapa(etapa);
      const fecha = this.getFechaEtapaIsoItinerario(etapa);

      if (!proveedor?.id || !fecha) {
        return;
      }

      this.loadingTarifasAlojamientoItinerario = true;
      this.tarifasAlojamientoItinerario = [];
      this.tarifasAlojamientoProveedorIdItinerario = proveedor.id;
      this.tarifasAlojamientoProveedorItinerario = this.getNombreProveedorMenuEtapa(etapa, proveedor);
      this.tarifasAlojamientoFechaItinerario = fecha;
      this.showDialogTarifasAlojamientoItinerario = true;

      try {
        await this.cargarTarifasAlojamientoItinerario();
      } finally {
        this.loadingTarifasAlojamientoItinerario = false;
      }
    },

    async cargarTarifasAlojamientoItinerario() {
      if (!this.tarifasAlojamientoProveedorIdItinerario || !this.tarifasAlojamientoFechaItinerario) {
        this.tarifasAlojamientoItinerario = [];
        return;
      }

      const response = await this.getTarifasProveedorPorFecha([
        this.access_token,
        this.tarifasAlojamientoProveedorIdItinerario,
        this.tarifasAlojamientoFechaItinerario,
        false,
      ]);

      this.tarifasAlojamientoItinerario = Array.isArray(response?.tarifas) ? response.tarifas : [];
    },

    async onCambiarFechaTarifasAlojamientoItinerario(fecha) {
      this.tarifasAlojamientoFechaItinerario = fecha || "";
      this.menuFechaTarifasAlojamientoItinerario = false;
      this.loadingTarifasAlojamientoItinerario = true;

      try {
        await this.cargarTarifasAlojamientoItinerario();
      } finally {
        this.loadingTarifasAlojamientoItinerario = false;
      }
    },

    cerrarDialogTarifasAlojamientoItinerario() {
      this.showDialogTarifasAlojamientoItinerario = false;
      this.loadingTarifasAlojamientoItinerario = false;
      this.tarifasAlojamientoItinerario = [];
      this.tarifasAlojamientoProveedorIdItinerario = null;
      this.tarifasAlojamientoProveedorItinerario = "";
      this.tarifasAlojamientoFechaItinerario = "";
      this.menuFechaTarifasAlojamientoItinerario = false;
    },

    isTabDisabled(tabIndex) {
      if (this.accion == "editar") {
        return false;
      } else if (tabIndex > 1) {
        return true;
      }

      return false;
    },

    async _refrescarReserva() {
      const tabActual = this.tab;
      this.inputId = this.$route.params.id;
      if (this.inputId > 0) {
        this.accion = "editar";
        await this._getReserva();
        await this._getProveedoresDeServicios();
      } else {
        this.accion = "crear";
        this._inicializarModelReserva();
        this._aplicarContextoCreacionDesdeRuta();
        await this._getCaminos();
        await this._getOrigenes();
      }
      this.tab = tabActual;
      if (typeof tabActual === "number") {
        this.onTabChange(tabActual);
      }
    },

    async _getProveedoresDeServicios() {
      await this.getProveedoresDeServicios([this.access_token]);
    },

    _obtenerListaCorreosUsuario() {
      const correos = [];
      if (this.user?.email) {
        correos.push(this.user.email);
      }
      if (this.user?.lista_emails) {
        correos.push(
          ...this.user.lista_emails
            .split(';')
            .map(email => email.trim())
            .filter(email => email.length > 0)
        );
      }
      return [...new Set(correos)];
    },

    _mostrarDialogEnviarDocumentoCliente(item) {
      this.documentoClienteSeleccionado = item;
      this.enviarListaCorreos = this._obtenerListaCorreosUsuario();
      this.enviarDocumentoClienteDe = this.user?.email || '';
      this.enviarDocumentoClientePara = this.modelReserva?.cliente?.email || '';
      this.enviarDocumentoClienteCC = this.user?.email || '';

      const nombreDocumento = item?.documento || this.getNombreArchivo(item?.url_pdf) || 'Documento';
      const clienteNombre = this.modelReserva?.cliente?.nombre;

      this.enviarDocumentoClienteAsunto = `${this.modelReserva?.codigo || ''} - ${nombreDocumento}`.trim();
      this.enviarDocumentoClienteTexto = [
        clienteNombre ? `Hola ${clienteNombre},` : 'Hola,',
        '',
        `Te enviamos adjunto el Bono ${nombreDocumento}${this.modelReserva?.codigo ? ` de la reserva ${this.modelReserva.codigo}` : ''}.`,
        '',
        'Un saludo.',
      ].join('\n');

      this.showDialogEnviarDocumentoCliente = true;
    },

    _cerrarDialogEnviarDocumentoCliente() {
      if (this.loadingEnviandoDocumentoCliente) {
        return;
      }

      this.showDialogEnviarDocumentoCliente = false;
      this.documentoClienteSeleccionado = null;
      this.enviarDocumentoClienteDe = '';
      this.enviarDocumentoClientePara = '';
      this.enviarDocumentoClienteCC = '';
      this.enviarDocumentoClienteAsunto = '';
      this.enviarDocumentoClienteTexto = '';
    },

    async _enviarDocumentoACliente() {
      if (!this.documentoClienteSeleccionado?.id || this.loadingEnviandoDocumentoCliente) {
        return;
      }

      this.loadingEnviandoDocumentoCliente = true;
      try {
        const res = await this.enviarDocumentoACliente([
          this.access_token,
          this.documentoClienteSeleccionado.id,
          this.enviarDocumentoClienteDe,
          this.enviarDocumentoClientePara,
          this.enviarDocumentoClienteCC,
          this.enviarDocumentoClienteAsunto,
          this.enviarDocumentoClienteTexto,
        ]);

        if (res && res.id == this.modelReserva.id) {
          this.modelReserva = res;
          this.sincronizarProveedoresEtapa();
        }
      } finally {
        this.loadingEnviandoDocumentoCliente = false;
      }

      this._cerrarDialogEnviarDocumentoCliente();
    },

    async _enviarDisponibilidadATodos() {
      if (!this.enviandoDisponibilidad) {
        this.notaAlojamientosTemporal = this.modelReserva?.nota_alojamientos || '';
        this.showDialogEnviarDisponibilidadATodos = true;
      }
    },

    _cerrarDialogEnviarDisponibilidadATodos() {
      if (!this.enviandoDisponibilidad) {
        this.showDialogEnviarDisponibilidadATodos = false;
        this.notaAlojamientosTemporal = this.modelReserva?.nota_alojamientos || '';
      }
    },

    async _confirmarEnviarDisponibilidadATodos() {
      if (!this.enviandoDisponibilidad) {
        this.enviandoDisponibilidad = true;
        try {
          const notaAlojamientos = this.notaAlojamientosTemporal ? this.notaAlojamientosTemporal.trim() : '';
          const res = await this.enviarDisponibilidadATodos([this.access_token, this.modelReserva.id, notaAlojamientos]);
          if (res && res.id == this.modelReserva.id) {
            this.modelReserva = res;
          } else if (this.modelReserva) {
            this.modelReserva.nota_alojamientos = notaAlojamientos;
          }
          this.showDialogEnviarDisponibilidadATodos = false;
        } finally {
          this.enviandoDisponibilidad = false;
        }
      }
    },

    _activoBotonDeCrearGuardar() {
      return this.modelReserva &&
        this.modelReserva.cliente.nombre &&
        this.modelReserva.cliente.email &&
        this.modelReserva.camino &&
        this.modelReserva.camino.id > 0 &&
        this.modelReserva.origen &&
        this.modelReserva.origen.id > 0 &&
        this.modelReserva.fecha_inicio &&
        this.modelReserva.fecha_llegada &&
        this.modelReserva.cant_habitaciones_individuales +
        this.modelReserva.cant_habitaciones_dobles +
        this.modelReserva.cant_habitaciones_dobles_matrimoniales +
        this.modelReserva.cant_habitaciones_triples +
        this.modelReserva.cant_habitaciones_cuadruples > 0

    },

    verificarLocalidadPersonalizada() {
      // Verificar si la localidad escrita está en la lista de puntos finales
      if (this.servicioNuevoLocalidad) {
        const localidadString = typeof this.servicioNuevoLocalidad === 'string'
          ? this.servicioNuevoLocalidad
          : this.servicioNuevoLocalidad;

        const existeEnLista = this.listadoPuntosFinales.includes(localidadString);

        // Mostrar el campo de referencia solo si NO está en la lista
        this.mostrarReferenciaLocalidad = !existeEnLista;

        // Limpiar la referencia si la localidad está en la lista
        if (existeEnLista) {
          this.servicioNuevoLocalidadReferencia = '';
        }
      } else {
        this.mostrarReferenciaLocalidad = false;
        this.servicioNuevoLocalidadReferencia = '';
      }
    },

    _irAReserva() {
      this.$router.push({
        path: "/Reservas",
        query: {
          es_agencia: String(this.$route?.query?.es_agencia || "0"),
        },
      });
    },

    _irAPresupuesto() {
      this.$router.push({
        path: "/Presupuestos",
        query: {
          es_agencia: String(this.$route?.query?.es_agencia || "0"),
        },
      });
    },

    _getTipoCabecera() {
      const tipoQuery = String(this.$route?.query?.tipo || "").toUpperCase();
      if (tipoQuery === "RESERVA") {
        return "RESERVA";
      }
      if (tipoQuery === "PRESUPUESTO") {
        return "PRESUPUESTO";
      }
      return this.modelReserva?.estado?.id >= 3 ? "RESERVA" : "PRESUPUESTO";
    },

    async _eliminarPresupuesto(item) {
      const res = await this.eliminarPresupuesto([this.access_token, item.id]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva = res;
      }
    },

    abrirSelectorSeguro() {
      this.$refs.fileInput.click();
    },

    async manejarSeleccionSeguro(event) {
      const archivo = event.target.files[0];
      if (archivo && archivo.type === 'application/pdf') {
        const formData = new FormData();
        formData.append('seguro_pdf', archivo);

        try {
          const res = await this.subirSeguro([
            this.access_token,
            this.modelReserva.id,
            formData
          ]);

          if (res && res.id == this.modelReserva.id) {
            this.modelReserva = res;
          }


        } catch (error) {
          console.error('Error al subir el archivo:', error);

        }
      }
    },

    async _getInitialData() {
      await this.getInitialData([this.access_token]);
    },


    async _getReserva() {
      if (this.inputId) {
        this.loading = true;
        this.modelReserva = await this.getReserva([this.access_token, this.inputId]);
        if (this.modelReserva) {
          this.setReservaSelec(this.modelReserva);

          if (this.modelReserva.camino) {
            this.serviciosNoIncluidos = this.modelReserva.camino.servicios
              .filter(servicio => !servicio.esta_incluido && servicio.esta_activo)
              .map(servicio => ({
                ...servicio,
                seleccionado: false,
                importe: 0,
                descripcion: ''
              }));

            this.serviciosIncluidos = this.modelReserva.camino.servicios
              .filter(servicio => servicio.esta_incluido && servicio.esta_activo)
              .map(servicio => ({
                ...servicio,
                seleccionado: !(this.modelReserva.servicios_inc_cancelados || '')
                  .split(';')
                  .filter(id => id.trim() !== '')
                  .includes(servicio.id.toString())
              }));
          }

          for (let servicio of this.serviciosNoIncluidos) {
            const servicioEncontrado = this.modelReserva.servicios.find(servicioReserva =>
              servicioReserva.titulo === servicio.titulo
            );

            if (servicioEncontrado) {
              if (this.servicioEsNocheExtra(servicio)) {
              }

              servicio.seleccionado = true;
              servicio.importe = servicioEncontrado.importe;
              servicio.descripcion = servicioEncontrado.descripcion;
            }
          }

          this.sincronizarProveedoresEtapa();

          this.actualizarTarifasCamino();

          this._getCaminos();
          this._getOrigenes();
        }
        this.loading = false;
      }
    },

    _showModalAgregarPasajero() {
      this._inicializarPasajero();
      this.showModalAgregarPasajero = true;
    },

    _mostrarCamposCompletosPasajero() {
      const origenId = Number(
        this.modelReserva?.origen?.id ?? this.modelReserva?.origen_id ?? 0
      );
      return origenId <= 1;
    },

    _inicializarPasajero() {
      this.pasajeroNuevo = {
        id: null,
        nombre: '',
        primer_apellido: '',
        segundo_apellido: '',
        tipo_documento: 'DNI',
        numero_documento: '',
        soporte_documento: '',
        poblacion: '',
        provincia: '',
        direccion: '',
        codigo_postal: '',
        email: '',
        fecha_nacimiento: '',
        nacionalidad: '',
        parentesco: '',
        reserva_id: this.modelReserva.id,
      };
    },

    _esNacionalidadEspana(nacionalidad) {
      return String(nacionalidad || '').trim().toUpperCase() === 'ESPAÑA';
    },

    _onNacionalidadPasajeroChange(value) {
      if (!this._esNacionalidadEspana(value)) {
        return;
      }

      const provinciaActual = String(this.pasajeroNuevo?.provincia || '').trim();
      if (!provinciaActual) {
        return;
      }

      const provinciaNormalizada = this.provincias.find(
        (provincia) => provincia.toUpperCase() === provinciaActual.toUpperCase()
      );

      if (provinciaNormalizada) {
        this.pasajeroNuevo.provincia = provinciaNormalizada;
      }
    },

    etapaEnviadaOConfirmada(etapa) {
      return etapa.pivot.estado_id === 3 || etapa.pivot.estado_id === 5;
    },

    async _guardarPasajero(cerrar) {
      this.loadingGuardandoPasajero = true;
      if (this.pasajeroNuevo.id == null) {
        const res = await this.crearPasajeros([this.access_token, this.pasajeroNuevo]);
        if (res && res.id == this.modelReserva.id) {
          this.modelReserva.pasajeros = res.pasajeros;
        }
        this._inicializarPasajero();
      } else {
        const res = await this.updatePasajero([this.access_token, this.pasajeroNuevo]);
        if (res && res.id == this.modelReserva.id) {
          this.modelReserva.pasajeros = res.pasajeros;
        }
      }


      if (cerrar) {
        this.showModalAgregarPasajero = false;
      }
      this.loadingGuardandoPasajero = false;
    },

    async _actualizarClienteEsViajero(cliente_es_viajero) {
      if (!this.modelReserva?.id || this.loadingClienteEsViajero) {
        return;
      }

      const valorAnterior = this.clienteEsViajero;
      const nuevoValor = Boolean(cliente_es_viajero);
      this.loadingClienteEsViajero = true;
      this.$set(this.modelReserva, "cliente_es_viajero", nuevoValor);

      try {
        const reserva = await this.updateClienteEsViajero([
          this.access_token,
          this.modelReserva.id,
          nuevoValor,
        ]);

        if (reserva?.cliente_es_viajero !== undefined) {
          this.$set(this.modelReserva, "cliente_es_viajero", reserva.cliente_es_viajero);
        }
      } catch (error) {
        this.$set(this.modelReserva, "cliente_es_viajero", valorAnterior);
        console.error("Error al actualizar si el cliente es viajero:", error);
      } finally {
        this.loadingClienteEsViajero = false;
      }
    },

    async _deletePasajero(pasajero) {
      const res = await this.eliminarPasajero([this.access_token, pasajero.id]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva.pasajeros = res.pasajeros;
      }
    },

    _esPrimerPasajero(pasajero) {
      return this.modelReserva?.pasajeros?.[0]?.id === pasajero?.id;
    },

    async _editarPasajero(pasajero) {
      this.pasajeroNuevo = pasajero;
      this.showModalAgregarPasajero = true;
    },

    isValidDocument(tipo, documento) {
      if (!documento || documento.trim() === '') return true;
      const tipoDocumento = String(tipo).toUpperCase();
      switch (tipoDocumento) {
        case 'DNI':
          return /^[0-9]{8}[A-Z]$/.test(documento);
        case 'NIE':
          return /^[XYZ][0-9]{7,8}[A-Z]$/.test(documento);
        case 'Pasaporte':
          return /^[A-Za-z0-9\-]{5,20}$/.test(documento);
        default:
          return true;
      }
    },

    _mostrarDialogCambiarEstado(entidadACambiarEstado, reservaetapaproveedorId = null) {
      this.entidadACambiarEstado = entidadACambiarEstado;
      this.etapaACambiarEstadoId = entidadACambiarEstado === 'ETAPA' ? reservaetapaproveedorId : null;
      this.showDialogCambiarEstado = true;
    },

    _inicializarModelReserva() {
      this.modelReserva = {
        id: null,
        acepta_novedades: 0,
        camino: null,
        cant_habitaciones: 0,
        cant_habitaciones_cuadruples: 0,
        cant_habitaciones_dobles: 0,
        cant_habitaciones_dobles_matrimoniales: 0,
        cant_habitaciones_individuales: 0,
        cant_habitaciones_triples: 0,
        cant_peregrinos: 0,

        cliente: {
          id: null,
          tipoCliente: null,
          nombre: null,
          apellidos: null,
          telefono: null,
          email: null,
          documento: null,
          direccion: null,
          comentarios: null,
        },
        codigo: null,
        codigo_reserva: null,
        comentarios: null,
        descripcion_importe_presupuestado: null,
        descripcion_importe_reserva: null,
        descripcion_importe_servicios: null,
        estado: null,
        estado_id: null,
        etapas: [],
        fecha_inicio: null,
        fecha_llegada: null,
        historials: [],
        importe_presupuestado: 0,
        importe_reserva: 0,
        importe_servicios: 0,
        language: 'ES',
        origen: null,
        codigo_agencia: null,
        pasajeros: [],
        presupuestos: [],
        servicios: [],
        servicios_inc_cancelados: null,
        tiene_pendientes: 0,
        nota_alojamientos: null,
        url_presupuesto: null,
      };
    },

    _aplicarContextoCreacionDesdeRuta() {
      if (this.accion !== "crear" || !this.modelReserva) {
        return;
      }

      this.modelReserva.es_agencia =
        String(this.$route?.query?.es_agencia || "0") === "1" ? 1 : 0;

      const estadoIdQuery = Number(this.$route?.query?.estado_id);
      if (Number.isInteger(estadoIdQuery) && estadoIdQuery > 0) {
        this.modelReserva.estado_id = estadoIdQuery;

        if (Array.isArray(this.estados) && this.estados.length > 0) {
          const estadoCreacion = this.estados.find(estado => estado.id === estadoIdQuery);
          if (estadoCreacion) {
            this.modelReserva.estado = estadoCreacion;
          }
        }
      } else {
        this.modelReserva.estado_id = null;
      }
    },






    _actualizarEtapaExtra(reserva) {
      this.dialogFormularioEtapaExtra = false;
      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva.fecha_llegada = reserva.fecha_llegada;
        this.modelReserva.etapas = reserva.etapas;
      }

    },

    onCancelarServicioInc(servicio, seleccionado) {
      servicio.seleccionado = !seleccionado;
      this._updateServiciosIncCancelados();
    },

    async _updateServiciosIncCancelados() {
      let servicios_inc_cancelados = '';
      for (let servicio of this.serviciosIncluidos) {
        if (!servicio.seleccionado) {
          servicios_inc_cancelados += servicio.id + ';';
        }
      }
      if (servicios_inc_cancelados == '') {
        servicios_inc_cancelados = null;
      }
      const res = await this.updateServiciosIncCancelados([this.access_token, this.modelReserva.id, servicios_inc_cancelados]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva = res;
      }

    },

    _mostrarDialogEnviarCorreo() {
      this.estadoAccionDeCorreo = null;
      this.inicializarEnviarCorreo();
      this.inicializarSwitchEnviarCorreoConExtras();
      this.showDialogEnviarCorreo = true;
    },

    _mostrarDialogEnviarResena() {
      this.estadoAccionDeCorreo = null;
      this.inicializarEnviarCorreo();
      this.allowSendCuestionario = true;

      const { asunto, cuerpo } = generarEmailContenidoResena(
        this.modelReserva,
        this.user,
        this.enviarCuestionario
      );

      this.enviarCorreoAsunto = asunto;
      this.enviarTextoMensaje = cuerpo;
      this.showDialogEnviarCorreo = true;
    },

    _actualizarContenidoCorreoResena() {
      const { asunto, cuerpo } = generarEmailContenidoResena(
        this.modelReserva,
        this.user,
        this.enviarCuestionario
      );

      this.enviarCorreoAsunto = asunto;
      this.enviarTextoMensaje = cuerpo;
    },

    inicializarSwitchEnviarCorreoConExtras() {
      this.allowSendUltimoPresupuesto = this.existPresupuesto;
      this.allowSendUltimoConfirmacion = this.existConfirmacion;
      this.allowSendDossier = this.existDossier;
      this.allowSendUltimoBonoAlojamientos = this.existUltimoBonoAlojamientos;
      this.allowSendUltimoBonoServicios = this.existUltimoBonoServicios;
      this.allowSendUltimoProforma = this.existUltimoProforma;
      this.allowSendUltimoSeguro = this.existUltimoSeguro;
      this.allowSendTips = this.existTips;
      this.allowSendSeguroAnulacion = this.existSeguroAnulacion;
      this.allowSendAutorizacionTarjeta = Boolean(this.modelReserva?.link_cargo_tarjeta);
      this.allowSendRegistroViajeros = Boolean(this.modelReserva?.link_registro_viajeros);
      this.allowSendDatosBanco = false;

      this.enviarUltimoPresupuesto = false;
      this.enviarUltimoConfirmacion = false;
      this.enviarDossier = false;
      this.enviarUltimoBonoAlojamientos = false;
      this.enviarUltimoBonoServicios = false;
      this.enviarUltimoProforma = false;
      this.enviarUltimoSeguro = false;
      this.enviarTips = false;
      this.enviarSeguroAnulacion = false;
      this.enviarAutorizacionTarjeta = false;
      this.enviarRegistroViajeros = false;
      this.enviarDatosBanco = false;
    },

    inicializarSwitchEnviarPresupuestoClienteFinal() {
     this.allowSendUltimoPresupuesto = true;
      this.allowSendTips = true;
      this.allowSendSeguroAnulacion = true;

      this.enviarUltimoPresupuesto = true;
      this.enviarTips = false;
      this.enviarDatosBanco = false;
      this.enviarSeguroAnulacion = false;
    },

    inicializarSwitchEnviarPresupuestoAgencia() {
     this.allowSendUltimoPresupuesto = true;
      this.allowSendTips = false;
      this.allowSendSeguroAnulacion = false;

      this.enviarUltimoPresupuesto = true;
      this.enviarTips = false;
      this.enviarDatosBanco = false;
      this.enviarSeguroAnulacion = false;
    },

    _mostrarDialogEnviarPresupuesto() {
      this.estadoAccionDeCorreo = 2;
      this.inicializarEnviarCorreo();
      if (this.modelReserva.origen.id == 1){
        this.inicializarSwitchEnviarPresupuestoClienteFinal();
      } else {
        this.inicializarSwitchEnviarPresupuestoAgencia();
      }
      
      const { asunto, cuerpo } = generarEmailContenidoPresupuesto(
        this.modelReserva,
        this.user
      );

      this.enviarCorreoAsunto = this._formatearAsuntoEnvioPresupuesto(asunto);
      this.enviarTextoMensaje = cuerpo;

      this.enviarAdjuntoUltimoPresupuesto = this.modelReserva.presupuestos &&
        this.modelReserva.presupuestos.length > 0 ?
        this.modelReserva.presupuestos.at(-1).url_pdf : '';

      this.showDialogEnviarCorreo = true;
    },

    inicializarSwitchEnviarConfirmacionClienteFinal(){
      this.allowSendUltimoConfirmacion = true;
      this.allowSendDossier = true;
      this.allowSendTips = true;
      this.allowSendRegistroViajeros = true;
      this.allowSendAutorizacionTarjeta = true;
      this.allowSendSeguroAnulacion = true;
      this.allowSendDatosBanco = true;

      this.enviarUltimoConfirmacion = true;
      this.enviarTips = true;
      this.enviarDatosBanco = true;
      this.enviarRegistroViajeros = true;
      this.enviarAutorizacionTarjeta = true;
      this.enviarSeguroAnulacion = false;
    },

    inicializarSwitchEnviarConfirmacionAgencia(){
      this.allowSendUltimoConfirmacion = true;
      this.allowSendDossier = false;
      this.allowSendTips = false;
      this.allowSendRegistroViajeros = false;
      this.allowSendAutorizacionTarjeta = false;
      this.allowSendSeguroAnulacion = false;
      this.allowSendDatosBanco = false;

      this.enviarUltimoConfirmacion = true;
      this.enviarTips = false;
      this.enviarDatosBanco = false;
      this.enviarRegistroViajeros = false;
      this.enviarAutorizacionTarjeta = false;
      this.enviarSeguroAnulacion = false;
    },

    _mostrarDialogEnviarConfirmacion() {
      this.estadoAccionDeCorreo = 5;
      this.inicializarEnviarCorreo();
      if (this.modelReserva.origen.id == 1){
        this.inicializarSwitchEnviarConfirmacionClienteFinal();
      } else {
        this.inicializarSwitchEnviarConfirmacionAgencia();
      }

      const { asunto, cuerpo } = generarEmailContenidoConfirmacion(
        this.modelReserva,
        this.user
      );

      this.enviarCorreoAsunto = this._formatearAsuntoCorreoConReserva(asunto);
      this.enviarTextoMensaje = cuerpo;

      this.enviarAdjuntoUltimoConfirmacion = this.modelReserva.confirmaciones &&
        this.modelReserva.confirmaciones.length > 0 ?
        this.modelReserva.confirmaciones.at(-1).url_pdf : '';

      this.showDialogEnviarCorreo = true;
    },

    inicializarSwitchEnviarDocumentacionClienteFinal(){
      this.allowSendUltimoConfirmacion = true;
      this.allowSendDossier = true;
      this.allowSendUltimoBonoAlojamientos = true;
      this.allowSendUltimoBonoServicios = true;
      this.allowSendUltimoProforma = true;
      this.allowSendUltimoSeguro = true;

      this.allowSendTips = true;
      this.allowSendSeguroAnulacion = true;
      this.allowSendAutorizacionTarjeta = true;

      this.enviarUltimoConfirmacion = false;
      this.enviarDossier = true;
      this.enviarUltimoBonoAlojamientos = true;
      this.enviarUltimoBonoServicios = true;
      this.enviarUltimoProforma = true;
      this.enviarUltimoSeguro = true;
      this.enviarTips = false;
      this.enviarDatosBanco = false;
      this.enviarSeguroAnulacion = false;
      this.enviarAutorizacionTarjeta = false;
    },

    inicializarSwitchEnviarDocumentacionAgencia(){
      this.allowSendUltimoConfirmacion = true;
      this.allowSendDossier = false;
      this.allowSendUltimoBonoAlojamientos = true;
      this.allowSendUltimoBonoServicios = true;
      this.allowSendUltimoProforma = true;
      this.allowSendUltimoSeguro = false;

      this.allowSendTips = false;
      this.allowSendSeguroAnulacion = false;
      this.allowSendAutorizacionTarjeta = false;

      this.enviarUltimoConfirmacion = false;
      this.enviarDossier = false;
      this.enviarUltimoBonoAlojamientos = true;
      this.enviarUltimoBonoServicios = true;
      this.enviarUltimoProforma = true;
      this.enviarUltimoSeguro = false;
      this.enviarTips = false;
      this.enviarDatosBanco = false;
      this.enviarSeguroAnulacion = false;
      this.enviarAutorizacionTarjeta = false;
    },

    _mostrarDialogEnviarDocumentacionFinal() {
      this.estadoAccionDeCorreo = 6;
      this.inicializarEnviarCorreo();

      if (this.modelReserva.origen.id == 1) {
        this.inicializarSwitchEnviarDocumentacionClienteFinal();
      } else {
        this.inicializarSwitchEnviarDocumentacionAgencia();
      }

      const { asunto, cuerpo } = generarEmailContenidoDocumentacion(
        this.modelReserva,
        this.user
      );

      this.enviarCorreoAsunto = this._formatearAsuntoCorreoConReserva(asunto);
      this.enviarTextoMensaje = cuerpo;



      const dossier = this.archivosDossierYTips.find(item => item.documento == 'DOSSIER');
      this.enviarAdjuntoDossier = dossier ? dossier.url_pdf : '';

      this.enviarAdjuntoUltimoBonoAlojamientos = this.modelReserva.bonos_alojamientos &&
        this.modelReserva.bonos_alojamientos.length > 0 ?
        this.modelReserva.bonos_alojamientos.at(-1).url_pdf : '';
      this.enviarAdjuntoUltimoBonoServicios = this.modelReserva.bonos_servicios &&
        this.modelReserva.bonos_servicios.length > 0 ?
        this.modelReserva.bonos_servicios.at(-1).url_pdf : '';
      this.enviarAdjuntoUltimoProforma = this.modelReserva.proformas &&
        this.modelReserva.proformas.length > 0 ?
        this.modelReserva.proformas.at(-1).url_pdf : '';
      this.enviarAdjuntoUltimoSeguro = this.modelReserva.seguros &&
        this.modelReserva.seguros.length > 0 ?
        this.modelReserva.seguros.at(-1).url_pdf : '';



      this.showDialogEnviarCorreo = true;
    },

    getEmailDestinatarioReserva() {
      const emailOrigen = String(this.modelReserva?.origen?.email || "").trim();
      const emailCliente = String(this.modelReserva?.cliente?.email || "").trim();
      const origenId = Number(this.modelReserva?.origen?.id || 0);

      if (origenId > 1 && emailOrigen) {
        return emailOrigen;
      }

      return emailCliente;
    },

    _formatearAsuntoCorreoConReserva(asuntoBase) {
      const codigoReserva = String(this.modelReserva?.codigo_reserva || "").trim();
      const codigoPresupuesto = String(this.modelReserva?.codigo || "").trim();

      if (!codigoReserva || !codigoPresupuesto) {
        return asuntoBase;
      }

      const partes = String(asuntoBase || "").split(" - ");
      const prefijo = partes.length > 0 ? partes[0] : String(asuntoBase || "").trim();

      if (!prefijo) {
        return `${codigoReserva} - (${codigoPresupuesto})`;
      }

      return `${prefijo}. ${codigoReserva} - (${codigoPresupuesto})`;
    },

    _formatearAsuntoEnvioPresupuesto(asuntoBase) {
      const asunto = String(asuntoBase || "").trim();
      const hayMultiplesPresupuestos = Array.isArray(this.modelReserva?.presupuestos)
        && this.modelReserva.presupuestos.length > 1;
      const asuntoNuevoPresupuestoPorIdioma = {
        DE: "Neues Angebot",
        EN: "New Proposal",
        ES: "Nuevo Presupuesto",
      };
      const idioma = String(this.modelReserva?.language || "ES").toUpperCase();
      
      const asuntoNuevoPresupuesto = asuntoNuevoPresupuestoPorIdioma[idioma]
        || asuntoNuevoPresupuestoPorIdioma.ES;
      const sufijo = ` [${asuntoNuevoPresupuesto}]`;
      
      if (!hayMultiplesPresupuestos || !asunto) {
        return asunto;
      }
     
      return asunto.endsWith(sufijo)
        ? asunto
        : `${asunto}${sufijo}`;
    },

    inicializarEnviarCorreo() {
      this.enviarCorreoDe = this.user.email;
      this.enviarCorreoPara = this.getEmailDestinatarioReserva();
      this.enviarCorreoCC = this.user.email;

      this.allowSendUltimoPresupuesto = false;
      this.allowSendUltimoConfirmacion = false;
      this.allowSendUltimoBonoAlojamientos = false;
      this.allowSendUltimoBonoServicios = false;
      this.allowSendUltimoProforma = false;
      this.allowSendUltimoSeguro = false;
      this.allowSendDossier = false;
      this.allowSendTips = false;
      this.allowSendSeguroAnulacion = false;
      this.allowSendAutorizacionTarjeta = false;
      this.allowSendRegistroViajeros = false;
      this.allowSendDatosBanco = false;
      this.allowSendCuestionario = false;

      this.enviarUltimoPresupuesto = false;
      this.enviarUltimoConfirmacion = false;
      this.enviarDossier = false;
      this.enviarTips = false;
      this.enviarSeguroAnulacion = false;
      this.enviarUltimoBonoAlojamientos = false;
      this.enviarUltimoBonoServicios = false;
      this.enviarUltimoProforma = false;
      this.enviarUltimoSeguro = false;
      this.enviarAutorizacionTarjeta = false;
      this.enviarRegistroViajeros = false;
      this.enviarDatosBanco = false;
      this.enviarCuestionario = false;

      this.enviarCorreoAsunto = this.modelReserva.codigo;
      this.enviarTextoMensaje = '';
      this.enviarAdjuntoUltimoPresupuesto = '';

      // Convertir la cadena de emails en un array
      if (this.user.lista_emails) {
        this.enviarListaCorreos = this.user.lista_emails
          .split(';')
          .map(email => email.trim())
          .filter(email => email.length > 0);
      } else {
        this.enviarListaCorreos = [];
      }
    },

    async _enviarCorreo() {
      if (this.enviarUltimoPresupuesto) {
        this.enviarAdjuntoUltimoPresupuesto = this.modelReserva.presupuestos &&
          this.modelReserva.presupuestos.length > 0 ?
          this.modelReserva.presupuestos[this.modelReserva.presupuestos.length - 1].url_pdf : '';
      } else {
        this.enviarAdjuntoUltimoPresupuesto = '';
      }

      if (this.enviarUltimoConfirmacion) {
        this.enviarAdjuntoUltimoConfirmacion = this.modelReserva.confirmaciones &&
          this.modelReserva.confirmaciones.length > 0 ?
          this.modelReserva.confirmaciones[this.modelReserva.confirmaciones.length - 1].url_pdf : '';
      } else {
        this.enviarAdjuntoUltimoConfirmacion = '';
      }

      if (this.enviarDossier) {
        const dossierItem = this.archivosDossierYTips.find(item => item.documento == 'DOSSIER');
        if (dossierItem) {
          this.enviarAdjuntoDossier = dossierItem.url_pdf;
        } else {
          this.enviarAdjuntoDossier = '';
        }
      } else {
        this.enviarAdjuntoDossier = '';
      }

      if (this.enviarTips) {
        const tipsItem = this.archivosDossierYTips.find(item => item.documento == 'TIPS DEL CAMINO');
        if (tipsItem) {
          this.enviarAdjuntoTips = tipsItem.url_pdf;
        } else {
          this.enviarAdjuntoTips = '';
        }
      } else {
        this.enviarAdjuntoTips = '';
      }

      if (this.enviarSeguroAnulacion) {
        const seguroAnulacionItem = this.archivosDossierYTips.find(item => item.documento == 'SEGURO DE ANULACIÓN');
        if (seguroAnulacionItem) {
          this.enviarAdjuntoSeguroAnulacion = seguroAnulacionItem.url_pdf;
        } else {
          this.enviarAdjuntoSeguroAnulacion = '';
        }
      } else {
        this.enviarAdjuntoSeguroAnulacion = '';
      }

      if (this.enviarAutorizacionTarjeta) {
        this.enviarAdjuntoAutorizacionTarjeta = this.modelReserva.link_cargo_tarjeta ? this.modelReserva.link_cargo_tarjeta + this.modelReserva.language + '/' + this.modelReserva.hash : '';
      } else {
        this.enviarAdjuntoAutorizacionTarjeta = '';
      }

      if (this.enviarRegistroViajeros) {
        this.enviarAdjuntoRegistroViajeros = this.modelReserva.link_registro_viajeros ? this.modelReserva.link_registro_viajeros + this.modelReserva.language + '/' + this.modelReserva.hash : '';
      } else {
        this.enviarAdjuntoRegistroViajeros = '';
      }

      if (this.enviarUltimoBonoAlojamientos) {
        this.enviarAdjuntoUltimoBonoAlojamientos = this.modelReserva.bonos_alojamientos &&
          this.modelReserva.bonos_alojamientos.length > 0 ?
          this.modelReserva.bonos_alojamientos[this.modelReserva.bonos_alojamientos.length - 1].url_pdf : '';
      } else {
        this.enviarAdjuntoUltimoBonoAlojamientos = '';
      }

      if (this.enviarUltimoBonoServicios) {
        this.enviarAdjuntoUltimoBonoServicios = this.modelReserva.bonos_servicios &&
          this.modelReserva.bonos_servicios.length > 0 ?
          this.modelReserva.bonos_servicios[this.modelReserva.bonos_servicios.length - 1].url_pdf : '';
      } else {
        this.enviarAdjuntoUltimoBonoServicios = '';
      }

      if (this.enviarUltimoProforma) {
        this.enviarAdjuntoUltimoProforma = this.modelReserva.proformas &&
          this.modelReserva.proformas.length > 0 ?
          this.modelReserva.proformas[this.modelReserva.proformas.length - 1].url_pdf : '';
      } else {
        this.enviarAdjuntoUltimoProforma = '';
      }

      if (this.enviarUltimoSeguro) {
        this.enviarAdjuntoUltimoSeguro = this.modelReserva.seguros &&
          this.modelReserva.seguros.length > 0 ?
          this.modelReserva.seguros[this.modelReserva.seguros.length - 1].url_pdf : '';
      } else {
        this.enviarAdjuntoUltimoSeguro = '';
      }


      if (!this.loadingEnviandoCorreo) {
        this.loadingEnviandoCorreo = true;
        const correoCC = String(this.enviarCorreoCC || "").trim();
        const res = await this.enviarCorreo([this.access_token, this.modelReserva.id,
        this.enviarCorreoDe, this.enviarCorreoPara, correoCC, this.enviarCorreoAsunto,
        this.enviarTextoMensaje, this.enviarAdjuntoUltimoPresupuesto, this.enviarAdjuntoUltimoConfirmacion, this.enviarAdjuntoDossier, this.enviarAdjuntoTips,
        this.enviarAdjuntoUltimoBonoAlojamientos, this.enviarAdjuntoUltimoBonoServicios, this.enviarAdjuntoUltimoProforma, this.enviarAdjuntoUltimoSeguro,
        this.enviarAdjuntoSeguroAnulacion, this.enviarAdjuntoAutorizacionTarjeta, this.enviarAdjuntoRegistroViajeros, this.estadoAccionDeCorreo,
        this.enviarCuestionario]);

        if (res && res.id == this.modelReserva.id) {
          this.modelReserva = res;
        }
        this.showDialogEnviarCorreo = false;
        this.loadingEnviandoCorreo = false;
      }

    },



    getNombreUsuario(user) {
      if (user) {
        return user.username.substring(0, 2);
      }
      return '';
    },

    getCaptionFecha(fecha) {
      if (fecha) {
        const date = new Date(fecha);

        // Verificar si la fecha es válida
        if (isNaN(date.getTime())) {
          return fecha.split(' ')[0]; // Fallback al formato original
        }

        // Obtener día, mes y año
        const dia = date.getDate();
        const mes = date.toLocaleDateString('es-ES', { month: 'short' });
        const año = date.getFullYear();
        const hora = date.toLocaleTimeString('es-ES', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });

        return `${dia} ${mes} ${año}  (${hora})`;
      }
      return '';
    },

    formatearFechaConHora(fecha) {
      if (!fecha) return '';

      const date = new Date(fecha);

      if (Number.isNaN(date.getTime())) {
        return fecha;
      }

      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const año = date.getFullYear();
      const hora = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');

      return `${dia}/${mes}/${año} ${hora}:${minutos}`;
    },

    formatearFechaSinHora(fecha) {
      if (!fecha) return '';

      const date = new Date(fecha);

      // Verificar si la fecha es válida
      if (Number.isNaN(date.getTime())) {
        return fecha; // Fallback al formato original
      }

      // Obtener día, mes, año, hora y minutos con padding
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const año = date.getFullYear();

      return `${dia}/${mes}/${año}`;
    },

    _agregarEtapa(fecha) {
      this._inicializarModelEtapa();
      this.fechaEtapaExtra = fecha;
      this.dialogFormularioEtapaExtra = true;

    },

    _inicializarModelEtapa() {
      this.modelEtapaExtra = {
        id: null,
        titulo: null,
        descripcion: null,
        inicio_punto: null,
        final_punto: null,
        dificultad: null,
        duracion: null,
        distancia: null,
        imagen_base64: null,
      };
    },

    async _eliminarEtapa(etapa_id) {
      if (this.loadingEliminandoEtapa) {
        return;
      }
      this.loadingEliminandoEtapa = true;
      const etapas_ids = [etapa_id];
      const reserva = await this.eliminarEtapas([this.access_token, this.modelReserva.id, etapas_ids]);

      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva.etapas = reserva.etapas;
        this.modelReserva.fecha_llegada = reserva.fecha_llegada;
      }
      this.loadingEliminandoEtapa = false;
    },

    async eliminarTodasEtapas() {
      this.showDialogEliminarTodasEtapas = false;
      if (this.loadingEliminandoTodasEtapas) {
        return;
      }
      this.loadingEliminandoTodasEtapas = true;
      const etapas_ids = this.modelReserva.etapas.map(etapa => etapa.pivot.id);
      const reserva = await this.eliminarEtapas([this.access_token, this.modelReserva.id, etapas_ids]);

      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva.etapas = reserva.etapas;
        this.modelReserva.fecha_llegada = reserva.fecha_llegada;
      }
      this.loadingEliminandoTodasEtapas = false;
    },

    getHistorialMensaje(item) {
      if (!item) return '';

      const partes = [];

      if (item.remitente) {
        partes.push(`<strong>De:</strong> ${this.escapeHtml(item.remitente)}`);
      }

      if (item.destinatario) {
        partes.push(`<strong>Para:</strong> ${this.escapeHtml(item.destinatario)}`);
      }

      if (item.asunto) {
        partes.push(`<strong>Asunto:</strong> ${this.escapeHtml(item.asunto)}`);
      }

      const contenido = item.contenido || item.mensaje || item.texto_correo || '';

      if (contenido) {
        partes.push(contenido);
      }

      return partes.join('<br>');
    },

    mostrarDialogHistorialCorreo(item) {
      this.historialCorreoTexto = this.getHistorialMensaje(item);
      this.showDialogHistorialCorreo = true;
    },

    getHistorialAdjuntos(item) {
      const adjunto = item?.adjunto;

      if (!adjunto) {
        return [];
      }

      if (Array.isArray(adjunto)) {
        return adjunto
          .map((documento, index) => ({
            nombre_documento: documento?.nombre_documento || `Documento ${index + 1}`,
            url_documento: documento?.url_documento || documento?.url || '',
          }))
          .filter((documento) => documento.url_documento);
      }

      if (typeof adjunto === 'string') {
        const valor = adjunto.trim();

        if (!valor) {
          return [];
        }

        if (valor.startsWith('[') || valor.startsWith('{')) {
          try {
            const parsed = JSON.parse(valor);
            return this.getHistorialAdjuntos({ adjunto: parsed });
          } catch (e) {
            // Si no es JSON valido, se trata como URL simple.
          }
        }

        return [{
          nombre_documento: 'Documento',
          url_documento: valor,
        }];
      }

      if (typeof adjunto === 'object') {
        const urlDocumento = adjunto.url_documento || adjunto.url || '';

        if (!urlDocumento) {
          return [];
        }

        return [{
          nombre_documento: adjunto.nombre_documento || 'Documento',
          url_documento: urlDocumento,
        }];
      }

      return [];
    },

    abrirHistorialAdjuntoDocumento(adjunto) {
      if (adjunto?.url_documento) {
        window.open(adjunto.url_documento, '_blank');
      }
    },

    formatHistorialDescripcion(descripcion) {
      if (!descripcion) return '';
      const safe = this.escapeHtml(descripcion);
      return safe
        .replace(/\bCANCELAD[AO]\b/gi, '<span class="historial-keyword-cancelar">$&</span>')
        .replace(/\bCONFIRMAD[AO]\b/gi, '<span class="historial-keyword-confirmar">$&</span>')
        .replace(/\bPRESUPUESTADA\b/gi, '<span class="historial-keyword-presupuestada">$&</span>')
        .replace(/\bEN PROCESO\b/gi, '<span class="historial-keyword-en-proceso">$&</span>')
        .replace(/\bCONFIRMACION FINAL\b/gi, '<span class="historial-keyword-confirmacion-final">$&</span>');
    },

    escapeHtml(text) {
      return String(text).replace(/[&<>"']/g, (char) => {
        switch (char) {
          case '&':
            return '&amp;';
          case '<':
            return '&lt;';
          case '>':
            return '&gt;';
          case '"':
            return '&quot;';
          case "'":
            return '&#39;';
          default:
            return char;
        }
      });
    },


    verHistorialAdjunto(item) {
      const adjuntos = this.getHistorialAdjuntos(item);

      if (adjuntos.length === 1) {
        this.abrirHistorialAdjuntoDocumento(adjuntos[0]);
        return;
      }

      if (adjuntos.length > 1) {
        this.historialAdjuntos = adjuntos;
        this.showDialogHistorialAdjuntos = true;
      }
    },

    onTabChange(newTab) {

      switch (newTab) {
        case 0: // Datos de Reserva
          break;
        case 1: // Cliente
          // Cargar datos del cliente si es necesario
          break;
        case 2: // Servicios
          // Actualizar lista de servicios
          break;
        case 3: // Itinerario

          break;
        case 4: // Historial
          this._cargarHistorial();

          break;
        case 5: // Pasajeros
          // Cargar datos de pasajeros
          break;

      }
    },

    async _updateItinerarioAMedida(itinerario_a_medida) {
      this.showDialogItinerarioAMedida = false;
      this.showDialogItinerarioOriginal = false;
      const reserva = await this.updateItinerarioAMedida([this.access_token, this.modelReserva.id, itinerario_a_medida]);

      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva.itinerario_a_medida = reserva.itinerario_a_medida;
        if (itinerario_a_medida == 0) {
          this.modelReserva.etapas = reserva.etapas;
          this.modelReserva.fecha_llegada = reserva.fecha_llegada;
        }
      }
    },

    async _cambiarEstado(estado_id) {
      try {
        this.showDialogCambiarEstado = false;

        const accionesPorEntidad = {
          ETAPA: () => {
            if (!this.etapaACambiarEstadoId) {
              return null;
            }
            return this.updateEstadoEtapa([
              this.access_token,
              this.etapaACambiarEstadoId,
              estado_id
            ]);
          },
          RESERVA: () => this.updateEstadoReserva([this.access_token, this.modelReserva.id, estado_id]),
        };

        const accion = accionesPorEntidad[this.entidadACambiarEstado];
        if (!accion) {
          return;
        }

        const response = await accion();
        const reserva = this.entidadACambiarEstado === 'ETAPA' ? response?.reserva : response;
        const aviso = this.entidadACambiarEstado === 'ETAPA' ? response?.aviso : null;

        if (this.entidadACambiarEstado === 'ETAPA' && this.etapaACambiarEstadoId) {
          if (aviso) {
            this.$set(this.avisosEstadoEtapa, this.etapaACambiarEstadoId, aviso);
          } else {
            this.$delete(this.avisosEstadoEtapa, this.etapaACambiarEstadoId);
          }
        }

        if (reserva && reserva.id == this.modelReserva.id) {
          this.modelReserva = { ...this.modelReserva, ...reserva };
          if (Array.isArray(reserva.etapas)) {
            this.sincronizarProveedoresEtapa();
          }
        }
      } catch (error) {
        console.error('Error al cambiar el estado:', error);
      } finally {
        this.entidadACambiarEstado = null;
        this.etapaACambiarEstadoId = null;
      }
    },

    async _abrirDialogCambiarTrabajador() {
      try {
        this.loadingTrabajadores = true;
        this.showDialogCambiarTrabajador = true;
        const trabajadores = await this.getTrabajadores([this.access_token]);

        if (trabajadores) {
          this.trabajadores = Array.isArray(trabajadores) ? trabajadores : [];

          // Pre-seleccionar el trabajador actual si existe
          if (this.modelReserva.asignada_a && this.trabajadoresOrigenUno.length > 0) {
            this.trabajadorSeleccionado = this.trabajadoresOrigenUno.find(t => t.id === this.modelReserva.asignada_a.id);
          }
        }
      } catch (error) {
        console.error('Error al cargar los trabajadores:', error);
      } finally {
        this.loadingTrabajadores = false;
      }
    },

    _cerrarDialogCambiarTrabajador() {
      this.showDialogCambiarTrabajador = false;
      this.trabajadorSeleccionado = null;
      this.mensajeTrabajador = '';
    },

    async _cambiarTrabajadorAsignado() {
      try {
        if (!this.trabajadorSeleccionado) {
          return;
        }

        this.showDialogCambiarTrabajador = false;
        const reserva = await this.cambiarTrabajadorAsignado([
          this.access_token,
          this.modelReserva.id,
          this.trabajadorSeleccionado.id,
          this.mensajeTrabajador
        ]);

        if (reserva && reserva.id == this.modelReserva.id) {
          this.modelReserva.asignada_a = reserva.asignada_a;
        }

        // Limpiar los campos
        this.trabajadorSeleccionado = null;
        this.mensajeTrabajador = '';
      } catch (error) {
        console.error('Error al cambiar el trabajador asignado:', error);
      }
    },

    async _cargarHistorial() {
      this.loadingCargandoHistorial = true;
      const historials = await this.getHistorialByReserva([this.access_token, this.modelReserva.id]);
      if (historials) {
        this.modelReserva.historials = historials;
      }
      this.loadingCargandoHistorial = false;
    },

    async _generarNuevoPresupuesto() {
      if (this.loadingGenerandoPresupuesto) {
        return;
      }

      this.loadingGenerandoPresupuesto = true;
      const reserva = await this.generarNuevoPresupuesto([this.access_token, this.modelReserva.id]);
      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva = reserva;
        this.sincronizarProveedoresEtapa();
      }
      this.loadingGenerandoPresupuesto = false;
    },

    async _generarNuevaConfirmacion() {
      if (this.loadingGenerandoConfirmacion) {
        return;
      }

      this.loadingGenerandoConfirmacion = true;
      const reserva = await this.generarNuevaConfirmacion([this.access_token, this.modelReserva.id]);
      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva = reserva;
        this.sincronizarProveedoresEtapa();
      }
      this.loadingGenerandoConfirmacion = false;
    },

    async _generarBonosAlojamientos() {
      if (this.loadingGenerandoBonosAlojamientos) {
        return;
      }

      this.loadingGenerandoBonosAlojamientos = true;
      const reserva = await this.generarBonosAlojamientos([this.access_token, this.modelReserva.id]);
      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva = reserva;
        this.sincronizarProveedoresEtapa();
      }
      this.loadingGenerandoBonosAlojamientos = false;
    },

    async _generarBonosServicios() {
      if (this.loadingGenerandoBonosServicios) {
        return;
      }

      this.loadingGenerandoBonosServicios = true;
      const reserva = await this.generarBonosServicios([this.access_token, this.modelReserva.id]);
      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva = reserva;
        this.sincronizarProveedoresEtapa();
      }
      this.loadingGenerandoBonosServicios = false;
    },

    async _generarProforma() {
      if (this.loadingGenerandoProforma) {
        return;
      }

      this.loadingGenerandoProforma = true;
      const reserva = await this.generarProforma([this.access_token, this.modelReserva.id]);
      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva = reserva;
        this.sincronizarProveedoresEtapa();
      }
      this.loadingGenerandoProforma = false;
    },

    customFilter(item, queryText, itemText) {
      const textOne = itemText.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },


    getNombreArchivo(url) {
      if (!url) return '';
      return url.split('/').pop();
    },

    getMostrarTodosLosProveedoresEtapa(etapa) {
      const etapaPivotId = String(etapa?.pivot?.id || "");
      if (!etapaPivotId) {
        return false;
      }

      return Boolean(this.mostrarTodosLosProveedoresPorEtapa[etapaPivotId]);
    },

    onCambiarMostrarTodosLosProveedoresEtapa(etapa, mostrarTodos) {
      const etapaPivotId = String(etapa?.pivot?.id || "");
      if (!etapaPivotId) {
        return;
      }

      this.$set(
        this.mostrarTodosLosProveedoresPorEtapa,
        etapaPivotId,
        Boolean(mostrarTodos)
      );
    },

    getProveedoresPorEtapa(etapa) {
      const proveedores = Array.isArray(this.masterProveedores) ? this.masterProveedores : [];
      const etapaId = etapa?.final_punto_id;

      if (!this.getMostrarTodosLosProveedoresEtapa(etapa)) {
        return proveedores
          .filter(proveedor => proveedor.punto_id == etapaId)
          .sort((a, b) => (a.nombre_alias || a.nombre || "").localeCompare(b.nombre_alias || b.nombre || ""));
      }

      const etapaIds = new Set(
        (Array.isArray(this.modelReserva?.etapas) ? this.modelReserva.etapas.slice(0, -1) : [])
          .map(etapa => String(etapa?.final_punto_id || ""))
          .filter(Boolean)
      );

      const proveedoresUnicos = new Map();

      proveedores
        .filter(proveedor => etapaIds.has(String(proveedor.punto_id || "")))
        .forEach((proveedor) => {
          if (!proveedoresUnicos.has(proveedor.id)) {
            proveedoresUnicos.set(proveedor.id, proveedor);
          }
        });

      return Array.from(proveedoresUnicos.values())
        .sort((a, b) => (a.nombre_alias || a.nombre || "").localeCompare(b.nombre_alias || b.nombre || ""));
    },

    sincronizarNotasInternasEditables(textoHtml) {
      const texto = textoHtml || '';
      this.notasInternasEditables = this.parsearNotasInternas(texto);
    },

    parsearNotasInternas(textoHtml) {
      if (!textoHtml) {
        return [];
      }
      const separador = /<br\s*\/?>\s*<br\s*\/?>\s*<hr\s*\/?>\s*<br\s*\/?>/i;
      return textoHtml
        .split(separador)
        .map((bloque) => bloque.trim())
        .filter((bloque) => bloque)
        .map((bloque, index) => {
          const matchHeader = bloque.match(/<b>.*?<\/b>/i);
          const headerHtml = matchHeader ? matchHeader[0] : "<b>Nota interna</b>";
          let cuerpo = matchHeader ? bloque.replace(matchHeader[0], "") : bloque;
          cuerpo = cuerpo.replace(/^\s*\n/, "").replace(/^\s*<br\s*\/?>/i, "");
          const bodyText = cuerpo
            .replace(/<br\s*\/?>/gi, "\n")
            .replace(/&nbsp;/gi, " ")
            .trim();
          return {
            id: `nota-${Date.now()}-${index}`,
            headerHtml,
            bodyText,
          };
        });
    },

    construirHtmlNotasInternas(notas) {
      if (!Array.isArray(notas)) {
        return "";
      }
      const notasLimpias = notas
        .map((nota) => {
          const header = (nota?.headerHtml || "<b>Nota interna</b>").trim();
          const cuerpoTexto = (nota?.bodyText || "").trim();
          const cuerpo = cuerpoTexto
            ? `\n${this.escaparHtml(cuerpoTexto).replace(/\n/g, "<br>")}`
            : "";
          return `${header}${cuerpo}<br>`;
        })
        .filter((nota) => nota.trim() !== "<br>");
      return notasLimpias.join("<br><hr><br>");
    },

    escaparHtml(texto) {
      if (!texto) {
        return "";
      }
      return String(texto)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },

    _changeServicioNuevoSeleccionado() {
      this.servicioNuevoTipoDescuento = 'Servicios';
      if (this.servicioNuevoSeleccionado && !this.servicioEsNocheExtra(this.servicioNuevoSeleccionado)) {
        this.servicioNuevoDescripcion = this.getDescripcionNuevoServicio(this.servicioNuevoSeleccionado);
        this.servicioNuevoImporte = this.getImporteNuevoServicio(this.servicioNuevoSeleccionado);
      } else if (this.servicioNuevoSeleccionado && this.servicioEsNocheExtra(this.servicioNuevoSeleccionado)) {
        this.servicioNuevoTarifaInd = 0;
        this.servicioNuevoTarifaDoble = 0;
        this.servicioNuevoTarifaTriple = 0;
        this.servicioNuevoCantidadInd = Number(this.modelReserva.cant_habitaciones_individuales) || 0;
        this.servicioNuevoCantidadDoble = this._getMaximoHabitacionesDobles();
        this.servicioNuevoCantidadTriple = Number(this.modelReserva.cant_habitaciones_triples) || 0;
      }
    },

    _showModalAgregarNotaInterna() {
      this.nuevaNotaInterna = '';
      this.showModalNuevaNotaInterna = true;
    },

    _cerrarModalNuevaNotaInterna() {
      this.showModalNuevaNotaInterna = false;
    },

    async _eliminarNotaInterna(index) {
      if (index < 0 || index >= this.notasInternasEditables.length) {
        return;
      }
      this.notasInternasEditables.splice(index, 1);
      await this._guardarNotasInternasEditadas();
    },

    async _guardarNotasInternasEditadas() {
      if (!this.modelReserva) {
        return;
      }
      this.loadingGuardandoNotasInternas = true;
      const htmlNotas = this.construirHtmlNotasInternas(this.notasInternasEditables);
      this.modelReserva.notas_internas = htmlNotas;
      const res = await this.updateReserva([this.access_token, this.modelReserva]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva = res;
        this.sincronizarNotasInternasEditables(res.notas_internas);
      }
      this.loadingGuardandoNotasInternas = false;
    },

    async _agregarNotaInterna() {
      const reserva = await this.agregarNotaInterna([this.access_token, this.modelReserva.id, this.nuevaNotaInterna]);
      if (reserva && reserva.id == this.modelReserva.id) {
        this.modelReserva.notas_internas = reserva.notas_internas;
      }
      this.showModalNuevaNotaInterna = false;
      this.nuevaNotaInterna = '';
    },

    async _changeProveedorEtapaSeleccionado(etapa) {
      if (!this.haCambiadoProveedorEtapa(etapa)) {
        return;
      }

      if (this.debeConfirmarCambioProveedorEtapa(etapa)) {
        this.abrirDialogConfirmarCambioProveedorEtapa(etapa);
        return;
      }

      await this._actualizarProveedorEtapa(etapa);
    },

    async _actualizarProveedorEtapa(etapa, enviarCorreoCancelacion = 0) {
      const type = typeof etapa.proveedor;
      if (etapa.proveedor && type == 'object' && etapa.proveedor.id) {
        const data = await this.updateProveedorEtapa([
          this.access_token,
          this.modelReserva.id,
          etapa.pivot.id,
          etapa.proveedor.id,
          etapa.proveedor.nombre_alias,
          etapa.final_punto_id,
          enviarCorreoCancelacion,
        ]);
        if (data?.aviso) {
          this.$set(this.avisosEstadoEtapa, etapa.pivot.id, data.aviso);
        } else {
          this.$delete(this.avisosEstadoEtapa, etapa.pivot.id);
        }
        if (data.reserva && data.reserva.id == this.modelReserva.id) {
          this.modelReserva = data.reserva;
          this.sincronizarProveedoresEtapa();
        }
      } else if (etapa.proveedor && type == 'string' && etapa.proveedor != '') {
        const data = await this.updateProveedorEtapa([
          this.access_token,
          this.modelReserva.id,
          etapa.pivot.id,
          null,
          etapa.proveedor,
          etapa.final_punto_id,
          enviarCorreoCancelacion,
        ]);
        if (data?.aviso) {
          this.$set(this.avisosEstadoEtapa, etapa.pivot.id, data.aviso);
        } else {
          this.$delete(this.avisosEstadoEtapa, etapa.pivot.id);
        }
        if (data.reserva && data.proveedor && data.reserva.id == this.modelReserva.id) {
          this.modelReserva = data.reserva;
          this.addMasterProveedor(data.proveedor);
          this.sincronizarProveedoresEtapa();
        }
      } else if (etapa.proveedor == null) {
        const data = await this.updateProveedorEtapa([
          this.access_token,
          this.modelReserva.id,
          etapa.pivot.id,
          null,
          null,
          etapa.final_punto_id,
          enviarCorreoCancelacion,
        ]);
        if (data?.aviso) {
          this.$set(this.avisosEstadoEtapa, etapa.pivot.id, data.aviso);
        } else {
          this.$delete(this.avisosEstadoEtapa, etapa.pivot.id);
        }
        if (data.reserva && data.reserva.id == this.modelReserva.id) {
          this.modelReserva = data.reserva;
          this.sincronizarProveedoresEtapa();
        }
      }
    },

    debeConfirmarCambioProveedorEtapa(etapa) {
      return Number(etapa?.pivot?.estado_id) >= 5;
    },

    haCambiadoProveedorEtapa(etapa) {
      const proveedorSeleccionado = etapa?.proveedor;
      const proveedorActualId = etapa?.pivot?.proveedor_id;
      const proveedorActualNombre = etapa?.pivot?.proveedor_nombre || null;

      if (proveedorSeleccionado == null) {
        return proveedorActualId != null || proveedorActualNombre != null;
      }

      if (typeof proveedorSeleccionado === 'object') {
        if (proveedorSeleccionado.id) {
          return proveedorSeleccionado.id != proveedorActualId;
        }

        return proveedorSeleccionado.nombre_alias !== proveedorActualNombre;
      }

      if (typeof proveedorSeleccionado === 'string') {
        return proveedorSeleccionado !== (proveedorActualNombre || '');
      }

      return true;
    },

    abrirDialogConfirmarCambioProveedorEtapa(etapa) {
      this.cambioProveedorEtapaPendiente = {
        etapaId: etapa?.pivot?.id,
        proveedorAnteriorNombre: etapa?.pivot?.proveedor_nombre || 'actual',
        proveedorSeleccionado: this.clonarProveedorEtapa(etapa?.proveedor),
      };
      this.showDialogConfirmarCambioProveedorEtapa = true;
    },

    async confirmarCambioProveedorEtapa() {
      const etapaId = this.cambioProveedorEtapaPendiente?.etapaId;
      const etapa = this.getEtapaByPivotId(etapaId);
      if (!etapa) {
        this.cerrarDialogConfirmarCambioProveedorEtapa();
        return;
      }

      etapa.proveedor = this.clonarProveedorEtapa(this.cambioProveedorEtapaPendiente?.proveedorSeleccionado);

      this.procesandoCambioProveedorEtapa = true;
      try {
        await this._actualizarProveedorEtapa(etapa, 1);
      } finally {
        this.procesandoCambioProveedorEtapa = false;
        this.cerrarDialogConfirmarCambioProveedorEtapa();
      }
    },

    cancelarCambioProveedorEtapa() {
      const etapaId = this.cambioProveedorEtapaPendiente?.etapaId;
      const etapa = this.getEtapaByPivotId(etapaId);
      if (etapa) {
        etapa.proveedor = this.getProveedorActualEtapa(etapa);
      }
      this.cerrarDialogConfirmarCambioProveedorEtapa();
    },

    cerrarDialogConfirmarCambioProveedorEtapa() {
      this.showDialogConfirmarCambioProveedorEtapa = false;
      this.cambioProveedorEtapaPendiente = null;
    },

    getEtapaByPivotId(etapaId) {
      return this.modelReserva?.etapas?.find(item => item?.pivot?.id == etapaId) || null;
    },

    getProveedorActualEtapa(etapa) {
      if (etapa?.pivot?.proveedor_id) {
        const proveedor = this.masterProveedores.find(item => item.id == etapa.pivot.proveedor_id);
        if (proveedor) {
          return proveedor;
        }

        return {
          id: etapa.pivot.proveedor_id,
          nombre_alias: etapa.pivot.proveedor_nombre,
        };
      }

      return etapa?.pivot?.proveedor_nombre || null;
    },

    clonarProveedorEtapa(proveedor) {
      if (proveedor && typeof proveedor === 'object') {
        return { ...proveedor };
      }

      return proveedor ?? null;
    },

    getAvisoEstadoEtapa(etapa) {
      const etapaId = etapa?.pivot?.id;
      if (!etapaId) {
        return [];
      }
      const aviso = this.avisosEstadoEtapa[etapaId];
      return aviso ? [aviso] : [];
    },

    sincronizarProveedoresEtapa() {
      for (let etapa of this.modelReserva.etapas) {
        if (etapa.pivot.proveedor_id && etapa.pivot.proveedor_nombre) {
          const prov = this.masterProveedores.find(proveedor => proveedor.id == etapa.pivot.proveedor_id);
          if (prov) {
            etapa.proveedor = prov;
          }
        }
      }
    },

    getImporteNuevoServicio(servicio) {
      if (!this.servicioEsNocheExtra(servicio) && servicio.titulo !== 'Traslados extra' && servicio.titulo !== 'Servicios extra') {
        let tarifa = parseFloat(this._calcularTarifaDeServicio(servicio)).toFixed(2);
        if (servicio.x_reserva) {
          return parseFloat(tarifa);
        } else {
          let importeServicio = parseFloat(tarifa) * this.modelReserva.cant_peregrinos;
          return importeServicio;
        }
      }


      return 0;
    },

    getDescripcionNuevoServicio(servicio) {
      if (servicio) {
        if (servicio.titulo.includes('Traslado privado')) {
          return '';
        }

        if (this.servicioEsNocheExtra(servicio)) {
          return '';
        }

        if (servicio.titulo == 'Traslados extra') {
          return '';
        }

        if (servicio.titulo == 'Servicios extra') {
          return '';
        }

        if (servicio.titulo == 'Descuento') {
          return '';
        }

        if (servicio.titulo.includes('Seguro de')) {
          return '';
        }

        if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
          return this.textoPendiente;
        }
        if (servicio.x_reserva == 1) {
          return "(" + this._calcularTarifaDeServicioWithPersona(servicio) + "€)";
        }

        if (servicio.x_persona == 1) {
          return '(' + this._calcularTarifaDeServicio(servicio) + '€ x ' + this.modelReserva.cant_peregrinos + ' ' + this.textoPersonas + ')';
        }

      }
      return '';

    },

    _calcularTarifaDeServicio(servicio) {
      if (servicio.titulo.includes('Traslado privado') && servicio.importe > 0) {
        return servicio.importe;
      }
      if (servicio.titulo.includes('Excursión')) {
        return this._getTarifaExcursionPorFecha(servicio);
      }

      if (!servicio || !servicio.tarifa) {
        return 0;
      }

      if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {

        return 0;
      }

      let tarifa = parseFloat(servicio.tarifa);

      if (servicio.x_reserva) {
        if (this.modelReserva.cant_peregrinos <= servicio.max_pendiente) {
          return parseFloat(tarifa);
        }
      }

      if (servicio.x_noche) {
        tarifa = tarifa * this.modelReserva.camino.noches;
      }
      if (servicio.x_etapa) {
        tarifa = tarifa * (this.modelReserva.camino.noches - 1);
      }

      return parseFloat(tarifa);
    },

    _getTarifaExcursionPorFecha(servicio) {
      const fechaLlegada = new Date(this.modelReserva.fecha_llegada);
      const year = fechaLlegada.getFullYear();

      if (year >= 2027 && servicio.tarifa_2027) {
        return servicio.tarifa_2027;
      }

      if (year >= 2026 && servicio.tarifa_2026) {
        return servicio.tarifa_2026;
      }

      return servicio.tarifa;
    },

    _calcularTarifaDeServicioWithPersona(servicio) {

      if (servicio.titulo.includes('Traslado privado') && servicio.importe > 0) {
        return Number(servicio.importe).toFixed(2);
      }

      if (this.servicioEsNocheExtra(servicio) && servicio.seleccionado) {
        return 0;
      }

      if (servicio.titulo == 'Traslados extra' && servicio.seleccionado) {
        return 0;
      }

      if (servicio.titulo == 'Servicios extra' && servicio.seleccionado) {
        return 0;
      }

      if (!servicio || !servicio.tarifa) {
        return 0;
      }

      if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
        return 0;
      }


      let tarifa = this._calcularTarifaDeServicio(servicio);



      let result = 0;

      if (servicio.x_reserva) {
        if (this.modelReserva.cant_peregrinos <= servicio.max_pendiente) {
          return parseFloat(tarifa);
        }
      }

      if (servicio.x_persona) {
        result = tarifa * this.modelReserva.cant_peregrinos;
      }


      return Number(result).toFixed(2);
    },



    _cerrarModalAgregarServicio() {
      this.servicioNuevoSeleccionado = null;
      this.servicioNuevoTipoDescuento = 'Servicios';
      this.servicioNuevoImporte = 0;
      this.servicioNuevoDescripcion = '';
      this.servicioNuevoLocalidad = '';
      this.servicioNuevoLocalidadReferencia = '';
      this.mostrarReferenciaLocalidad = false;
      this.servicioNuevoTarifaInd = 0;
      this.servicioNuevoTarifaDoble = 0;
      this.servicioNuevoTarifaTriple = 0;
      this.servicioNuevoCantidadInd = 0;
      this.servicioNuevoCantidadDoble = 0;
      this.servicioNuevoCantidadTriple = 0;

      this.showModalAgregarServicio = false;
    },

    _cerrarDialogEditarNocheExtra() {
      this.showDialogEditarNocheExtra = false;
      this.servicioNocheExtraEditando = null;
      this.servicioEditarNocheExtraTarifaInd = 0;
      this.servicioEditarNocheExtraTarifaDoble = 0;
      this.servicioEditarNocheExtraTarifaTriple = 0;
      this.servicioEditarNocheExtraCantidadInd = 0;
      this.servicioEditarNocheExtraCantidadDoble = 0;
      this.servicioEditarNocheExtraCantidadTriple = 0;
      this.loadingGuardandoEdicionNocheExtra = false;
    },

    _showConfirmacionCancelaServicio(servicio) {
      if (!this.loadingGuardandoServicios) {
        this.servicioSeleccionado = servicio;
        this.showConfirmacionCancelaServicio = true;
      }
    },

    async _eliminarServicio() {
      this.loadingGuardandoServicios = true;
      this.showConfirmacionCancelaServicio = false;
      if (this.servicioSeleccionado != null && this.servicioSeleccionado.id != null) {
        const reserva = await this.eliminarServicioReserva([this.access_token, this.servicioSeleccionado.id, this.modelReserva.id]);
        if (reserva && reserva.id == this.modelReserva.id) {
          this.modelReserva = reserva;
          this.sincronizarProveedoresEtapa();
        }
      }
      this.loadingGuardandoServicios = false;
      this.servicioSeleccionado = null;
    },

    onServicioSeleccionado(servicio) {
      if (servicio.seleccionado) {
        if (this.nochesextras.length == 0) {
          this._agregarNocheExtraVacia('');
        }
      } else {
        //  this.nochesextras = this.nochesextras.filter(noche => noche.localidad !== servicio.localidad);
      }
    },



    getTituloServicio(servicio) {
      const language = this.modelReserva?.language || 'ES';

      switch (language) {
        case 'EN':
          return servicio.titulo_EN || servicio.titulo;
        case 'DE':
          return servicio.titulo_DE || servicio.titulo;
        default:
          return servicio.titulo;
      }
    },

    _agregarNocheExtraVacia(localidad) {
      this.nochesextras.push({
        localidad: localidad,
        tarifa_ind: 0,
        tarifa_doble: 0,
        tarifa_triple: 0,
      });
    },

    _actualizarEstadoReserva() {
      /*const res = await this.updateEstadoReserva([this.access_token, this.modelReserva.id, this.modelReserva.estado.id]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva = res;
      }*/
    },

    _getSubtitulo(servicio) {
      if (servicio) {
        if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
          return '';
        }
        if (servicio.x_reserva == 1) {
          return '(' + this._calcularTarifaDeServicio(servicio) + ' €)';
        }

        if (servicio.x_persona == 1) {
          return '(' + this._calcularTarifaDeServicio(servicio) + ' €)';
        }

      }
      return '';
    },

    _calcularTarifaDeServicio(servicio) {
      if (servicio.titulo.includes('Traslado privado') && servicio.importe > 0) {
        return servicio.importe;
      }

      if (servicio.titulo.includes('Excursión')) {
        return this._getTarifaExcursionPorFecha(servicio);
      }

      if (!servicio || !servicio.tarifa) {
        return 0;
      }

      if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {

        return 0;
      }

      let tarifa = parseFloat(servicio.tarifa);

      if (servicio.x_reserva) {
        if (this.modelReserva.cant_peregrinos <= servicio.max_pendiente) {
          return parseFloat(tarifa);
        }
      }

      if (servicio.x_noche) {
        tarifa = tarifa * this.modelReserva.camino.noches;
      }
      if (servicio.x_etapa) {
        tarifa = tarifa * (this.modelReserva.camino.noches - 1);
      }

      return parseFloat(tarifa);
    },

    _cerrarVentana() {
      this.infoEtapas = [];
      this.$emit("cerrarFormularioReserva");
    },

    async _guardarServicios() {
      this.loadingGuardandoServicios = true;
      const serviciosParaGuardar = this.modelReserva.servicios.map(servicio => {
        const servicioParaGuardar = {
          id: servicio.id,
          descripcion: servicio.descripcion,
          importe: servicio.importe,
          fecha: servicio.fecha,
          tipo_descuento: servicio.tipo_descuento || null,
        };

        if (this.servicioEsNocheExtra(servicio)) {
          servicioParaGuardar.tarifa_individual_extra = servicio.tarifa_individual_extra ?? null;
          servicioParaGuardar.tarifa_doble_extra = servicio.tarifa_doble_extra ?? null;
          servicioParaGuardar.tarifa_triple_extra = servicio.tarifa_triple_extra ?? null;
          servicioParaGuardar.cant_habitaciones_individuales_extra = servicio.cant_habitaciones_individuales_extra ?? null;
          servicioParaGuardar.cant_habitaciones_dobles_extra = servicio.cant_habitaciones_dobles_extra ?? null;
          servicioParaGuardar.cant_habitaciones_triples_extra = servicio.cant_habitaciones_triples_extra ?? null;
        }

        return servicioParaGuardar;
      });
      const res = await this.guardarServiciosReserva([this.access_token, this.modelReserva.id, serviciosParaGuardar]);
      if (res && Array.isArray(res.servicios)) {
        this.modelReserva.servicios = res.servicios;
      } else if (res && res.reserva && Array.isArray(res.reserva.servicios)) {
        this.modelReserva.servicios = res.reserva.servicios;
      }
      this.loadingGuardandoServicios = false;
      return res;
    },

    _onInputFechaServicio(servicio, valor) {
      if (!servicio) {
        return;
      }
      this.$set(servicio, "fecha", valor || null);
      this.$set(servicio, "_showFechaServicio", false);
      this._changeFechaServicio(servicio);
    },

    async _changeFechaServicio(servicio) {
      if (!servicio || !this.modelReserva) {
        return;
      }
      const servicioId = servicio.id;
      const fecha = this.normalizarFechaServicio(servicio.fecha);
      const res = await this.updateReservaServicioFecha([
        this.access_token,
        servicioId,
        fecha
      ]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva.servicios = res.servicios;
      }
    },

    _limpiarFechaServicio(servicio) {
      if (!servicio) {
        return;
      }
      this.$set(servicio, "fecha", null);
      this._changeFechaServicio(servicio);
    },

    getHabitacionesDisponiblesParaPasajero(pasajero) {
      const disponibles = this.getHabitacionesDisponibles();
      const asignada = this.getHabitacionAsignada(pasajero);
      if (asignada && !disponibles.some(item => item.tipo === asignada.tipo && item.numero === asignada.numero)) {
        return [asignada, ...disponibles];
      }
      return disponibles;
    },

    getHabitacionAsignada(pasajero) {
      if (!this.modelReserva?.roaming || !pasajero) {
        return null;
      }
      const pasajeroId = this.getIdPasajero(pasajero);
      if (!pasajeroId) {
        return null;
      }
      const roaming = this.modelReserva.roaming;
      const tipos = this.getOrdenTiposRoaming(roaming);
      for (const tipo of tipos) {
        const habitaciones = Array.isArray(roaming[tipo]) ? roaming[tipo] : [];
        for (const habitacion of habitaciones) {
          const pasajeros = Array.isArray(habitacion?.pasajeros) ? habitacion.pasajeros : [];
          if (this.pasajerosIncluyenId(pasajeros, pasajeroId)) {
            return this.crearItemHabitacion(tipo, habitacion?.numero);
          }
        }
      }
      return null;
    },

    getHabitacionesDisponibles() {
      if (!this.modelReserva?.roaming) {
        return [];
      }
      const roaming = this.modelReserva.roaming;
      const tipos = this.getOrdenTiposRoaming(roaming);
      const res = [];
      for (const tipo of tipos) {
        const habitaciones = Array.isArray(roaming[tipo]) ? roaming[tipo] : [];
        const capacidad = this.getCapacidadHabitacion(tipo);
        habitaciones.forEach((habitacion) => {
          const pasajeros = Array.isArray(habitacion?.pasajeros) ? habitacion.pasajeros : [];
          if (pasajeros.length < capacidad) {
            res.push(this.crearItemHabitacion(tipo, habitacion?.numero));
          }
        });
      }
      return res;
    },

    getOrdenTiposRoaming(roaming) {
      const orden = [
        "individuales",
        "dobles",
        "dobles_matrimoniales",
        "triples",
        "cuadruples",
      ];
      const existentes = Object.keys(roaming || {});
      return orden.filter((tipo) => existentes.includes(tipo));
    },

    getCapacidadHabitacion(tipo) {
      const capacidades = {
        individuales: 1,
        dobles: 2,
        triples: 3,
        cuadruples: 4,
        dobles_matrimoniales: 2,
      };
      return capacidades[tipo] || 1;
    },

    crearItemHabitacion(tipo, numero) {
      return {
        tipo,
        numero,
        label: `${this.getEtiquetaHabitacion(tipo)} ${numero || ""}`.trim(),
      };
    },

    getEtiquetaHabitacion(tipo) {
      const etiquetas = {
        individuales: "Individual",
        dobles: "Doble (2 Ind)",
        triples: "Triple",
        cuadruples: "Cuadruple",
        dobles_matrimoniales: "Doble (1 Mat)",
      };
      return etiquetas[tipo] || tipo;
    },

    pasajerosIncluyenId(pasajeros, pasajeroId) {
      const objetivo = String(pasajeroId);
      return pasajeros.some((pasajero) => String(this.getIdPasajero(pasajero)) === objetivo);
    },

    getIdPasajero(pasajero) {
      if (!pasajero) {
        return null;
      }
      if (typeof pasajero === "number" || typeof pasajero === "string") {
        return pasajero;
      }
      return pasajero.id ?? pasajero.pasajero_id ?? null;
    },

    async onAsignarHabitacion(pasajero, seleccion) {
      if (!pasajero || !seleccion || typeof seleccion !== "object") {
        return;
      }
      const reservaId = this.modelReserva?.id;
      const pasajeroId = this.getIdPasajero(pasajero);
      if (!reservaId || !pasajeroId) {
        return;
      }
      const tipo = seleccion.tipo;
      const numero = seleccion.numero;
      if (!tipo || !numero) {
        return;
      }
      const res = await this.asignarPasajeroHabitacion([
        this.access_token,
        reservaId,
        pasajeroId,
        tipo,
        numero,
      ]);
      if (res?.id === this.modelReserva.id) {
        this.modelReserva = res;
      } else if (res?.roaming) {
        this.$set(this.modelReserva, "roaming", res.roaming);
      } else {
        this.actualizarRoamingLocal(pasajeroId, tipo, numero);
      }
    },

    actualizarRoamingLocal(pasajeroId, tipo, numero) {
      if (!this.modelReserva?.roaming) {
        return;
      }
      const roaming = this.modelReserva.roaming;
      const tipos = Object.keys(roaming || {});
      tipos.forEach((tipoActual) => {
        const habitaciones = Array.isArray(roaming[tipoActual]) ? roaming[tipoActual] : [];
        habitaciones.forEach((habitacion) => {
          if (!Array.isArray(habitacion?.pasajeros)) {
            habitacion.pasajeros = [];
          }
          habitacion.pasajeros = habitacion.pasajeros.filter(
            (pasajero) => String(this.getIdPasajero(pasajero)) !== String(pasajeroId)
          );
        });
      });
      const listado = Array.isArray(roaming[tipo]) ? roaming[tipo] : [];
      const index = listado.findIndex((habitacion) => String(habitacion?.numero) === String(numero));
      if (index >= 0) {
        const habitacion = listado[index];
        const pasajeros = Array.isArray(habitacion?.pasajeros) ? habitacion.pasajeros : [];
        pasajeros.push(pasajeroId);
        habitacion.pasajeros = pasajeros;
      }
      this.$set(this.modelReserva, "roaming", roaming);
    },

    getFechaServicioParaPicker(servicio) {
      const fechaBase = this.getFechaServicioPorDefecto(servicio);
      return this.normalizarFechaServicio(fechaBase);
    },

    getFechaServicioMostrada(servicio) {
      const fechaBase = this.getFechaServicioPorDefecto(servicio);
      return this.formatearFechaSinHora(fechaBase);
    },

    normalizarFechaServicio(fecha) {
      if (!fecha) {
        return null;
      }
      if (fecha instanceof Date) {
        if (Number.isNaN(fecha.getTime())) {
          return null;
        }
        return fecha.toISOString().slice(0, 10);
      }
      if (typeof fecha !== "string") {
        return null;
      }
      const valor = fecha.trim();
      if (!valor) {
        return null;
      }
      if (/^\d{4}-\d{2}-\d{2}/.test(valor)) {
        return valor.slice(0, 10);
      }
      const match = valor.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      if (match) {
        const [, dia, mes, anio] = match;
        return `${anio}-${mes}-${dia}`;
      }
      return null;
    },

    getFechaServicioPorDefecto(servicio) {
      if (!servicio) {
        return null;
      }
      if (this.esServicioExcursion(servicio)) {
        if (!servicio.fecha && this.modelReserva?.fecha_llegada) {
          return this.modelReserva.fecha_llegada;
        }
      }
      return servicio.fecha || null;
    },

    debeMostrarFechaServicio(servicio) {
      return (
        this.esServicioTrasladosExtra(servicio) ||
        this.esServicioServiciosExtra(servicio) ||
        this.esServicioExcursion(servicio)
      );
    },

    esServicioTrasladosExtra(servicio) {
      const titulo = this.getTituloServicioNormalizado(servicio);
      const prefijos = [
        "traslado privado",
        "traslados extra",
        "private transfer",
        "extra transfer",
        "privater transfer",
        "zusatzliche transfer",
        "zusätzliche transfer",
      ];
      return prefijos.some((prefijo) => titulo.startsWith(prefijo));
    },

    esServicioServiciosExtra(servicio) {
      const titulo = this.getTituloServicioNormalizado(servicio);
      const prefijos = ["servicios extra", "extra services", "zusatzleistungen"];
      return prefijos.some((prefijo) => titulo.startsWith(prefijo));
    },

    esServicioExcursion(servicio) {
      const titulo = this.getTituloServicioNormalizado(servicio);
      const prefijos = ["excursion", "excursión", "one day tour", "tagestour"];
      return prefijos.some((prefijo) => titulo.startsWith(prefijo));
    },

    servicioEsNocheExtra(servicio) {
      const titulo = this.getTituloServicioNormalizado(servicio);
      const prefijos = [
        "noche extra",
        "noches extra",
        "extra night",
        "extra nights",
        "zusatznacht",
        "zusatznächte",
        "zusätzliche nacht",
        "zusätzliche nächte",
      ];
      return prefijos.some((prefijo) => titulo.startsWith(prefijo));
    },

    esServicioDescuento(servicio) {
      const titulo = this.getTituloServicioNormalizado(servicio);
      return ["descuento", "discount", "rabatt"].some((prefijo) => titulo.startsWith(prefijo));
    },

    esDescuentoReserva(servicio) {
      return this.esServicioDescuento(servicio) &&
        String(servicio?.tipo_descuento || '').trim().toLowerCase() === 'reserva';
    },

    getTipoDescuentoServicioParaGuardar(servicio) {
      return servicio?.tipo_descuento || 'Servicios';
    },

    getTituloServicioNormalizado(servicio) {
      return (servicio?.titulo || "").toLowerCase().trim();
    },

    _showDialogAgregarServicio() {
      this.showModalAgregarServicio = true;
    },

    _showDialogEditarNocheExtra(servicio) {
      if (!servicio || !this.servicioEsNocheExtra(servicio)) {
        return;
      }

      this.servicioNocheExtraEditando = servicio;
      this.servicioEditarNocheExtraTarifaInd = servicio.tarifa_individual_extra ??
        this._getTarifaNocheExtraDesdeDescripcion(servicio.descripcion, ["ind", "single", "einzelzimmer"]);
      this.servicioEditarNocheExtraTarifaDoble = servicio.tarifa_doble_extra ??
        this._getTarifaNocheExtraDesdeDescripcion(servicio.descripcion, ["doble", "double", "doppelzimmer"]);
      this.servicioEditarNocheExtraTarifaTriple = servicio.tarifa_triple_extra ??
        this._getTarifaNocheExtraDesdeDescripcion(servicio.descripcion, ["triple", "dreibettzimmer"]);
      this.servicioEditarNocheExtraCantidadInd = servicio.cant_habitaciones_individuales_extra ??
        this.modelReserva.cant_habitaciones_individuales;
      this.servicioEditarNocheExtraCantidadDoble = servicio.cant_habitaciones_dobles_extra ??
        (Number(this.modelReserva.cant_habitaciones_dobles) || 0) +
        (Number(this.modelReserva.cant_habitaciones_dobles_matrimoniales) || 0);
      this.servicioEditarNocheExtraCantidadTriple = servicio.cant_habitaciones_triples_extra ??
        this.modelReserva.cant_habitaciones_triples;
      this._limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadInd', this.modelReserva.cant_habitaciones_individuales);
      this._limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadDoble', this._getMaximoHabitacionesDobles());
      this._limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadTriple', this.modelReserva.cant_habitaciones_triples);
      this.showDialogEditarNocheExtra = true;
    },

    async _agregarServicio() {
      this.showModalAgregarServicio = false;

      if (this.servicioNuevoSeleccionado && this.servicioNuevoTituloParaGuardar != '') {
        const esNocheExtra = this.servicioEsNocheExtra(this.servicioNuevoSeleccionado);
        const serviciosIdsAntesDeAgregar = new Set(this.modelReserva.servicios.map(servicio => String(servicio.id)));
        const valoresNocheExtra = {
          tarifa_individual_extra: Number(this.servicioNuevoTarifaInd) || 0,
          tarifa_doble_extra: Number(this.servicioNuevoTarifaDoble) || 0,
          tarifa_triple_extra: Number(this.servicioNuevoTarifaTriple) || 0,
          cant_habitaciones_individuales_extra: Number(this.servicioNuevoCantidadInd) || 0,
          cant_habitaciones_dobles_extra: Number(this.servicioNuevoCantidadDoble) || 0,
          cant_habitaciones_triples_extra: Number(this.servicioNuevoCantidadTriple) || 0,
        };
        let etapa_id = null;

        if (this.servicioEsNocheExtra(this.servicioNuevoSeleccionado) && this.servicioNuevoLocalidad != '') {
          if (this.servicioNuevoLocalidadReferencia != '') {
            const etapaEncontrada = this.modelReserva.camino.etapas.find(etapa => etapa.final_punto.nombre.toLowerCase() === this.servicioNuevoLocalidadReferencia.toLowerCase());
            if (etapaEncontrada) {
              etapa_id = etapaEncontrada.id;
            }
          } else {
            const etapaEncontrada = this.modelReserva.camino.etapas.find(etapa => etapa.final_punto.nombre.toLowerCase() === this.servicioNuevoLocalidad.toLowerCase());
            if (etapaEncontrada) {
              etapa_id = etapaEncontrada.id;
            }
          }
        }


        const reserva = await this.agregarServicioReserva([this.access_token,
        this.modelReserva.id,
        this.servicioNuevoSeleccionado.id,
        this.servicioNuevoTituloParaGuardar,
        this.servicioNuevoDescripcionParaGuardar,
        this.servicioNuevoImporte,
          etapa_id,
          this.esServicioDescuento(this.servicioNuevoSeleccionado) ? this.servicioNuevoTipoDescuento : null]);
        if (reserva && reserva.id == this.modelReserva.id) {
          this.modelReserva = reserva;
          if (esNocheExtra) {
            const servicioNocheExtraCreado = this.modelReserva.servicios.find(servicio =>
              !serviciosIdsAntesDeAgregar.has(String(servicio.id)) && this.servicioEsNocheExtra(servicio)
            );

            if (servicioNocheExtraCreado) {
              Object.entries(valoresNocheExtra).forEach(([campo, valor]) => this.$set(servicioNocheExtraCreado, campo, valor));
              await this._guardarServicios();
            }
          }
          this.sincronizarProveedoresEtapa();
        }
        this.servicioNuevoSeleccionado = null;
        this.servicioNuevoTipoDescuento = 'Servicios';
        this.servicioNuevoImporte = 0;
        this.servicioNuevoDescripcion = '';
        this.servicioNuevoLocalidad = '';
        this.servicioNuevoLocalidadReferencia = '';
        this.mostrarReferenciaLocalidad = false;
        this.servicioNuevoTarifaInd = 0;
        this.servicioNuevoTarifaDoble = 0;
        this.servicioNuevoTarifaTriple = 0;
        this.servicioNuevoCantidadInd = 0;
        this.servicioNuevoCantidadDoble = 0;
        this.servicioNuevoCantidadTriple = 0;
      }





    },

    _getTarifaNocheExtraDesdeDescripcion(descripcion, labels) {
      const texto = typeof descripcion === 'string' ? descripcion : '';

      for (const label of labels) {
        const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const match = texto.match(new RegExp(`${escaped}\\s*x\\s*([0-9]+(?:[\\.,][0-9]+)?)€`, 'i'));
        if (match && match[1] != null) {
          return Number(String(match[1]).replace(',', '.')) || 0;
        }
      }

      return 0;
    },

    _getMaximoHabitacionesDobles() {
      return (Number(this.modelReserva?.cant_habitaciones_dobles) || 0) +
        (Number(this.modelReserva?.cant_habitaciones_dobles_matrimoniales) || 0);
    },

    _limitarCantidadNocheExtra(campo, valor, maximo) {
      if (arguments.length === 2) {
        maximo = valor;
        valor = this[campo];
      }

      const cantidad = Number(valor);
      this[campo] = Math.min(Math.max(Number.isFinite(cantidad) ? Math.trunc(cantidad) : 0, 0), Number(maximo) || 0);
    },

    _normalizarTarifaNocheExtra(campo, valor) {
      const texto = String(valor == null ? '' : valor)
        .replace(',', '.')
        .replace(/[^0-9.]/g, '');
      const [parteEntera, ...partesDecimales] = texto.split('.');

      this[campo] = partesDecimales.length > 0
        ? parteEntera + '.' + partesDecimales.join('')
        : parteEntera;
    },

    _getImporteNocheExtraConTarifas(tarifaInd, tarifaDoble, tarifaTriple, cantidadInd, cantidadDoble, cantidadTriple) {
      let importe = 0;
      const ind = Number(tarifaInd) || 0;
      const doble = Number(tarifaDoble) || 0;
      const triple = Number(tarifaTriple) || 0;
      const habitacionesInd = Number(cantidadInd) || 0;
      const habitacionesDoble = Number(cantidadDoble) || 0;
      const habitacionesTriple = Number(cantidadTriple) || 0;

      if (ind > 0 && habitacionesInd > 0) {
        importe += habitacionesInd * ind;
      }
      if (doble > 0 && habitacionesDoble > 0) {
        importe += habitacionesDoble * doble;
      }
      if (triple > 0 && habitacionesTriple > 0) {
        importe += habitacionesTriple * triple;
      }

      return importe;
    },

    _getDescripcionNocheExtraConTarifas(tarifaInd, tarifaDoble, tarifaTriple, cantidadInd, cantidadDoble, cantidadTriple) {
      let desc = '';
      let tipoInd = 'Ind';
      let tipoDoble = 'Doble';
      let tipoTriple = 'Triple';

      if (this.modelReserva.language == 'EN') {
        tipoInd = 'Single';
        tipoDoble = 'Double';
      } else if (this.modelReserva.language == 'DE') {
        tipoInd = 'Einzelzimmer';
        tipoDoble = 'Doppelzimmer';
        tipoTriple = 'Dreibettzimmer';
      }

      const ind = Number(tarifaInd) || 0;
      const doble = Number(tarifaDoble) || 0;
      const triple = Number(tarifaTriple) || 0;
      const habitacionesInd = Number(cantidadInd) || 0;
      const habitacionesDoble = Number(cantidadDoble) || 0;
      const habitacionesTriple = Number(cantidadTriple) || 0;

      if (habitacionesInd > 0 && ind > 0) {
        desc += habitacionesInd + ' ' + tipoInd + ' x ' + ind.toFixed(2) + '€, ';
      }
      if (habitacionesDoble > 0 && doble > 0) {
        desc += habitacionesDoble + ' ' + tipoDoble + ' x ' + doble.toFixed(2) + '€, ';
      }
      if (habitacionesTriple > 0 && triple > 0) {
        desc += habitacionesTriple + ' ' + tipoTriple + ' x ' + triple.toFixed(2) + '€';
      }

      desc = desc.replace(/,\s*$/, '');
      return desc ? '(' + desc + ')' : '';
    },

    _getImporteEdicionNocheExtra() {
      return this._getImporteNocheExtraConTarifas(
        this.servicioEditarNocheExtraTarifaInd,
        this.servicioEditarNocheExtraTarifaDoble,
        this.servicioEditarNocheExtraTarifaTriple,
        this.servicioEditarNocheExtraCantidadInd,
        this.servicioEditarNocheExtraCantidadDoble,
        this.servicioEditarNocheExtraCantidadTriple
      );
    },

    _getDescripcionEdicionNocheExtra() {
      return this._getDescripcionNocheExtraConTarifas(
        this.servicioEditarNocheExtraTarifaInd,
        this.servicioEditarNocheExtraTarifaDoble,
        this.servicioEditarNocheExtraTarifaTriple,
        this.servicioEditarNocheExtraCantidadInd,
        this.servicioEditarNocheExtraCantidadDoble,
        this.servicioEditarNocheExtraCantidadTriple
      );
    },

    async _guardarEdicionNocheExtra() {
      if (!this.servicioNocheExtraEditando || this.loadingGuardandoEdicionNocheExtra) {
        return;
      }

      this.loadingGuardandoEdicionNocheExtra = true;
      this._limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadInd', this.modelReserva.cant_habitaciones_individuales);
      this._limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadDoble', this._getMaximoHabitacionesDobles());
      this._limitarCantidadNocheExtra('servicioEditarNocheExtraCantidadTriple', this.modelReserva.cant_habitaciones_triples);

      this.$set(this.servicioNocheExtraEditando, 'descripcion', this._getDescripcionEdicionNocheExtra());
      this.$set(this.servicioNocheExtraEditando, 'importe', this._getImporteEdicionNocheExtra());
      this.$set(this.servicioNocheExtraEditando, 'tarifa_individual_extra', Number(this.servicioEditarNocheExtraTarifaInd) || 0);
      this.$set(this.servicioNocheExtraEditando, 'tarifa_doble_extra', Number(this.servicioEditarNocheExtraTarifaDoble) || 0);
      this.$set(this.servicioNocheExtraEditando, 'tarifa_triple_extra', Number(this.servicioEditarNocheExtraTarifaTriple) || 0);
      this.$set(this.servicioNocheExtraEditando, 'cant_habitaciones_individuales_extra', Number(this.servicioEditarNocheExtraCantidadInd) || 0);
      this.$set(this.servicioNocheExtraEditando, 'cant_habitaciones_dobles_extra', Number(this.servicioEditarNocheExtraCantidadDoble) || 0);
      this.$set(this.servicioNocheExtraEditando, 'cant_habitaciones_triples_extra', Number(this.servicioEditarNocheExtraCantidadTriple) || 0);

      await this._guardarServicios();
      this._cerrarDialogEditarNocheExtra();
    },

    async _getCaminos() {
      await this.getCaminos([this.access_token, false]);
    },

    async _getOrigenes() {
      await this.getOrigenes([this.access_token, false]);
    },

    _getNombreFinalEtapa(etapa_id) {
      let etapa = this.modelReserva.camino.etapas.find(c => c.id == etapa_id);
      if (etapa != null) {
        return etapa.final_punto.nombre;
      }
      return '';
    },

    _changeOrigen(origenSeleccionado) {
      console.log("Origen seleccionado:", this.modelReserva.origen);
      

      const identificador = String(origenSeleccionado?.identificador || "").toLowerCase();
      const telefono = String(origenSeleccionado?.telefono || "").trim();
      const email = String(origenSeleccionado?.email || "").trim();

      if (
        this.accion === "crear" &&
        identificador !== "web" &&
        telefono !== "" &&
        email !== "" &&
        this.modelReserva &&
        this.modelReserva.cliente
      ) {
        this.modelReserva.cliente.telefono = telefono;
        this.modelReserva.cliente.email = email;
      }
    },

    mostrarCampoCodigoAgencia() {
      return Number(this.modelReserva?.origen?.id || 0) > 1;
    },


    _changeCamino() {
      if (this.accion == "editar") {
        this._actualizarEtapasPorCambiodeCamino();
        this.actualizarTarifasCamino();
      }
    },

    _changeLanguage() {
      if (this.accion == "editar") {
        this._actualizarEtapasPorCambiodeCamino();
      }
    },

    async _actualizarEtapasPorCambiodeCamino() {
      var res = await this.actualizarEtapasPorCambiodeCamino([this.access_token, this.modelReserva.id, this.modelReserva.camino.id, this.modelReserva.language]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva = res;
        this._actualizarImportePresupuestado();
      }

    },

    calcularNochesTotales() {
      if (!this.modelReserva.fecha_inicio || !this.modelReserva.fecha_llegada) return 0;

      const inicio = new Date(this.modelReserva.fecha_inicio);
      const llegada = new Date(this.modelReserva.fecha_llegada);
      llegada.setDate(llegada.getDate());

      const diferencia = llegada.getTime() - inicio.getTime();
      return Math.ceil(diferencia / (1000 * 3600 * 24));
    },

    actualizarTarifasCamino() {
      if (this.modelReserva.camino != null && this.modelReserva.fecha_inicio != null) {
        const tarifaEncontrada = this.encontrarTarifaPorFecha(this.modelReserva.fecha_inicio);

        if (tarifaEncontrada) {
          this.precio_ind = tarifaEncontrada.precio_ind;
          this.precio_doble = tarifaEncontrada.precio_doble;
          this.precio_triple = tarifaEncontrada.precio_triple;
        }
      }
    },

    encontrarTarifaPorFecha(fechaInicio) {
      if (!this.modelReserva.camino || !this.modelReserva.camino.tarifas || !Array.isArray(this.modelReserva.camino.tarifas)) {
        return null;
      }
      const fechaInicioDate = new Date(fechaInicio);
      const tarifaEncontrada = this.modelReserva.camino.tarifas.find(tarifa => {
        const fechaDesde = new Date(tarifa.fecha_desde);
        const fechaHasta = new Date(tarifa.fecha_hasta);
        return fechaInicioDate >= fechaDesde && fechaInicioDate <= fechaHasta;
      });
      return tarifaEncontrada || null;
    },

    normalizarFechaSinHora(fecha) {
      if (!fecha) return null;

      const date = new Date(fecha);
      if (Number.isNaN(date.getTime())) {
        return null;
      }

      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },

    getPorcentajeSuplementoTarifa(tarifa) {
      return Number(tarifa?.suplemento || 0);
    },

    tarifaTieneSuplemento(tarifa) {
      return (
        this.getPorcentajeSuplementoTarifa(tarifa) > 0 &&
        Boolean(tarifa?.suplemento_fecha_desde) &&
        Boolean(tarifa?.suplemento_fecha_hasta)
      );
    },

    calcularNochesConSuplemento(tarifa) {
      if (!this.tarifaTieneSuplemento(tarifa) || !this.modelReserva.fecha_inicio || !this.modelReserva.fecha_llegada) {
        return 0;
      }

      const fechaSuplementoDesde = this.normalizarFechaSinHora(tarifa.suplemento_fecha_desde);
      const fechaSuplementoHasta = this.normalizarFechaSinHora(tarifa.suplemento_fecha_hasta);
      const fechaLlegada = this.normalizarFechaSinHora(this.modelReserva.fecha_llegada);
      let fechaActual = this.normalizarFechaSinHora(this.modelReserva.fecha_inicio);

      if (!fechaSuplementoDesde || !fechaSuplementoHasta || !fechaLlegada || !fechaActual) {
        return 0;
      }

      let noches = 0;

      while (fechaActual < fechaLlegada) {
        if (fechaActual >= fechaSuplementoDesde && fechaActual <= fechaSuplementoHasta) {
          noches++;
        }

        fechaActual.setDate(fechaActual.getDate() + 1);
      }

      return noches;
    },

    _calcularCantidadPeregrinos() {
      this.modelReserva.cant_peregrinos =
        this.modelReserva.cant_habitaciones_individuales * 1 +
        this.modelReserva.cant_habitaciones_dobles * 2 +
        this.modelReserva.cant_habitaciones_dobles_matrimoniales * 2 +
        this.modelReserva.cant_habitaciones_triples * 3;
    },

    _actualizarImportePresupuestado() {
      this._calcularCantidadPeregrinos();
      if (this.modelReserva.camino != null) {
        const tarifaActiva = this.encontrarTarifaPorFecha(this.modelReserva.fecha_inicio);
        const porcentajeSuplemento = this.getPorcentajeSuplementoTarifa(tarifaActiva);
        const nochesConSuplemento = this.calcularNochesConSuplemento(tarifaActiva);
        const nochesTotales = this.calcularNochesTotales();
        const factorSuplemento = 1 + (porcentajeSuplemento / 100);

        let importeTotal = 0;
        let descripcion = '';

        if (porcentajeSuplemento <= 0 || nochesConSuplemento === 0) {
          importeTotal = (
            Number((this.modelReserva.cant_habitaciones_individuales * Math.ceil(parseFloat(this.precio_ind))).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_dobles * Math.ceil(parseFloat(this.precio_doble))).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * Math.ceil(parseFloat(this.precio_doble))).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_triples * Math.ceil(parseFloat(this.precio_triple))).toFixed(2))
          );
          this.modelReserva.descripcion_importe_reserva =
            (this.modelReserva.cant_habitaciones_individuales > 0 ?
              `${this.modelReserva.cant_habitaciones_individuales} ${this.modelReserva.language === 'ES' ? 'Ind' : this.modelReserva.language === 'EN' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(this.precio_ind).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * this.precio_ind).toFixed(2)} €<br>` : '') +
            (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.modelReserva.language === 'ES' ? 'Doble (cama matrimonial)' : this.modelReserva.language === 'EN' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(this.precio_doble).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble).toFixed(2)} €<br>` : '') +
            (this.modelReserva.cant_habitaciones_dobles > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles} ${this.modelReserva.language === 'ES' ? 'Doble (2 camas Ind)' : this.modelReserva.language === 'EN' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(this.precio_doble).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * this.precio_doble).toFixed(2)} €<br>` : '') +
            (this.modelReserva.cant_habitaciones_triples > 0 ?
              `${this.modelReserva.cant_habitaciones_triples} ${this.modelReserva.language === 'ES' ? 'Triple' : this.modelReserva.language === 'EN' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(this.precio_triple).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * this.precio_triple).toFixed(2)} €` : '');

          this.modelReserva.descripcion_importe_reserva = this.modelReserva.descripcion_importe_reserva.replace(/<br>/g, '\n').replace(/<b>/g, '').replace(/<\/b>/g, '');
          this.modelReserva.importe_reserva = parseFloat(importeTotal).toFixed(2);

        }

        if (porcentajeSuplemento > 0 && nochesTotales === nochesConSuplemento) {
          const precioIndConSuplemento = Math.ceil(parseFloat(this.precio_ind) * factorSuplemento);
          const precioDobleConSuplemento = Math.ceil(parseFloat(this.precio_doble) * factorSuplemento);
          const precioTripleConSuplemento = Math.ceil(parseFloat(this.precio_triple) * factorSuplemento);

          importeTotal = (
            Number((this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2))
          );

          this.modelReserva.descripcion_importe_reserva =
            (this.modelReserva.cant_habitaciones_individuales > 0 ?
              `${this.modelReserva.cant_habitaciones_individuales} ${this.modelReserva.language === 'ES' ? 'Ind' : this.modelReserva.language === 'EN' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €\n` : '') +
            (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.modelReserva.language === 'ES' ? 'Doble (cama matrimonial)' : this.modelReserva.language === 'EN' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €\n` : '') +
            (this.modelReserva.cant_habitaciones_dobles > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles} ${this.modelReserva.language === 'ES' ? 'Doble (2 camas Ind)' : this.modelReserva.language === 'EN' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €\n` : '') +
            (this.modelReserva.cant_habitaciones_triples > 0 ?
              `${this.modelReserva.cant_habitaciones_triples} ${this.modelReserva.language === 'ES' ? 'Triple' : this.modelReserva.language === 'EN' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €\n` : '');

          this.modelReserva.importe_reserva = parseFloat(importeTotal).toFixed(2);
          this.modelReserva.descripcion_importe_reserva = this.modelReserva.descripcion_importe_reserva.replace(/<br>/g, '\n').replace(/<b>/g, '').replace(/<\/b>/g, '');

        }

        if (porcentajeSuplemento > 0 && nochesTotales > nochesConSuplemento && nochesConSuplemento > 0) {
          const precioIndSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_ind) / nochesTotales);
          const precioDobleSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_doble) / nochesTotales);
          const precioTripleSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_triple) / nochesTotales);

          const precioIndConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_ind) * factorSuplemento) / nochesTotales);
          const precioDobleConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_doble) * factorSuplemento) / nochesTotales);
          const precioTripleConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_triple) * factorSuplemento) / nochesTotales);

          const precioIndConSuplemento = Math.ceil(precioIndSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioIndConSuplementoPorNoche * nochesConSuplemento);
          const precioDobleConSuplemento = Math.ceil(precioDobleSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioDobleConSuplementoPorNoche * nochesConSuplemento);
          const precioTripleConSuplemento = Math.ceil(precioTripleSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioTripleConSuplementoPorNoche * nochesConSuplemento);

          importeTotal = (
            Number((this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)) +
            Number((this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2))
          );
          this.modelReserva.descripcion_importe_reserva =
            (this.modelReserva.cant_habitaciones_individuales > 0 ?
              `${this.modelReserva.cant_habitaciones_individuales} ${this.modelReserva.language === 'ES' ? 'Ind' : this.modelReserva.language === 'EN' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €\n` : '') +
            (this.modelReserva.cant_habitaciones_individuales > 0 ?
              `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioIndSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioIndConSuplementoPorNoche).toFixed(2)} €)\n\n` : '') +

            (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.modelReserva.language === 'ES' ? 'Doble (cama matrimonial)' : this.modelReserva.language === 'EN' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €\n` : '') +
            (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
              `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioDobleSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioDobleConSuplementoPorNoche).toFixed(2)} €)\n\n` : '') +

            (this.modelReserva.cant_habitaciones_dobles > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles} ${this.modelReserva.language === 'ES' ? 'Doble (2 camas Ind)' : this.modelReserva.language === 'EN' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €\n` : '') +
            (this.modelReserva.cant_habitaciones_dobles > 0 ?
              `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioDobleSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioDobleConSuplementoPorNoche).toFixed(2)} €)\n\n` : '') +

            (this.modelReserva.cant_habitaciones_triples > 0 ?
              `${this.modelReserva.cant_habitaciones_triples} ${this.modelReserva.language === 'ES' ? 'Triple' : this.modelReserva.language === 'EN' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €\n` : '') +
            (this.modelReserva.cant_habitaciones_triples > 0 ?
              `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioTripleSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioTripleConSuplementoPorNoche).toFixed(2)} €)\n` : '');

          //  + `<b>(Noches con suplemento: ${nochesConSuplemento} de ${nochesTotales})</b><br>`;

          this.modelReserva.descripcion_importe_reserva =
            (this.modelReserva.cant_habitaciones_individuales > 0 ?
              `${this.modelReserva.cant_habitaciones_individuales} ${this.modelReserva.language === 'ES' ? 'Ind' : this.modelReserva.language === 'EN' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €\n` : '') +

            (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.modelReserva.language === 'ES' ? 'Doble (cama matrimonial)' : this.modelReserva.language === 'EN' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €\n` : '') +

            (this.modelReserva.cant_habitaciones_dobles > 0 ?
              `${this.modelReserva.cant_habitaciones_dobles} ${this.modelReserva.language === 'ES' ? 'Doble (2 camas Ind)' : this.modelReserva.language === 'EN' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €\n` : '') +

            (this.modelReserva.cant_habitaciones_triples > 0 ?
              `${this.modelReserva.cant_habitaciones_triples} ${this.modelReserva.language === 'ES' ? 'Triple' : this.modelReserva.language === 'EN' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €\n` : '');

          this.modelReserva.descripcion_importe_reserva = this.modelReserva.descripcion_importe_reserva.replace(/<br>/g, '\n');

          this.modelReserva.importe_reserva = parseFloat(importeTotal).toFixed(2);
        }
      }

    },

    /* _actualizarImportePresupuestado22() {
         if (this.modelReserva.camino != null) {
           let nochesJulioAgosto = this.calcularNochesJulioAgosto();
           if (this.modelReserva.camino.suplemento != null && this.modelReserva.camino.suplemento > 0 && nochesJulioAgosto > 0) {
 
             let nochesTotales = this.calcularNochesTotales();
 
             let precioSinSuplemento = (this.modelReserva.cant_habitaciones_individuales * this.modelReserva.camino.precio_ind +
               this.modelReserva.cant_habitaciones_dobles * this.modelReserva.camino.precio_doble +
               this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.modelReserva.camino.precio_doble +
               this.modelReserva.cant_habitaciones_triples * this.modelReserva.camino.precio_triple);
             let precioSinSuplementoPorDia = (precioSinSuplemento / nochesTotales).toFixed(2);
 
             let precioConSuplemento = precioSinSuplemento + (precioSinSuplemento * this.modelReserva.camino.suplemento / 100);
             let precioConSuplementoPorDia = (precioConSuplemento / nochesTotales).toFixed(2);
 
             let importeTotalSinSuplemento = (precioSinSuplementoPorDia * (nochesTotales - nochesJulioAgosto)).toFixed(2);
             let importeTotalConSuplemento = (precioConSuplementoPorDia * nochesJulioAgosto).toFixed(2);
 
             let importeTotal = (parseFloat(importeTotalSinSuplemento) + parseFloat(importeTotalConSuplemento)).toFixed(2);
 
 
             this.modelReserva.descripcion_importe_presupuestado = 'Importe desglosado por días: \n';
             this.modelReserva.descripcion_importe_presupuestado += 'Noches sin suplemento: ' + (nochesTotales - nochesJulioAgosto) + '\n';
             this.modelReserva.descripcion_importe_presupuestado += 'Noches con suplemento: ' + nochesJulioAgosto + '\n\n';
 
             this.modelReserva.descripcion_importe_presupuestado += 'Precio sin suplemento: ' + precioSinSuplemento + ' €\n';
             this.modelReserva.descripcion_importe_presupuestado += 'Precio con suplemento: ' + precioConSuplemento + ' €\n';
             this.modelReserva.descripcion_importe_presupuestado += 'Precio sin suplemento por día: (' + precioSinSuplemento + ' € / ' + nochesTotales + ' noches) = ' + precioSinSuplementoPorDia + ' €\n';
             this.modelReserva.descripcion_importe_presupuestado += 'Precio con suplemento por día: (' + precioConSuplemento + ' € / ' + nochesTotales + ' noches) = ' + precioConSuplementoPorDia + ' €\n\n';
 
             this.modelReserva.descripcion_importe_presupuestado += 'Importe total sin suplemento: (' + precioSinSuplementoPorDia + ' € x ' + (nochesTotales - nochesJulioAgosto) + ' noches) = ' + importeTotalSinSuplemento + ' €\n';
             this.modelReserva.descripcion_importe_presupuestado += 'Importe total con suplemento: (' + precioConSuplementoPorDia + ' € x ' + nochesJulioAgosto + ' noches) = ' + importeTotalConSuplemento + ' €\n\n';
             this.modelReserva.descripcion_importe_presupuestado += 'Importe total: (' + importeTotalSinSuplemento + ' € + ' + importeTotalConSuplemento + ' €) = ' + importeTotal + ' €\n';
 
             this.modelReserva.importe_presupuestado = Math.round(parseFloat(importeTotal));
 
           } else {
             this.modelReserva.importe_presupuestado = this.modelReserva.cant_habitaciones_individuales * this.modelReserva.camino.precio_ind +
               this.modelReserva.cant_habitaciones_dobles * this.modelReserva.camino.precio_doble +
               this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.modelReserva.camino.precio_doble +
               this.modelReserva.cant_habitaciones_triples * this.modelReserva.camino.precio_triple;
 
             this.modelReserva.descripcion_importe_presupuestado = 'Importe presupuestado para: \n';
             if (this.modelReserva.cant_habitaciones_individuales > 0) {
               this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.cant_habitaciones_individuales + ' Ind x ' + this.modelReserva.camino.precio_ind + ' € = ' + this.modelReserva.cant_habitaciones_individuales * this.modelReserva.camino.precio_ind + ' €\n';
             }
             if (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0) {
               this.modelReserva.descripcion_importe_presupuestado += (this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) + ' Doble x ' + this.modelReserva.camino.precio_doble + ' € = ' + (this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) * this.modelReserva.camino.precio_doble + ' €\n';
             }
             if (this.modelReserva.cant_habitaciones_triples > 0) {
               this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.cant_habitaciones_triples + ' Triple x ' + this.modelReserva.camino.precio_triple + ' € = ' + this.modelReserva.cant_habitaciones_triples * this.modelReserva.camino.precio_triple + ' €\n';
             }
           }
         }
       
     },*/

    /* getCantidadNochesExtras() {
       return this.modelReserva.servicios.filter(servicio =>
         servicio.titulo === "Noche extra"
       ).length;
     },*/

    _changeFechaInicio() {
      if (this.modelReserva.camino != null && this.modelReserva.etapas.length > 0) {
        this.modelReserva.fecha_llegada = this._addDaysUTC(this.modelReserva.fecha_inicio, this.modelReserva.etapas.length - 1);
        this._actualizarFechasEtapas();

      }
      if (this.accion == "crear" && this.modelReserva.camino != null && this.modelReserva.camino.etapas.length > 0) {
        let dias = this.modelReserva.camino.etapas.length;
        if (this.modelReserva.camino.con_etapa_final == 0) {
          dias -= 1;
        }
        this.modelReserva.fecha_llegada = this._addDaysUTC(this.modelReserva.fecha_inicio, dias);
      }
      this.actualizarTarifasCamino();
      this._actualizarImportePresupuestado();
    },

    _changeFechaLlegada() {
      if (this.modelReserva.camino != null && this.modelReserva.etapas.length > 0) {
        this.modelReserva.fecha_inicio = this._addDaysUTC(this.modelReserva.fecha_llegada, -(this.modelReserva.etapas.length - 1));



        this._actualizarFechasEtapas();
      }
      if (this.accion == "crear" && this.modelReserva.camino != null && this.modelReserva.camino.etapas.length > 0) {
        let dias = this.modelReserva.camino.etapas.length;
        if (this.modelReserva.camino.con_etapa_final == 0) {
          dias -= 1;
        }
        this.modelReserva.fecha_llegada = this._addDaysUTC(this.modelReserva.fecha_inicio, dias);
      }

      this.actualizarTarifasCamino();
      this._actualizarImportePresupuestado();
    },

    _addDaysUTC(fechaStr, dias) {
      if (!fechaStr) return '';
      const [year, month, day] = fechaStr.split('-').map(Number);
      const date = new Date(Date.UTC(year, month - 1, day));
      date.setUTCDate(date.getUTCDate() + dias);
      return date.toISOString().slice(0, 10);
    },

    _actualizarFechasEtapas() {
      if (this.modelReserva.camino != null && this.modelReserva.fecha_inicio != null && this.modelReserva.fecha_llegada != null) {
        let fecha = new Date(this.modelReserva.fecha_inicio);
        for (let i = 0; i < this.modelReserva.etapas.length; i++) {
          this.modelReserva.etapas[i].pivot.fecha = new Date(fecha).toISOString().slice(0, 10);
          fecha.setDate(fecha.getDate() + 1);
        }
      }
    },

    _setCantidadPeregrinos(accion) {
      if (accion == "-") {
        this.modelReserva.cant_peregrinos > 0
          ? (this.modelReserva.cant_peregrinos =
            this.modelReserva.cant_peregrinos - 1)
          : (this.modelReserva.cant_peregrinos = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_peregrinos =
          this.modelReserva.cant_peregrinos + 1;
      }
    },

    _setCantidadHabitacionesIndividuales(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_individuales > 0
          ? this.modelReserva.cant_habitaciones_individuales--
          : this.modelReserva.cant_habitaciones_individuales = 0;
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_individuales++;
      }
      this._actualizarImportePresupuestado();
    },

    _setCantidadHabitacionesDobles(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_dobles > 0
          ? this.modelReserva.cant_habitaciones_dobles--
          : this.modelReserva.cant_habitaciones_dobles = 0;
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_dobles++;
      }
      this._actualizarImportePresupuestado();
    },

    _setCantidadHabitacionesDoblesMatrimonio(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0
          ? this.modelReserva.cant_habitaciones_dobles_matrimoniales--
          : this.modelReserva.cant_habitaciones_dobles_matrimoniales = 0;
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_dobles_matrimoniales++;
      }
      this._actualizarImportePresupuestado();
    },

    _setCantidadHabitacionesTriples(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_triples > 0
          ? this.modelReserva.cant_habitaciones_triples--
          : this.modelReserva.cant_habitaciones_triples = 0;
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_triples++;
      }
      this._actualizarImportePresupuestado();
    },

    _getColorEstadoEtapa(etapa) {
      let res = "#FFFFFF";
      if (etapa?.inicio_punto_id == etapa?.final_punto_id) {
        const est = this.estados.findIndex(r => r.id === this.getEstadoIdConfirmada);
        if (est != -1) {
          return this.estados[est].color;
        }
      }

      if (this.estados && this.estados.length > 0 && etapa?.pivot?.estado_id) {
        const est = this.estados.findIndex(r => r.id === etapa?.pivot?.estado_id);
        if (est != -1) {
          return this.estados[est].color;
        }
      }

      return res;

      /* const allCanceled = etapa.proveedores.every(prov => prov.estado_id === this.getEstadoIdEnProceso);
        if (allCanceled) {
          const est = this.estados.findIndex(r => r.id === this.getEstadoIdEnProceso);
          return this.estados[est].color;
        }
  
        const someCompleted = etapa.proveedores.some(prov => prov.estado_id === this.getEstadoIdConfirmada);
        if (someCompleted) {
          const est = this.estados.findIndex(r => r.id === this.getEstadoIdConfirmada);
          return this.estados[est].color;
        }
  
        const isPending = etapa.proveedores.some(prov => prov.estado_id === this.getEstadoIdEnProceso);
        if (isPending) {
          const est = this.estados.findIndex(r => r.id === this.getEstadoIdEnProceso);
          return this.estados[est].color;
        }*/


    },

    _colorEstadoAlojamiento(aloj) {
      if (this.estados && this.estados.length > 0) {
        const est = this.estados.findIndex(e => e.id === aloj.estado_id);
        return this.estados[est].color;
      }
      return "#FFFFFF";
    },

    _setCantidadHabitacionesCuadruples(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_cuadruples > 0
          ? (this.modelReserva.cant_habitaciones_cuadruples =
            this.modelReserva.cant_habitaciones_cuadruples - 1)
          : (this.modelReserva.cant_habitaciones_cuadruples = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_cuadruples =
          this.modelReserva.cant_habitaciones_cuadruples + 1;
      }
    },

    async actualizarNotaEtapa(etapa) {
      const prepagoDias = parseInt(etapa?.pivot?.prepago_dias, 10);
      const res = await this.updateNotaExtraEtapa([
        this.access_token,
        this.modelReserva.id,
        etapa.pivot.id,
        etapa.pivot.nota_extra,
        etapa.pivot.modalidad_pago,
        Number.isNaN(prepagoDias) ? null : prepagoDias,
        etapa.pivot.prepago_tipo_dias,
        etapa.pivot.prepago_fecha_aviso,
      ]);
      if (res && res.id == this.modelReserva.id) {
        this.modelReserva = res;
        this.sincronizarProveedoresEtapa();
      }
    },

    async actualizarTarifasEtapa(etapa) {
      if (etapa.proveedor && etapa.proveedor.id) {
        const res = await this.updateTarifasEtapa([this.access_token, this.modelReserva.id, etapa.pivot.id, etapa.pivot.tarifa_ind, etapa.pivot.tarifa_doble, etapa.pivot.tarifa_triple]);
        if (res && res.id == this.modelReserva.id) {
          this.modelReserva = res;
          this.sincronizarProveedoresEtapa();
        }
      } else {
        etapa.pivot.tarifa_ind = 0;
        etapa.pivot.tarifa_doble = 0;
        etapa.pivot.tarifa_triple = 0;
      }
    },

    descripcionCosteEtapa(etapa) {
      return descripcionCosteEtapaHelper(this.modelReserva, etapa);
    },

    getCosteEtapa(etapa) {
      return getCosteEtapaHelper(this.modelReserva, etapa);
    },


    async _guardarReserva() {
      this.loading = true;
      this.modelReserva.importe_presupuestado = this.getImporteTotal;
      if (this.accion == "crear") {
        this._aplicarContextoCreacionDesdeRuta();
        var res = await this.crearReserva([
          this.access_token,
          this.modelReserva,
        ]);
        if (res && res.id > 0) {
          this.inputId = res.id;
          if (this.inputId > 0) {
            this.accion = "editar";
            this._getReserva();
          }
          this.$router.push({
            path: "/Presupuestos/" + res.id,
            query: {
              ...this.$route.query,
            },
          });
        }

        // this._cerrarVentana();
        //await this.getReservas([this.access_token, false]);
      } else if (this.accion == "editar") {
        var res = await this.updateReserva([
          this.access_token,
          this.modelReserva,
        ]);

        if (res && res.id == this.modelReserva.id) {
          this.modelReserva = res;
          this.sincronizarProveedoresEtapa();
        }

        //this._cerrarVentana();
      }
      this.loading = false;
    },



    _editarEtapa(item) {
      this.setEtapaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.etapaSelec));
      this.modelEtapa = temp;
      this.accionEtapa = 'editar';
      this.dialogFormularioEtapa = true;
    },

    _deleteEtapa(etapa) {
    },

    _buscarPorTelefono(value) {
      const params = {};
      params.telefono = value;
      this._buscarCliente(params);
    },

    _buscarPorNombre(value) {
      const params = {};
      params.nombre = value;
      this._buscarCliente(params);
    },

    _buscarPorEmail(value) {
      const params = {};
      params.email = value;
      this._buscarCliente(params);
    },

    async _buscarCliente(params) {
      if (this.modelReserva.id == null) {
        await this.getClientes([this.access_token, params, false]);
        if (this.clientes && this.clientes.length) {
          this.dialogBusquedaClientes = true;
        } else {
        }
      }
    },

    _selecCliente(client) {
      this.modelReserva.cliente = client;
      this.dialogBusquedaClientes = false;
    },

    async _solicitarDisponibilidad(etapa) {

      if (etapa.pivot.reserva_id && etapa.pivot.etapa_id && etapa.pivot.proveedor_id && !this.enviandoDisponibilidad) {
        this.enviandoDisponibilidad = true;
        const res = await this.solicitarDisponibilidad([this.access_token, etapa.pivot.reserva_id, etapa.pivot.etapa_id, etapa.pivot.proveedor_id]);
        if (res && res.id == this.modelReserva.id) {
          this.modelReserva.etapas = res.etapas;
          this.sincronizarProveedoresEtapa();
        }
        this.enviandoDisponibilidad = false;
      }
    },

    validarFecha(fecha) {
      if (!fecha) return true; // Permitir campo vacío si no es requerido

      // Validar formato YYYY-MM-DD
      const formatoFecha = /^\d{4}-\d{2}-\d{2}$/;
      if (!formatoFecha.test(fecha)) {
        return 'Formato debe ser YYYY-MM-DD';
      }

      // Validar que sea una fecha válida
      const fechaObj = new Date(fecha);
      if (isNaN(fechaObj.getTime())) {
        return 'Fecha no válida';
      }

      // Validar rango de fechas (igual que en el date-picker)
      const fechaMin = new Date('1900-01-01');
      const fechaMax = new Date();

      if (fechaObj < fechaMin || fechaObj > fechaMax) {
        return 'Fecha debe estar entre 1900-01-01 y hoy';
      }

      return true;
    },

    validarYFormatearFecha() {
      if (!this.pasajeroNuevo.fecha_nacimiento) return;

      let fecha = this.pasajeroNuevo.fecha_nacimiento.trim();

      // Intentar formatear diferentes formatos de entrada
      // Formato DD/MM/YYYY o DD-MM-YYYY
      const formatoDDMMYYYY = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/;
      const matchDDMMYYYY = fecha.match(formatoDDMMYYYY);

      if (matchDDMMYYYY) {
        const dia = matchDDMMYYYY[1].padStart(2, '0');
        const mes = matchDDMMYYYY[2].padStart(2, '0');
        const año = matchDDMMYYYY[3];
        fecha = `${año}-${mes}-${dia}`;
      }

      // Formato DD/MM/YY
      const formatoDDMMYY = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2})$/;
      const matchDDMMYY = fecha.match(formatoDDMMYY);

      if (matchDDMMYY) {
        const dia = matchDDMMYY[1].padStart(2, '0');
        const mes = matchDDMMYY[2].padStart(2, '0');
        let año = parseInt(matchDDMMYY[3]);
        // Asumir que años 00-30 son 2000-2030, y 31-99 son 1931-1999
        año = año <= 30 ? 2000 + año : 1900 + año;
        fecha = `${año}-${mes}-${dia}`;
      }

      this.pasajeroNuevo.fecha_nacimiento = fecha;
    },
  },
};
</script>

<style scoped>
.custom-tab {
  background-color: rgb(220, 220, 220) !important;
  border: 2px solid rgb(107, 107, 107) !important;

  border-radius: 4px !important;
  margin: 0 2px !important;
  transition: all 0.3s ease !important;
}

.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}


.active-tab {
  background-color: rgb(177, 216, 252) !important;
  color: #000 !important;
  font-weight: bold !important;
}

.v-tabs-slider {
  display: none !important;

}


.tooltip-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.4;
  font-size: 0.875rem;
}

.historial-correo-texto {
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  white-space: normal;
  line-height: 1.5;
  font-size: 0.95rem;
}

.v-data-table>>>.col-compact {
  width: 1%;
  white-space: nowrap;
  padding-left: 4px;
  padding-right: 4px;
}

.historial-descripcion>>>.historial-keyword-cancelar {
  font-weight: 700;
  color: #FF0000;
}

.historial-descripcion>>>.historial-keyword-confirmar {
  font-weight: 700;
  color: #2e7d32;
}

.historial-descripcion>>>.historial-keyword-presupuestada {
  font-weight: 700;
  color: #90D5FF;
}

.historial-descripcion>>>.historial-keyword-en-proceso {
  font-weight: 700;
  color: #FFB5C0;
}

.historial-descripcion>>>.historial-keyword-confirmacion-final {
  font-weight: 700;
  color: #FFA800;
}
</style>
